//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.5.0.0 (NJsonSchema v11.4.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { IApiConfig } from './ApiConfig';
export class ApiClientBase {
    protected readonly config: IApiConfig;

    protected constructor(config: IApiConfig) {
        this.config = config;
    }

    protected transformOptions = async (options: RequestInit): Promise<RequestInit> => {
        const headers = new Headers(options.headers);
        if (typeof FormData !== 'undefined' && options.body instanceof FormData) {
            // The browser must add the multipart boundary to this header.
            headers.delete('Content-Type');
        }
        headers.set('Authorization', await this.config.getAuthorization());
        options.headers = headers;
        // See https://developer.mozilla.org/en-US/docs/Web/API/fetch#parameters
        // We want the cookies to be sent with request (as long as the target domain matches) - VendorId cookie
        options.credentials = 'include';
        return options;
    };
}

export class AdminClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets all tenants with pagination and filtering.
     * @param code (optional) 
     * @param name (optional) 
     * @param isActiveOnly (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @return OK
     */
    getTenants(code: string | undefined, name: string | undefined, isActiveOnly: boolean | undefined, pageIndex: number | undefined, pageSize: number | undefined, sortBy: string | undefined, sortAscending: boolean | undefined, signal?: AbortSignal): Promise<TenantSummaryModelPagingResultModel> {
        let url_ = this.baseUrl + "/Admin/Tenants?";
        if (code === null)
            throw new globalThis.Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (isActiveOnly === null)
            throw new globalThis.Error("The parameter 'isActiveOnly' cannot be null.");
        else if (isActiveOnly !== undefined)
            url_ += "isActiveOnly=" + encodeURIComponent("" + isActiveOnly) + "&";
        if (pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTenants(_response);
        });
    }

    protected processGetTenants(response: Response): Promise<TenantSummaryModelPagingResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TenantSummaryModelPagingResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantSummaryModelPagingResultModel>(null as any);
    }

    /**
     * Creates a new tenant.
     * @param body (optional) 
     * @return OK
     */
    createTenant(body: CreateTenantRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Admin/Tenants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateTenant(_response);
        });
    }

    protected processCreateTenant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets a tenant by ID.
     * @return OK
     */
    getTenantById(id: string, signal?: AbortSignal): Promise<TenantModel> {
        let url_ = this.baseUrl + "/Admin/Tenants/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTenantById(_response);
        });
    }

    protected processGetTenantById(response: Response): Promise<TenantModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TenantModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantModel>(null as any);
    }

    /**
     * Updates an existing tenant.
     * @param body (optional) 
     * @return OK
     */
    updateTenant(id: string, body: UpdateTenantRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Admin/Tenants/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTenant(_response);
        });
    }

    protected processUpdateTenant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Deletes a tenant.
     * @return OK
     */
    deleteTenant(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Admin/Tenants/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteTenant(_response);
        });
    }

    protected processDeleteTenant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets a tenant by code.
     * @return OK
     */
    getTenantByCode(code: string, signal?: AbortSignal): Promise<TenantModel> {
        let url_ = this.baseUrl + "/Admin/Tenants/by-code/{code}";
        if (code === undefined || code === null)
            throw new globalThis.Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTenantByCode(_response);
        });
    }

    protected processGetTenantByCode(response: Response): Promise<TenantModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TenantModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantModel>(null as any);
    }
}

export class AgentClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param name (optional) 
     * @return OK
     */
    getAgents(pageIndex: number | undefined, pageSize: number | undefined, name: string | undefined, signal?: AbortSignal): Promise<AgentModelPagingResultModel> {
        let url_ = this.baseUrl + "/Agent?";
        if (pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAgents(_response);
        });
    }

    protected processGetAgents(response: Response): Promise<AgentModelPagingResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentModelPagingResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentModelPagingResultModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createAgent(body: CreateAgentRequest | undefined, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/Agent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAgent(_response);
        });
    }

    protected processCreateAgent(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getAgent(agentId: string, signal?: AbortSignal): Promise<AgentModel> {
        let url_ = this.baseUrl + "/Agent/{agentId}";
        if (agentId === undefined || agentId === null)
            throw new globalThis.Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAgent(_response);
        });
    }

    protected processGetAgent(response: Response): Promise<AgentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateAgent(agentId: string, body: UpdateAgentRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Agent/{agentId}";
        if (agentId === undefined || agentId === null)
            throw new globalThis.Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAgent(_response);
        });
    }

    protected processUpdateAgent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    deleteAgent(agentId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Agent/{agentId}";
        if (agentId === undefined || agentId === null)
            throw new globalThis.Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAgent(_response);
        });
    }

    protected processDeleteAgent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAgentsByIds(body: AgentIdsRequest | undefined, signal?: AbortSignal): Promise<AgentModel[]> {
        let url_ = this.baseUrl + "/Agent/ByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAgentsByIds(_response);
        });
    }

    protected processGetAgentsByIds(response: Response): Promise<AgentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentModel[]>(null as any);
    }
}

export class ApiKeyClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    search(body: SearchApiKeyRequest | undefined, signal?: AbortSignal): Promise<ApiKeyModelPagingResultModel> {
        let url_ = this.baseUrl + "/ApiKey/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<ApiKeyModelPagingResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiKeyModelPagingResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiKeyModelPagingResultModel>(null as any);
    }

    /**
     * @return OK
     */
    getById(id: string, signal?: AbortSignal): Promise<ApiKeyModel> {
        let url_ = this.baseUrl + "/ApiKey/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<ApiKeyModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiKeyModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiKeyModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(id: string, body: UpdateApiKeyRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/ApiKey/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    delete(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/ApiKey/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateApiKeyCommand | undefined, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/ApiKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setDependencies(id: string, body: SetApiKeyDependenciesRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/ApiKey/{id}/Dependencies";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetDependencies(_response);
        });
    }

    protected processSetDependencies(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AppMediaClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param changeSetId (optional) 
     * @param body (optional) 
     * @param file (optional) 
     * @return OK
     */
    upload(definitionId: string, changeSetId: string | undefined, body: Body | undefined, file: FileParameter | null | undefined, signal?: AbortSignal): Promise<FileViewModel> {
        let url_ = this.baseUrl + "/AppMedia/{definitionId}?";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        if (changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' cannot be null.");
        else if (changeSetId !== undefined)
            url_ += "changeSetId=" + encodeURIComponent("" + changeSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "multipart/form-data",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<FileViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileViewModel>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @param changeSetId (optional) 
     * @return OK
     */
    get(definitionId: string, resourceId: string, fileId: string | undefined, changeSetId: string | undefined, signal?: AbortSignal): Promise<FileViewModel> {
        let url_ = this.baseUrl + "/AppMedia/{definitionId}/{resourceId}?";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        if (resourceId === undefined || resourceId === null)
            throw new globalThis.Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        if (fileId === null)
            throw new globalThis.Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        if (changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' cannot be null.");
        else if (changeSetId !== undefined)
            url_ += "changeSetId=" + encodeURIComponent("" + changeSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<FileViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileViewModel>(null as any);
    }
}

export class AssetClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    get(source: string, assetId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Asset/{source}/{assetId}";
        if (source === undefined || source === null)
            throw new globalThis.Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (assetId === undefined || assetId === null)
            throw new globalThis.Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AuditClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param pageSize (optional) 
     * @param continuationToken (optional) 
     * @return OK
     */
    browse(pageSize: number | undefined, continuationToken: string | undefined, signal?: AbortSignal): Promise<AuditPageModel> {
        let url_ = this.baseUrl + "/Audit?";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (continuationToken === null)
            throw new globalThis.Error("The parameter 'continuationToken' cannot be null.");
        else if (continuationToken !== undefined)
            url_ += "continuationToken=" + encodeURIComponent("" + continuationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBrowse(_response);
        });
    }

    protected processBrowse(response: Response): Promise<AuditPageModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuditPageModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuditPageModel>(null as any);
    }

    /**
     * @return OK
     */
    getById(id: string, signal?: AbortSignal): Promise<AuditRecordModel> {
        let url_ = this.baseUrl + "/Audit/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<AuditRecordModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuditRecordModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuditRecordModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    search(body: SearchAuditRequest | undefined, signal?: AbortSignal): Promise<AuditPageModel> {
        let url_ = this.baseUrl + "/Audit/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<AuditPageModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuditPageModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuditPageModel>(null as any);
    }

    /**
     * @param prefix (optional) 
     * @return OK
     */
    getFilterValues(field: string, prefix: string | undefined, signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/Audit/FilterValues?";
        if (field === undefined || field === null)
            throw new globalThis.Error("The parameter 'field' must be defined and cannot be null.");
        else
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        if (prefix === null)
            throw new globalThis.Error("The parameter 'prefix' cannot be null.");
        else if (prefix !== undefined)
            url_ += "prefix=" + encodeURIComponent("" + prefix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFilterValues(_response);
        });
    }

    protected processGetFilterValues(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class AuthoringResourceClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param scopeType (optional) 
     * @param scopeId (optional) 
     * @param includeDisabled (optional) 
     * @param includeInherited (optional) 
     * @return OK
     */
    list(scopeType: AuthoringResourceScopeType | undefined, scopeId: string | undefined, includeDisabled: boolean | undefined, includeInherited: boolean | undefined, signal?: AbortSignal): Promise<AuthoringResourceSummaryModel[]> {
        let url_ = this.baseUrl + "/AuthoringResource?";
        if (scopeType === null)
            throw new globalThis.Error("The parameter 'scopeType' cannot be null.");
        else if (scopeType !== undefined)
            url_ += "scopeType=" + encodeURIComponent("" + scopeType) + "&";
        if (scopeId === null)
            throw new globalThis.Error("The parameter 'scopeId' cannot be null.");
        else if (scopeId !== undefined)
            url_ += "scopeId=" + encodeURIComponent("" + scopeId) + "&";
        if (includeDisabled === null)
            throw new globalThis.Error("The parameter 'includeDisabled' cannot be null.");
        else if (includeDisabled !== undefined)
            url_ += "includeDisabled=" + encodeURIComponent("" + includeDisabled) + "&";
        if (includeInherited === null)
            throw new globalThis.Error("The parameter 'includeInherited' cannot be null.");
        else if (includeInherited !== undefined)
            url_ += "includeInherited=" + encodeURIComponent("" + includeInherited) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<AuthoringResourceSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthoringResourceSummaryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthoringResourceSummaryModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: SaveAuthoringResourceModel | undefined, signal?: AbortSignal): Promise<AuthoringResourceModel> {
        let url_ = this.baseUrl + "/AuthoringResource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: Response): Promise<AuthoringResourceModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthoringResourceModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthoringResourceModel>(null as any);
    }

    /**
     * @return OK
     */
    get(id: string, signal?: AbortSignal): Promise<AuthoringResourceModel> {
        let url_ = this.baseUrl + "/AuthoringResource/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<AuthoringResourceModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthoringResourceModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthoringResourceModel>(null as any);
    }

    /**
     * @return OK
     */
    delete(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/AuthoringResource/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ChangeSetClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Search ChangeSets with paging support.
     * @param name (optional) 
     * @param isActiveOnly (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @return OK
     */
    search(name: string | undefined, isActiveOnly: boolean | undefined, pageIndex: number | undefined, pageSize: number | undefined, sortBy: string | undefined, sortAscending: boolean | undefined, signal?: AbortSignal): Promise<ChangeSetViewModelPagingResultModel> {
        let url_ = this.baseUrl + "/ChangeSet?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (isActiveOnly === null)
            throw new globalThis.Error("The parameter 'isActiveOnly' cannot be null.");
        else if (isActiveOnly !== undefined)
            url_ += "isActiveOnly=" + encodeURIComponent("" + isActiveOnly) + "&";
        if (pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<ChangeSetViewModelPagingResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChangeSetViewModelPagingResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeSetViewModelPagingResultModel>(null as any);
    }

    /**
     * Create a new ChangeSet.
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateChangeSetRequest | undefined, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/ChangeSet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update an existing ChangeSet.
     * @param body (optional) 
     * @return OK
     */
    update(id: string, body: UpdateChangeSetRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/ChangeSet/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get a ChangeSet by ID.
     * @return OK
     */
    getById(id: string, signal?: AbortSignal): Promise<ChangeSetViewModel> {
        let url_ = this.baseUrl + "/ChangeSet/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<ChangeSetViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChangeSetViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeSetViewModel>(null as any);
    }
}

export class ClientClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    search(body: SearchClientRequest | undefined, signal?: AbortSignal): Promise<ClientModelPagingResultModel> {
        let url_ = this.baseUrl + "/Client/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<ClientModelPagingResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientModelPagingResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientModelPagingResultModel>(null as any);
    }

    /**
     * @return OK
     */
    getById(id: string, signal?: AbortSignal): Promise<ClientModel> {
        let url_ = this.baseUrl + "/Client/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<ClientModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(id: string, body: UpdateClientRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Client/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    delete(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Client/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateClientCommand | undefined, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/Client";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getRedirectUrlPlaceholders(id: string, environmentId: string, signal?: AbortSignal): Promise<RedirectUrlPlaceholderMetadataModel> {
        let url_ = this.baseUrl + "/Client/{id}/Environment/{environmentId}/RedirectUrlPlaceholders";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (environmentId === undefined || environmentId === null)
            throw new globalThis.Error("The parameter 'environmentId' must be defined.");
        url_ = url_.replace("{environmentId}", encodeURIComponent("" + environmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRedirectUrlPlaceholders(_response);
        });
    }

    protected processGetRedirectUrlPlaceholders(response: Response): Promise<RedirectUrlPlaceholderMetadataModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RedirectUrlPlaceholderMetadataModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RedirectUrlPlaceholderMetadataModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setDependencies(id: string, body: SetClientDependenciesRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Client/{id}/Dependencies";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetDependencies(_response);
        });
    }

    protected processSetDependencies(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CodeGenResourceClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param scopeType (optional) 
     * @param scopeId (optional) 
     * @param includeDisabled (optional) 
     * @return OK
     */
    getResources(scopeType: CodeGenResourceScopeType | undefined, scopeId: string | undefined, includeDisabled: boolean | undefined, signal?: AbortSignal): Promise<CodeGenResourceSummaryModel[]> {
        let url_ = this.baseUrl + "/CodeGenResource?";
        if (scopeType === null)
            throw new globalThis.Error("The parameter 'scopeType' cannot be null.");
        else if (scopeType !== undefined)
            url_ += "scopeType=" + encodeURIComponent("" + scopeType) + "&";
        if (scopeId === null)
            throw new globalThis.Error("The parameter 'scopeId' cannot be null.");
        else if (scopeId !== undefined)
            url_ += "scopeId=" + encodeURIComponent("" + scopeId) + "&";
        if (includeDisabled === null)
            throw new globalThis.Error("The parameter 'includeDisabled' cannot be null.");
        else if (includeDisabled !== undefined)
            url_ += "includeDisabled=" + encodeURIComponent("" + includeDisabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResources(_response);
        });
    }

    protected processGetResources(response: Response): Promise<CodeGenResourceSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeGenResourceSummaryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CodeGenResourceSummaryModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    upsert(body: UpsertCodeGenResourceModel | undefined, signal?: AbortSignal): Promise<CodeGenResourceModel> {
        let url_ = this.baseUrl + "/CodeGenResource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsert(_response);
        });
    }

    protected processUpsert(response: Response): Promise<CodeGenResourceModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeGenResourceModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CodeGenResourceModel>(null as any);
    }

    /**
     * @return OK
     */
    getEffectiveResources(contextId: string, signal?: AbortSignal): Promise<CodeGenResourceSummaryModel[]> {
        let url_ = this.baseUrl + "/CodeGenResource/effective/{contextId}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEffectiveResources(_response);
        });
    }

    protected processGetEffectiveResources(response: Response): Promise<CodeGenResourceSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeGenResourceSummaryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CodeGenResourceSummaryModel[]>(null as any);
    }

    /**
     * @return OK
     */
    getById(id: string, signal?: AbortSignal): Promise<CodeGenResourceModel> {
        let url_ = this.baseUrl + "/CodeGenResource/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<CodeGenResourceModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeGenResourceModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CodeGenResourceModel>(null as any);
    }

    /**
     * @return OK
     */
    delete(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/CodeGenResource/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CodeStoreClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    deleteCodeFile(codebaseId: string, fileName: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/CodeStore/{codebaseId}/{fileName}";
        if (codebaseId === undefined || codebaseId === null)
            throw new globalThis.Error("The parameter 'codebaseId' must be defined.");
        url_ = url_.replace("{codebaseId}", encodeURIComponent("" + codebaseId));
        if (fileName === undefined || fileName === null)
            throw new globalThis.Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCodeFile(_response);
        });
    }

    protected processDeleteCodeFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ContentClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getById(id: string, signal?: AbortSignal): Promise<StringTemplateViewModel> {
        let url_ = this.baseUrl + "/Content/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<StringTemplateViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringTemplateViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringTemplateViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(id: string, body: UpdateStringTemplateRequest | undefined, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/Content/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    delete(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Content/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param changeSetId (optional) 
     * @param category (optional) 
     * @param searchText (optional) 
     * @param folderId (optional) 
     * @return OK
     */
    search(pageIndex: number | undefined, pageSize: number | undefined, sortBy: string | undefined, sortAscending: boolean | undefined, changeSetId: string | undefined, category: string | undefined, searchText: string | undefined, folderId: string | undefined, signal?: AbortSignal): Promise<StringTemplateViewModelPagingResultModel> {
        let url_ = this.baseUrl + "/Content?";
        if (pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' cannot be null.");
        else if (changeSetId !== undefined)
            url_ += "changeSetId=" + encodeURIComponent("" + changeSetId) + "&";
        if (category === null)
            throw new globalThis.Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        if (searchText === null)
            throw new globalThis.Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (folderId === null)
            throw new globalThis.Error("The parameter 'folderId' cannot be null.");
        else if (folderId !== undefined)
            url_ += "folderId=" + encodeURIComponent("" + folderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<StringTemplateViewModelPagingResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringTemplateViewModelPagingResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringTemplateViewModelPagingResultModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateStringTemplateRequest | undefined, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/Content";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    searchVersions(templateId: string, pageIndex: number | undefined, pageSize: number | undefined, signal?: AbortSignal): Promise<StringTemplateViewModelPagingResultModel> {
        let url_ = this.baseUrl + "/Content/{templateId}/Versions?";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        if (pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchVersions(_response);
        });
    }

    protected processSearchVersions(response: Response): Promise<StringTemplateViewModelPagingResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringTemplateViewModelPagingResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringTemplateViewModelPagingResultModel>(null as any);
    }
}

export class ContentFolderClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param name (optional) 
     * @return OK
     */
    search(name: string | undefined, signal?: AbortSignal): Promise<TemplateFolderModel[]> {
        let url_ = this.baseUrl + "/ContentFolder?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<TemplateFolderModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TemplateFolderModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateFolderModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateTemplateFolderRequest | undefined, signal?: AbortSignal): Promise<TemplateFolderModel> {
        let url_ = this.baseUrl + "/ContentFolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<TemplateFolderModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TemplateFolderModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateFolderModel>(null as any);
    }

    /**
     * @return OK
     */
    get(id: string, signal?: AbortSignal): Promise<TemplateFolderModel> {
        let url_ = this.baseUrl + "/ContentFolder/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<TemplateFolderModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TemplateFolderModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateFolderModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(id: string, body: UpdateTemplateFolderRequest | undefined, signal?: AbortSignal): Promise<TemplateFolderModel> {
        let url_ = this.baseUrl + "/ContentFolder/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<TemplateFolderModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TemplateFolderModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateFolderModel>(null as any);
    }

    /**
     * @return OK
     */
    delete(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/ContentFolder/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ContextClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getSubDomains(signal?: AbortSignal): Promise<SubDomainContextsModel[]> {
        let url_ = this.baseUrl + "/Context/SubDomains";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSubDomains(_response);
        });
    }

    protected processGetSubDomains(response: Response): Promise<SubDomainContextsModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubDomainContextsModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubDomainContextsModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createSubDomain(body: NewSubDomainModel | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Context/SubDomains";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSubDomain(_response);
        });
    }

    protected processCreateSubDomain(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    deleteSubDomain(subDomainId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Context/SubDomains/{subDomainId}";
        if (subDomainId === undefined || subDomainId === null)
            throw new globalThis.Error("The parameter 'subDomainId' must be defined.");
        url_ = url_.replace("{subDomainId}", encodeURIComponent("" + subDomainId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteSubDomain(_response);
        });
    }

    protected processDeleteSubDomain(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateSubDomainDescription(subDomainId: string, body: UpdateDescriptionModel | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Context/SubDomains/{subDomainId}/Description";
        if (subDomainId === undefined || subDomainId === null)
            throw new globalThis.Error("The parameter 'subDomainId' must be defined.");
        url_ = url_.replace("{subDomainId}", encodeURIComponent("" + subDomainId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSubDomainDescription(_response);
        });
    }

    protected processUpdateSubDomainDescription(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createContext(subDomainId: string, body: NewContextModel | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Context/SubDomains/{subDomainId}/Contexts";
        if (subDomainId === undefined || subDomainId === null)
            throw new globalThis.Error("The parameter 'subDomainId' must be defined.");
        url_ = url_.replace("{subDomainId}", encodeURIComponent("" + subDomainId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateContext(_response);
        });
    }

    protected processCreateContext(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getAllContexts(signal?: AbortSignal): Promise<ContextModel[]> {
        let url_ = this.baseUrl + "/Context";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllContexts(_response);
        });
    }

    protected processGetAllContexts(response: Response): Promise<ContextModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContextModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContextModel[]>(null as any);
    }

    /**
     * @return OK
     */
    delete(contextId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Context/{contextId}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getContextById(contextId: string, signal?: AbortSignal): Promise<ContextModel> {
        let url_ = this.baseUrl + "/Context/{contextId}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetContextById(_response);
        });
    }

    protected processGetContextById(response: Response): Promise<ContextModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContextModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContextModel>(null as any);
    }

    /**
     * @return OK
     */
    getArtifactLayout(contextId: string, signal?: AbortSignal): Promise<ContextArtifactLayoutModel> {
        let url_ = this.baseUrl + "/Context/{contextId}/artifact-layout";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetArtifactLayout(_response);
        });
    }

    protected processGetArtifactLayout(response: Response): Promise<ContextArtifactLayoutModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContextArtifactLayoutModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContextArtifactLayoutModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateArtifactLayout(contextId: string, body: ContextArtifactLayoutModel | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Context/{contextId}/artifact-layout";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateArtifactLayout(_response);
        });
    }

    protected processUpdateArtifactLayout(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param includeCode (optional) 
     * @return OK
     */
    getDesignerSnapshot(contextId: string, includeCode: boolean | undefined, signal?: AbortSignal): Promise<ContextDesignerSnapshotModel> {
        let url_ = this.baseUrl + "/Context/{contextId}/designer-snapshot?";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (includeCode === null)
            throw new globalThis.Error("The parameter 'includeCode' cannot be null.");
        else if (includeCode !== undefined)
            url_ += "includeCode=" + encodeURIComponent("" + includeCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDesignerSnapshot(_response);
        });
    }

    protected processGetDesignerSnapshot(response: Response): Promise<ContextDesignerSnapshotModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContextDesignerSnapshotModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContextDesignerSnapshotModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateContextDescription(contextId: string, body: UpdateDescriptionModel | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Context/{contextId}/Description";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateContextDescription(_response);
        });
    }

    protected processUpdateContextDescription(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    moveContextToSubDomain(contextId: string, subDomainId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Context/{contextId}/SubDomain/{subDomainId}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (subDomainId === undefined || subDomainId === null)
            throw new globalThis.Error("The parameter 'subDomainId' must be defined.");
        url_ = url_.replace("{subDomainId}", encodeURIComponent("" + subDomainId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMoveContextToSubDomain(_response);
        });
    }

    protected processMoveContextToSubDomain(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addContextScope(contextId: string, body: AddContextScopeModel | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Context/{contextId}/Scopes";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddContextScope(_response);
        });
    }

    protected processAddContextScope(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateContextScope(contextId: string, scopeId: string, body: UpdateContextScopeModel | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Context/{contextId}/Scopes/{scopeId}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (scopeId === undefined || scopeId === null)
            throw new globalThis.Error("The parameter 'scopeId' must be defined.");
        url_ = url_.replace("{scopeId}", encodeURIComponent("" + scopeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateContextScope(_response);
        });
    }

    protected processUpdateContextScope(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    removeContextScope(contextId: string, scopeId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Context/{contextId}/Scopes/{scopeId}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (scopeId === undefined || scopeId === null)
            throw new globalThis.Error("The parameter 'scopeId' must be defined.");
        url_ = url_.replace("{scopeId}", encodeURIComponent("" + scopeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveContextScope(_response);
        });
    }

    protected processRemoveContextScope(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    upsertServiceConnection(contextId: string, serviceConnectionId: string, body: UpsertContextServiceConnectionModel | undefined, signal?: AbortSignal): Promise<ContextModel> {
        let url_ = this.baseUrl + "/Context/{contextId}/ServiceConnections/{serviceConnectionId}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (serviceConnectionId === undefined || serviceConnectionId === null)
            throw new globalThis.Error("The parameter 'serviceConnectionId' must be defined.");
        url_ = url_.replace("{serviceConnectionId}", encodeURIComponent("" + serviceConnectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertServiceConnection(_response);
        });
    }

    protected processUpsertServiceConnection(response: Response): Promise<ContextModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContextModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContextModel>(null as any);
    }

    /**
     * @return OK
     */
    removeServiceConnection(contextId: string, serviceConnectionId: string, signal?: AbortSignal): Promise<ContextModel> {
        let url_ = this.baseUrl + "/Context/{contextId}/ServiceConnections/{serviceConnectionId}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (serviceConnectionId === undefined || serviceConnectionId === null)
            throw new globalThis.Error("The parameter 'serviceConnectionId' must be defined.");
        url_ = url_.replace("{serviceConnectionId}", encodeURIComponent("" + serviceConnectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveServiceConnection(_response);
        });
    }

    protected processRemoveServiceConnection(response: Response): Promise<ContextModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContextModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContextModel>(null as any);
    }
}

export class ContextCodeClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    downloadContextCode(contextId: string, codeBaseType: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/ContextCode/{contextId}/code/{codeBaseType}/download";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (codeBaseType === undefined || codeBaseType === null)
            throw new globalThis.Error("The parameter 'codeBaseType' must be defined.");
        url_ = url_.replace("{codeBaseType}", encodeURIComponent("" + codeBaseType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadContextCode(_response);
        });
    }

    protected processDownloadContextCode(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    getContextCode(contextId: string, codeBaseType: string, signal?: AbortSignal): Promise<CodeStoreFileModel[]> {
        let url_ = this.baseUrl + "/ContextCode/{contextId}/code/{codeBaseType}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (codeBaseType === undefined || codeBaseType === null)
            throw new globalThis.Error("The parameter 'codeBaseType' must be defined.");
        url_ = url_.replace("{codeBaseType}", encodeURIComponent("" + codeBaseType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetContextCode(_response);
        });
    }

    protected processGetContextCode(response: Response): Promise<CodeStoreFileModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeStoreFileModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CodeStoreFileModel[]>(null as any);
    }

    /**
     * @return OK
     */
    getContextDomainMeta(contextId: string, signal?: AbortSignal): Promise<DomainMetaModel> {
        let url_ = this.baseUrl + "/ContextCode/{contextId}/code/domain/meta";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetContextDomainMeta(_response);
        });
    }

    protected processGetContextDomainMeta(response: Response): Promise<DomainMetaModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DomainMetaModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DomainMetaModel>(null as any);
    }

    /**
     * @return OK
     */
    getCodeBaseInformation(contextId: string, codeBaseType: string, signal?: AbortSignal): Promise<CodeBaseModel> {
        let url_ = this.baseUrl + "/ContextCode/{contextId}/code/information/{codeBaseType}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (codeBaseType === undefined || codeBaseType === null)
            throw new globalThis.Error("The parameter 'codeBaseType' must be defined.");
        url_ = url_.replace("{codeBaseType}", encodeURIComponent("" + codeBaseType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCodeBaseInformation(_response);
        });
    }

    protected processGetCodeBaseInformation(response: Response): Promise<CodeBaseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeBaseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CodeBaseModel>(null as any);
    }

    /**
     * @return Accepted
     */
    packageCode(contextId: string, codeBaseType: string, signal?: AbortSignal): Promise<CodeBaseAsyncOperationModel> {
        let url_ = this.baseUrl + "/ContextCode/{contextId}/code/package/{codeBaseType}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (codeBaseType === undefined || codeBaseType === null)
            throw new globalThis.Error("The parameter 'codeBaseType' must be defined.");
        url_ = url_.replace("{codeBaseType}", encodeURIComponent("" + codeBaseType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPackageCode(_response);
        });
    }

    protected processPackageCode(response: Response): Promise<CodeBaseAsyncOperationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeBaseAsyncOperationModel;
            return result202;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CodeBaseAsyncOperationModel>(null as any);
    }

    /**
     * @return Accepted
     */
    deployCode(contextId: string, codeBaseType: string, signal?: AbortSignal): Promise<CodeBaseAsyncOperationModel> {
        let url_ = this.baseUrl + "/ContextCode/{contextId}/code/deploy/{codeBaseType}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (codeBaseType === undefined || codeBaseType === null)
            throw new globalThis.Error("The parameter 'codeBaseType' must be defined.");
        url_ = url_.replace("{codeBaseType}", encodeURIComponent("" + codeBaseType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeployCode(_response);
        });
    }

    protected processDeployCode(response: Response): Promise<CodeBaseAsyncOperationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeBaseAsyncOperationModel;
            return result202;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CodeBaseAsyncOperationModel>(null as any);
    }

    /**
     * @return OK
     */
    getCodeOperation(contextId: string, operationId: string, signal?: AbortSignal): Promise<CodeBaseAsyncOperationModel> {
        let url_ = this.baseUrl + "/ContextCode/{contextId}/code/operations/{operationId}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (operationId === undefined || operationId === null)
            throw new globalThis.Error("The parameter 'operationId' must be defined.");
        url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCodeOperation(_response);
        });
    }

    protected processGetCodeOperation(response: Response): Promise<CodeBaseAsyncOperationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeBaseAsyncOperationModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CodeBaseAsyncOperationModel>(null as any);
    }

    /**
     * @return OK
     */
    syncOperationContract(contextId: string, operationId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/ContextCode/{contextId}/sync-operation-contracts/{operationId}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (operationId === undefined || operationId === null)
            throw new globalThis.Error("The parameter 'operationId' must be defined.");
        url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSyncOperationContract(_response);
        });
    }

    protected processSyncOperationContract(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    runUnitTests(contextId: string, signal?: AbortSignal): Promise<TestRunResultModel> {
        let url_ = this.baseUrl + "/ContextCode/{contextId}/code/tests/run";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunUnitTests(_response);
        });
    }

    protected processRunUnitTests(response: Response): Promise<TestRunResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TestRunResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestRunResultModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    instructCodeGenChangesToDomainLogic(contextId: string, body: CodeGenInstructionsModel | undefined, signal?: AbortSignal): Promise<CodeGenInstructionReponseModel> {
        let url_ = this.baseUrl + "/ContextCode/{contextId}/code/instruct/domain-logic";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInstructCodeGenChangesToDomainLogic(_response);
        });
    }

    protected processInstructCodeGenChangesToDomainLogic(response: Response): Promise<CodeGenInstructionReponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeGenInstructionReponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CodeGenInstructionReponseModel>(null as any);
    }

    /**
     * @param operationId (optional) 
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    instructCodeGenChangesToApplicationOperation(contextId: string, operationId: string | undefined, body: CodeGenInstructionsModel | undefined, signal?: AbortSignal): Promise<CodeGenInstructionReponseModel> {
        let url_ = this.baseUrl + "/ContextCode/{contextId}/code/instruct/application-operation-logic?";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (operationId === null)
            throw new globalThis.Error("The parameter 'operationId' cannot be null.");
        else if (operationId !== undefined)
            url_ += "operationId=" + encodeURIComponent("" + operationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInstructCodeGenChangesToApplicationOperation(_response);
        });
    }

    protected processInstructCodeGenChangesToApplicationOperation(response: Response): Promise<CodeGenInstructionReponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeGenInstructionReponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CodeGenInstructionReponseModel>(null as any);
    }

    /**
     * @param eventHandlerId (optional) 
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    instructCodeGenChangesToApplicationEventHandler(contextId: string, eventHandlerId: string | undefined, body: CodeGenInstructionsModel | undefined, signal?: AbortSignal): Promise<CodeGenInstructionReponseModel> {
        let url_ = this.baseUrl + "/ContextCode/{contextId}/code/instruct/application-event-handler-logic?";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (eventHandlerId === null)
            throw new globalThis.Error("The parameter 'eventHandlerId' cannot be null.");
        else if (eventHandlerId !== undefined)
            url_ += "eventHandlerId=" + encodeURIComponent("" + eventHandlerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInstructCodeGenChangesToApplicationEventHandler(_response);
        });
    }

    protected processInstructCodeGenChangesToApplicationEventHandler(response: Response): Promise<CodeGenInstructionReponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeGenInstructionReponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CodeGenInstructionReponseModel>(null as any);
    }

    /**
     * Returns a lightweight list of artifact names matching the prefix query.
    Used for @mention autocomplete in the coding-agent instruction panel.
            
    Artifact types (maps to @mention prefix):
      entity      → @domain/{Name}
      enum        → @domain/{Name}
      domain-file → @domain/{FileName}
      operation   → @service/{Name}
      service-file→ @service/{FileName}
      event-handler-file → @event-handler/{FileName}
            
    Pass includeArtifact to restrict to specific types; omit to include all.
    Pass excludeArtifact to omit specific types.
     * @param q (optional) 
     * @param includeArtifact (optional) 
     * @param excludeArtifact (optional) 
     * @return OK
     */
    searchArtifacts(contextId: string, q: string | undefined, includeArtifact: string[] | undefined, excludeArtifact: string[] | undefined, signal?: AbortSignal): Promise<CodeGenArtifactModel[]> {
        let url_ = this.baseUrl + "/ContextCode/{contextId}/code/artifacts/search?";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (q === null)
            throw new globalThis.Error("The parameter 'q' cannot be null.");
        else if (q !== undefined)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (includeArtifact === null)
            throw new globalThis.Error("The parameter 'includeArtifact' cannot be null.");
        else if (includeArtifact !== undefined)
            includeArtifact && includeArtifact.forEach(item => { url_ += "includeArtifact=" + encodeURIComponent("" + item) + "&"; });
        if (excludeArtifact === null)
            throw new globalThis.Error("The parameter 'excludeArtifact' cannot be null.");
        else if (excludeArtifact !== undefined)
            excludeArtifact && excludeArtifact.forEach(item => { url_ += "excludeArtifact=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchArtifacts(_response);
        });
    }

    protected processSearchArtifacts(response: Response): Promise<CodeGenArtifactModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeGenArtifactModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CodeGenArtifactModel[]>(null as any);
    }
}

export class ContextEventHandlerClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Create a new handler for this integration event within the specific context.
     * @param body (optional) 
     * @return OK
     */
    create(contextId: string, body: CreateContextEventHandlerRequest | undefined, signal?: AbortSignal): Promise<ContextEventHandlerModel> {
        let url_ = this.baseUrl + "/ContextEventHandler/{contextId}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ContextEventHandlerModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContextEventHandlerModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContextEventHandlerModel>(null as any);
    }

    /**
     * Returns all integration event handlers configured for this context.
     * @return OK
     */
    getAllForContext(contextId: string, signal?: AbortSignal): Promise<EventHandlerAndPayloadModel[]> {
        let url_ = this.baseUrl + "/ContextEventHandler/{contextId}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllForContext(_response);
        });
    }

    protected processGetAllForContext(response: Response): Promise<EventHandlerAndPayloadModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventHandlerAndPayloadModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventHandlerAndPayloadModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(contextId: string, eventHandlerId: string, body: UpdateContextEventHandlerRequest | undefined, signal?: AbortSignal): Promise<ContextEventHandlerModel> {
        let url_ = this.baseUrl + "/ContextEventHandler/{contextId}/{eventHandlerId}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (eventHandlerId === undefined || eventHandlerId === null)
            throw new globalThis.Error("The parameter 'eventHandlerId' must be defined.");
        url_ = url_.replace("{eventHandlerId}", encodeURIComponent("" + eventHandlerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ContextEventHandlerModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContextEventHandlerModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContextEventHandlerModel>(null as any);
    }

    /**
     * @return OK
     */
    delete(contextId: string, eventHandlerId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/ContextEventHandler/{contextId}/{eventHandlerId}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (eventHandlerId === undefined || eventHandlerId === null)
            throw new globalThis.Error("The parameter 'eventHandlerId' must be defined.");
        url_ = url_.replace("{eventHandlerId}", encodeURIComponent("" + eventHandlerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Returns a list of integration events that are available to handler, from within the passed context.
     * @return OK
     */
    getAvailableIntegrationEventsToHandle(contextId: string, signal?: AbortSignal): Promise<IntegrationEventModel[]> {
        let url_ = this.baseUrl + "/ContextEventHandler/{contextId}/events-available-to-handle";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableIntegrationEventsToHandle(_response);
        });
    }

    protected processGetAvailableIntegrationEventsToHandle(response: Response): Promise<IntegrationEventModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IntegrationEventModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IntegrationEventModel[]>(null as any);
    }
}

export class ConversationClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return No Content
     */
    cancelResponse(id: string, turnId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Conversation/{id}/Response/{turnId}/Cancel";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (turnId === undefined || turnId === null)
            throw new globalThis.Error("The parameter 'turnId' must be defined.");
        url_ = url_.replace("{turnId}", encodeURIComponent("" + turnId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelResponse(_response);
        });
    }

    protected processCancelResponse(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getById(id: string, signal?: AbortSignal): Promise<ConversationDetailViewModel> {
        let url_ = this.baseUrl + "/Conversation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<ConversationDetailViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConversationDetailViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversationDetailViewModel>(null as any);
    }

    /**
     * @return OK
     */
    delete(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Conversation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param beforeSequence (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getMessagesBefore(id: string, beforeSequence: number | undefined, pageSize: number | undefined, signal?: AbortSignal): Promise<ConversationMessagePageViewModel> {
        let url_ = this.baseUrl + "/Conversation/{id}/Messages?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (beforeSequence === null)
            throw new globalThis.Error("The parameter 'beforeSequence' cannot be null.");
        else if (beforeSequence !== undefined)
            url_ += "beforeSequence=" + encodeURIComponent("" + beforeSequence) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMessagesBefore(_response);
        });
    }

    protected processGetMessagesBefore(response: Response): Promise<ConversationMessagePageViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConversationMessagePageViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversationMessagePageViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setExpiry(id: string, body: ConversationExpirationRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Conversation/{id}/Expiry";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetExpiry(_response);
        });
    }

    protected processSetExpiry(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param conversationId (optional) 
     * @param participantTargetId (optional) 
     * @param attributeKey (optional) 
     * @param attributeValue (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @return OK
     */
    search(conversationId: string | undefined, participantTargetId: string | undefined, attributeKey: string | undefined, attributeValue: string | undefined, pageIndex: number | undefined, pageSize: number | undefined, sortBy: string | undefined, sortAscending: boolean | undefined, signal?: AbortSignal): Promise<ConversationViewModelPagingResultModel> {
        let url_ = this.baseUrl + "/Conversation?";
        if (conversationId === null)
            throw new globalThis.Error("The parameter 'conversationId' cannot be null.");
        else if (conversationId !== undefined)
            url_ += "conversationId=" + encodeURIComponent("" + conversationId) + "&";
        if (participantTargetId === null)
            throw new globalThis.Error("The parameter 'participantTargetId' cannot be null.");
        else if (participantTargetId !== undefined)
            url_ += "participantTargetId=" + encodeURIComponent("" + participantTargetId) + "&";
        if (attributeKey === null)
            throw new globalThis.Error("The parameter 'attributeKey' cannot be null.");
        else if (attributeKey !== undefined)
            url_ += "attributeKey=" + encodeURIComponent("" + attributeKey) + "&";
        if (attributeValue === null)
            throw new globalThis.Error("The parameter 'attributeValue' cannot be null.");
        else if (attributeValue !== undefined)
            url_ += "attributeValue=" + encodeURIComponent("" + attributeValue) + "&";
        if (pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<ConversationViewModelPagingResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConversationViewModelPagingResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversationViewModelPagingResultModel>(null as any);
    }
}

export class DashboardClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param changeSetId (optional) 
     * @return OK
     */
    getOverview(changeSetId: string | undefined, signal?: AbortSignal): Promise<DashboardOverviewModel> {
        let url_ = this.baseUrl + "/Dashboard?";
        if (changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' cannot be null.");
        else if (changeSetId !== undefined)
            url_ += "changeSetId=" + encodeURIComponent("" + changeSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOverview(_response);
        });
    }

    protected processGetOverview(response: Response): Promise<DashboardOverviewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardOverviewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardOverviewModel>(null as any);
    }

    /**
     * @return Accepted
     */
    refresh(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Dashboard/refresh";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRefresh(_response);
        });
    }

    protected processRefresh(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DataSchemaClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getPropertyTypes(signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/DataSchema/propertyTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPropertyTypes(_response);
        });
    }

    protected processGetPropertyTypes(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param schemaTypeId (optional) 
     * @param includeSubEntities (optional) 
     * @return OK
     */
    getEntitiesForContext(contextId: string, schemaTypeId: number | undefined, includeSubEntities: boolean | undefined, signal?: AbortSignal): Promise<SchemaSummaryModel[]> {
        let url_ = this.baseUrl + "/DataSchema/{contextId}/entities?";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (schemaTypeId === null)
            throw new globalThis.Error("The parameter 'schemaTypeId' cannot be null.");
        else if (schemaTypeId !== undefined)
            url_ += "schemaTypeId=" + encodeURIComponent("" + schemaTypeId) + "&";
        if (includeSubEntities === null)
            throw new globalThis.Error("The parameter 'includeSubEntities' cannot be null.");
        else if (includeSubEntities !== undefined)
            url_ += "includeSubEntities=" + encodeURIComponent("" + includeSubEntities) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEntitiesForContext(_response);
        });
    }

    protected processGetEntitiesForContext(response: Response): Promise<SchemaSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SchemaSummaryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SchemaSummaryModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    newEntity(contextId: string, body: NewEntitySchemaRequest | undefined, signal?: AbortSignal): Promise<SchemaHierarchyModel> {
        let url_ = this.baseUrl + "/DataSchema/{contextId}/entities";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNewEntity(_response);
        });
    }

    protected processNewEntity(response: Response): Promise<SchemaHierarchyModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SchemaHierarchyModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SchemaHierarchyModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getEntitiesByIds(contextId: string, body: BatchEntityIdsRequest | undefined, signal?: AbortSignal): Promise<SchemaSummaryModel[]> {
        let url_ = this.baseUrl + "/DataSchema/{contextId}/entities/batch";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEntitiesByIds(_response);
        });
    }

    protected processGetEntitiesByIds(response: Response): Promise<SchemaSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SchemaSummaryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SchemaSummaryModel[]>(null as any);
    }

    /**
     * @param includeSubEntities (optional) 
     * @return OK
     */
    getEntitySummary(contextId: string, entityId: string, includeSubEntities: boolean | undefined, signal?: AbortSignal): Promise<SchemaSummaryModel> {
        let url_ = this.baseUrl + "/DataSchema/{contextId}/entities/{entityId}/summary?";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (entityId === undefined || entityId === null)
            throw new globalThis.Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        if (includeSubEntities === null)
            throw new globalThis.Error("The parameter 'includeSubEntities' cannot be null.");
        else if (includeSubEntities !== undefined)
            url_ += "includeSubEntities=" + encodeURIComponent("" + includeSubEntities) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEntitySummary(_response);
        });
    }

    protected processGetEntitySummary(response: Response): Promise<SchemaSummaryModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SchemaSummaryModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SchemaSummaryModel>(null as any);
    }

    /**
     * @return OK
     */
    getEntity(contextId: string, entityId: string, signal?: AbortSignal): Promise<SchemaHierarchyModel> {
        let url_ = this.baseUrl + "/DataSchema/{contextId}/entities/{entityId}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (entityId === undefined || entityId === null)
            throw new globalThis.Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEntity(_response);
        });
    }

    protected processGetEntity(response: Response): Promise<SchemaHierarchyModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SchemaHierarchyModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SchemaHierarchyModel>(null as any);
    }

    /**
     * @param schemaTypes (optional) 
     * @return OK
     */
    getDomainModel(contextId: string, schemaTypes: SchemaTypesModel[] | undefined, signal?: AbortSignal): Promise<DomainModelingDataModel> {
        let url_ = this.baseUrl + "/DataSchema/{contextId}/domain-model?";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (schemaTypes === null)
            throw new globalThis.Error("The parameter 'schemaTypes' cannot be null.");
        else if (schemaTypes !== undefined)
            schemaTypes && schemaTypes.forEach(item => { url_ += "schemaTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDomainModel(_response);
        });
    }

    protected processGetDomainModel(response: Response): Promise<DomainModelingDataModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DomainModelingDataModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DomainModelingDataModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addProperty(contextId: string, id: string, body: SimplePropertyModel | undefined, signal?: AbortSignal): Promise<SchemaPropertyModel> {
        let url_ = this.baseUrl + "/DataSchema/{contextId}/{id}/properties";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddProperty(_response);
        });
    }

    protected processAddProperty(response: Response): Promise<SchemaPropertyModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SchemaPropertyModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SchemaPropertyModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addPropertyV2(contextId: string, id: string, body: AddPropertyV2Model | undefined, signal?: AbortSignal): Promise<SchemaPropertyModel> {
        let url_ = this.baseUrl + "/DataSchema/{contextId}/{id}/v2/properties";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddPropertyV2(_response);
        });
    }

    protected processAddPropertyV2(response: Response): Promise<SchemaPropertyModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SchemaPropertyModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SchemaPropertyModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addSchemaProperty(contextId: string, id: string, body: NewEntityAsNewPropertyRequest | undefined, signal?: AbortSignal): Promise<SchemaPropertyModel> {
        let url_ = this.baseUrl + "/DataSchema/{contextId}/{id}/schemaProperties";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddSchemaProperty(_response);
        });
    }

    protected processAddSchemaProperty(response: Response): Promise<SchemaPropertyModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SchemaPropertyModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SchemaPropertyModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addEnumProperty(contextId: string, entityId: string, body: EnumPropertyModel | undefined, signal?: AbortSignal): Promise<SchemaPropertyModel> {
        let url_ = this.baseUrl + "/DataSchema/{contextId}/{entityId}/enumProperties";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (entityId === undefined || entityId === null)
            throw new globalThis.Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddEnumProperty(_response);
        });
    }

    protected processAddEnumProperty(response: Response): Promise<SchemaPropertyModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SchemaPropertyModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SchemaPropertyModel>(null as any);
    }

    /**
     * @return OK
     */
    removeProperty(contextId: string, id: string, propertyName: string, signal?: AbortSignal): Promise<SchemaHierarchyModel> {
        let url_ = this.baseUrl + "/DataSchema/{contextId}/{id}/properties/{propertyName}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (propertyName === undefined || propertyName === null)
            throw new globalThis.Error("The parameter 'propertyName' must be defined.");
        url_ = url_.replace("{propertyName}", encodeURIComponent("" + propertyName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveProperty(_response);
        });
    }

    protected processRemoveProperty(response: Response): Promise<SchemaHierarchyModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SchemaHierarchyModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SchemaHierarchyModel>(null as any);
    }

    /**
     * @param propertyType (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateProperty(contextId: string, id: string, propertyName: string, propertyType: PropertyTypes | undefined, body: UpdatePropertyModel | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/DataSchema/{contextId}/{id}/properties/{propertyName}?";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (propertyName === undefined || propertyName === null)
            throw new globalThis.Error("The parameter 'propertyName' must be defined.");
        url_ = url_.replace("{propertyName}", encodeURIComponent("" + propertyName));
        if (propertyType === null)
            throw new globalThis.Error("The parameter 'propertyType' cannot be null.");
        else if (propertyType !== undefined)
            url_ += "propertyType=" + encodeURIComponent("" + propertyType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProperty(_response);
        });
    }

    protected processUpdateProperty(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateDescription(contextId: string, id: string, body: UpdateDescriptionModel | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/DataSchema/{contextId}/{id}/updateDescription";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateDescription(_response);
        });
    }

    protected processUpdateDescription(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateMetadata(contextId: string, id: string, body: UpdateMetadataModel | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/DataSchema/{contextId}/{id}/updateMetadata";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMetadata(_response);
        });
    }

    protected processUpdateMetadata(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    batchUpdateMetadata(contextId: string, body: BatchUpdateMetadataModel | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/DataSchema/{contextId}/entities/updateMetadata";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBatchUpdateMetadata(_response);
        });
    }

    protected processBatchUpdateMetadata(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    batchUpdateDomainMetadata(contextId: string, body: BatchUpdateDomainMetadataModel | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/DataSchema/{contextId}/domain/updateMetadata";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBatchUpdateDomainMetadata(_response);
        });
    }

    protected processBatchUpdateDomainMetadata(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateEnumMetadata(contextId: string, enumId: string, body: UpdateMetadataModel | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/DataSchema/{contextId}/enums/{enumId}/updateMetadata";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (enumId === undefined || enumId === null)
            throw new globalThis.Error("The parameter 'enumId' must be defined.");
        url_ = url_.replace("{enumId}", encodeURIComponent("" + enumId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateEnumMetadata(_response);
        });
    }

    protected processUpdateEnumMetadata(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getEnums(contextId: string, signal?: AbortSignal): Promise<EnumModel[]> {
        let url_ = this.baseUrl + "/DataSchema/{contextId}/enums";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEnums(_response);
        });
    }

    protected processGetEnums(response: Response): Promise<EnumModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EnumModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnumModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addNewEnum(contextId: string, body: NewEnumModel | undefined, signal?: AbortSignal): Promise<EnumModel> {
        let url_ = this.baseUrl + "/DataSchema/{contextId}/enums";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddNewEnum(_response);
        });
    }

    protected processAddNewEnum(response: Response): Promise<EnumModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EnumModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnumModel>(null as any);
    }

    /**
     * @return OK
     */
    getEnumById(contextId: string, enumId: string, signal?: AbortSignal): Promise<EnumModel> {
        let url_ = this.baseUrl + "/DataSchema/{contextId}/enums/{enumId}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (enumId === undefined || enumId === null)
            throw new globalThis.Error("The parameter 'enumId' must be defined.");
        url_ = url_.replace("{enumId}", encodeURIComponent("" + enumId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEnumById(_response);
        });
    }

    protected processGetEnumById(response: Response): Promise<EnumModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EnumModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnumModel>(null as any);
    }

    /**
     * @return OK
     */
    deleteEnum(contextId: string, enumId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/DataSchema/{contextId}/enums/{enumId}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (enumId === undefined || enumId === null)
            throw new globalThis.Error("The parameter 'enumId' must be defined.");
        url_ = url_.replace("{enumId}", encodeURIComponent("" + enumId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteEnum(_response);
        });
    }

    protected processDeleteEnum(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getEnumItems(contextId: string, name: string, signal?: AbortSignal): Promise<EnumItemModel[]> {
        let url_ = this.baseUrl + "/DataSchema/{contextId}/enums/{name}/items";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEnumItems(_response);
        });
    }

    protected processGetEnumItems(response: Response): Promise<EnumItemModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EnumItemModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnumItemModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addNewEnumItem(contextId: string, name: string, body: AddEnumItemModel | undefined, signal?: AbortSignal): Promise<EnumModel> {
        let url_ = this.baseUrl + "/DataSchema/{contextId}/enums/{name}/items";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddNewEnumItem(_response);
        });
    }

    protected processAddNewEnumItem(response: Response): Promise<EnumModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EnumModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnumModel>(null as any);
    }
}

export class DesignerChatSessionClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param contextScope (optional) 
     * @return OK
     */
    getAgents(scopeName: string, contextScope: string | undefined, signal?: AbortSignal): Promise<DesignerChatAgentModel[]> {
        let url_ = this.baseUrl + "/DesignerChat/{scopeName}/agents?";
        if (scopeName === undefined || scopeName === null)
            throw new globalThis.Error("The parameter 'scopeName' must be defined.");
        url_ = url_.replace("{scopeName}", encodeURIComponent("" + scopeName));
        if (contextScope === null)
            throw new globalThis.Error("The parameter 'contextScope' cannot be null.");
        else if (contextScope !== undefined)
            url_ += "contextScope=" + encodeURIComponent("" + contextScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAgents(_response);
        });
    }

    protected processGetAgents(response: Response): Promise<DesignerChatAgentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DesignerChatAgentModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignerChatAgentModel[]>(null as any);
    }

    /**
     * @param targetId (optional) 
     * @param contextScope (optional) 
     * @param operationId (optional) 
     * @param eventHandlerId (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getScopedSessions(scopeName: string, targetId: string | undefined, contextScope: string | undefined, operationId: string | undefined, eventHandlerId: string | undefined, pageIndex: number | undefined, pageSize: number | undefined, signal?: AbortSignal): Promise<DesignerChatSessionModelPagingResultModel> {
        let url_ = this.baseUrl + "/DesignerChat/{scopeName}/sessions?";
        if (scopeName === undefined || scopeName === null)
            throw new globalThis.Error("The parameter 'scopeName' must be defined.");
        url_ = url_.replace("{scopeName}", encodeURIComponent("" + scopeName));
        if (targetId === null)
            throw new globalThis.Error("The parameter 'targetId' cannot be null.");
        else if (targetId !== undefined)
            url_ += "targetId=" + encodeURIComponent("" + targetId) + "&";
        if (contextScope === null)
            throw new globalThis.Error("The parameter 'contextScope' cannot be null.");
        else if (contextScope !== undefined)
            url_ += "contextScope=" + encodeURIComponent("" + contextScope) + "&";
        if (operationId === null)
            throw new globalThis.Error("The parameter 'operationId' cannot be null.");
        else if (operationId !== undefined)
            url_ += "operationId=" + encodeURIComponent("" + operationId) + "&";
        if (eventHandlerId === null)
            throw new globalThis.Error("The parameter 'eventHandlerId' cannot be null.");
        else if (eventHandlerId !== undefined)
            url_ += "eventHandlerId=" + encodeURIComponent("" + eventHandlerId) + "&";
        if (pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetScopedSessions(_response);
        });
    }

    protected processGetScopedSessions(response: Response): Promise<DesignerChatSessionModelPagingResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DesignerChatSessionModelPagingResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignerChatSessionModelPagingResultModel>(null as any);
    }

    /**
     * @param targetId (optional) 
     * @param contextScope (optional) 
     * @param operationId (optional) 
     * @param eventHandlerId (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getSessions(scopeName: string, agentId: string, targetId: string | undefined, contextScope: string | undefined, operationId: string | undefined, eventHandlerId: string | undefined, pageIndex: number | undefined, pageSize: number | undefined, signal?: AbortSignal): Promise<DesignerChatSessionModelPagingResultModel> {
        let url_ = this.baseUrl + "/DesignerChat/{scopeName}/{agentId}/sessions?";
        if (scopeName === undefined || scopeName === null)
            throw new globalThis.Error("The parameter 'scopeName' must be defined.");
        url_ = url_.replace("{scopeName}", encodeURIComponent("" + scopeName));
        if (agentId === undefined || agentId === null)
            throw new globalThis.Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (targetId === null)
            throw new globalThis.Error("The parameter 'targetId' cannot be null.");
        else if (targetId !== undefined)
            url_ += "targetId=" + encodeURIComponent("" + targetId) + "&";
        if (contextScope === null)
            throw new globalThis.Error("The parameter 'contextScope' cannot be null.");
        else if (contextScope !== undefined)
            url_ += "contextScope=" + encodeURIComponent("" + contextScope) + "&";
        if (operationId === null)
            throw new globalThis.Error("The parameter 'operationId' cannot be null.");
        else if (operationId !== undefined)
            url_ += "operationId=" + encodeURIComponent("" + operationId) + "&";
        if (eventHandlerId === null)
            throw new globalThis.Error("The parameter 'eventHandlerId' cannot be null.");
        else if (eventHandlerId !== undefined)
            url_ += "eventHandlerId=" + encodeURIComponent("" + eventHandlerId) + "&";
        if (pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSessions(_response);
        });
    }

    protected processGetSessions(response: Response): Promise<DesignerChatSessionModelPagingResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DesignerChatSessionModelPagingResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignerChatSessionModelPagingResultModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrGetSession(scopeName: string, agentId: string, body: DesignerChatCreateSessionRequest | undefined, signal?: AbortSignal): Promise<DesignerChatSessionModel> {
        let url_ = this.baseUrl + "/DesignerChat/{scopeName}/{agentId}/sessions";
        if (scopeName === undefined || scopeName === null)
            throw new globalThis.Error("The parameter 'scopeName' must be defined.");
        url_ = url_.replace("{scopeName}", encodeURIComponent("" + scopeName));
        if (agentId === undefined || agentId === null)
            throw new globalThis.Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateOrGetSession(_response);
        });
    }

    protected processCreateOrGetSession(response: Response): Promise<DesignerChatSessionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DesignerChatSessionModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignerChatSessionModel>(null as any);
    }

    /**
     * @param targetId (optional) 
     * @param contextScope (optional) 
     * @param operationId (optional) 
     * @param eventHandlerId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateSession(scopeName: string, agentId: string, sessionId: string, targetId: string | undefined, contextScope: string | undefined, operationId: string | undefined, eventHandlerId: string | undefined, body: DesignerChatUpdateSessionRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/DesignerChat/{scopeName}/{agentId}/sessions/{sessionId}?";
        if (scopeName === undefined || scopeName === null)
            throw new globalThis.Error("The parameter 'scopeName' must be defined.");
        url_ = url_.replace("{scopeName}", encodeURIComponent("" + scopeName));
        if (agentId === undefined || agentId === null)
            throw new globalThis.Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (sessionId === undefined || sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        if (targetId === null)
            throw new globalThis.Error("The parameter 'targetId' cannot be null.");
        else if (targetId !== undefined)
            url_ += "targetId=" + encodeURIComponent("" + targetId) + "&";
        if (contextScope === null)
            throw new globalThis.Error("The parameter 'contextScope' cannot be null.");
        else if (contextScope !== undefined)
            url_ += "contextScope=" + encodeURIComponent("" + contextScope) + "&";
        if (operationId === null)
            throw new globalThis.Error("The parameter 'operationId' cannot be null.");
        else if (operationId !== undefined)
            url_ += "operationId=" + encodeURIComponent("" + operationId) + "&";
        if (eventHandlerId === null)
            throw new globalThis.Error("The parameter 'eventHandlerId' cannot be null.");
        else if (eventHandlerId !== undefined)
            url_ += "eventHandlerId=" + encodeURIComponent("" + eventHandlerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSession(_response);
        });
    }

    protected processUpdateSession(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param targetId (optional) 
     * @param contextScope (optional) 
     * @param operationId (optional) 
     * @param eventHandlerId (optional) 
     * @return OK
     */
    deleteSession(scopeName: string, agentId: string, sessionId: string, targetId: string | undefined, contextScope: string | undefined, operationId: string | undefined, eventHandlerId: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/DesignerChat/{scopeName}/{agentId}/sessions/{sessionId}?";
        if (scopeName === undefined || scopeName === null)
            throw new globalThis.Error("The parameter 'scopeName' must be defined.");
        url_ = url_.replace("{scopeName}", encodeURIComponent("" + scopeName));
        if (agentId === undefined || agentId === null)
            throw new globalThis.Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (sessionId === undefined || sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        if (targetId === null)
            throw new globalThis.Error("The parameter 'targetId' cannot be null.");
        else if (targetId !== undefined)
            url_ += "targetId=" + encodeURIComponent("" + targetId) + "&";
        if (contextScope === null)
            throw new globalThis.Error("The parameter 'contextScope' cannot be null.");
        else if (contextScope !== undefined)
            url_ += "contextScope=" + encodeURIComponent("" + contextScope) + "&";
        if (operationId === null)
            throw new globalThis.Error("The parameter 'operationId' cannot be null.");
        else if (operationId !== undefined)
            url_ += "operationId=" + encodeURIComponent("" + operationId) + "&";
        if (eventHandlerId === null)
            throw new globalThis.Error("The parameter 'eventHandlerId' cannot be null.");
        else if (eventHandlerId !== undefined)
            url_ += "eventHandlerId=" + encodeURIComponent("" + eventHandlerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteSession(_response);
        });
    }

    protected processDeleteSession(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param targetId (optional) 
     * @param contextScope (optional) 
     * @param operationId (optional) 
     * @param eventHandlerId (optional) 
     * @param afterMessageId (optional) 
     * @param afterSequence (optional) 
     * @param changeToken (optional) 
     * @return OK
     */
    getMessagesDelta(scopeName: string, agentId: string, sessionId: string, targetId: string | undefined, contextScope: string | undefined, operationId: string | undefined, eventHandlerId: string | undefined, afterMessageId: string | undefined, afterSequence: number | undefined, changeToken: string | undefined, signal?: AbortSignal): Promise<DesignerChatSessionDeltaResponse> {
        let url_ = this.baseUrl + "/DesignerChat/{scopeName}/{agentId}/sessions/{sessionId}/messages/delta?";
        if (scopeName === undefined || scopeName === null)
            throw new globalThis.Error("The parameter 'scopeName' must be defined.");
        url_ = url_.replace("{scopeName}", encodeURIComponent("" + scopeName));
        if (agentId === undefined || agentId === null)
            throw new globalThis.Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (sessionId === undefined || sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        if (targetId === null)
            throw new globalThis.Error("The parameter 'targetId' cannot be null.");
        else if (targetId !== undefined)
            url_ += "targetId=" + encodeURIComponent("" + targetId) + "&";
        if (contextScope === null)
            throw new globalThis.Error("The parameter 'contextScope' cannot be null.");
        else if (contextScope !== undefined)
            url_ += "contextScope=" + encodeURIComponent("" + contextScope) + "&";
        if (operationId === null)
            throw new globalThis.Error("The parameter 'operationId' cannot be null.");
        else if (operationId !== undefined)
            url_ += "operationId=" + encodeURIComponent("" + operationId) + "&";
        if (eventHandlerId === null)
            throw new globalThis.Error("The parameter 'eventHandlerId' cannot be null.");
        else if (eventHandlerId !== undefined)
            url_ += "eventHandlerId=" + encodeURIComponent("" + eventHandlerId) + "&";
        if (afterMessageId === null)
            throw new globalThis.Error("The parameter 'afterMessageId' cannot be null.");
        else if (afterMessageId !== undefined)
            url_ += "afterMessageId=" + encodeURIComponent("" + afterMessageId) + "&";
        if (afterSequence === null)
            throw new globalThis.Error("The parameter 'afterSequence' cannot be null.");
        else if (afterSequence !== undefined)
            url_ += "afterSequence=" + encodeURIComponent("" + afterSequence) + "&";
        if (changeToken === null)
            throw new globalThis.Error("The parameter 'changeToken' cannot be null.");
        else if (changeToken !== undefined)
            url_ += "changeToken=" + encodeURIComponent("" + changeToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMessagesDelta(_response);
        });
    }

    protected processGetMessagesDelta(response: Response): Promise<DesignerChatSessionDeltaResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DesignerChatSessionDeltaResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignerChatSessionDeltaResponse>(null as any);
    }

    /**
     * @param targetId (optional) 
     * @param contextScope (optional) 
     * @param operationId (optional) 
     * @param eventHandlerId (optional) 
     * @param beforeSequence (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getMessagesBefore(scopeName: string, agentId: string, sessionId: string, targetId: string | undefined, contextScope: string | undefined, operationId: string | undefined, eventHandlerId: string | undefined, beforeSequence: number | undefined, pageSize: number | undefined, signal?: AbortSignal): Promise<DesignerChatMessagePageResponse> {
        let url_ = this.baseUrl + "/DesignerChat/{scopeName}/{agentId}/sessions/{sessionId}/messages/before?";
        if (scopeName === undefined || scopeName === null)
            throw new globalThis.Error("The parameter 'scopeName' must be defined.");
        url_ = url_.replace("{scopeName}", encodeURIComponent("" + scopeName));
        if (agentId === undefined || agentId === null)
            throw new globalThis.Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (sessionId === undefined || sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        if (targetId === null)
            throw new globalThis.Error("The parameter 'targetId' cannot be null.");
        else if (targetId !== undefined)
            url_ += "targetId=" + encodeURIComponent("" + targetId) + "&";
        if (contextScope === null)
            throw new globalThis.Error("The parameter 'contextScope' cannot be null.");
        else if (contextScope !== undefined)
            url_ += "contextScope=" + encodeURIComponent("" + contextScope) + "&";
        if (operationId === null)
            throw new globalThis.Error("The parameter 'operationId' cannot be null.");
        else if (operationId !== undefined)
            url_ += "operationId=" + encodeURIComponent("" + operationId) + "&";
        if (eventHandlerId === null)
            throw new globalThis.Error("The parameter 'eventHandlerId' cannot be null.");
        else if (eventHandlerId !== undefined)
            url_ += "eventHandlerId=" + encodeURIComponent("" + eventHandlerId) + "&";
        if (beforeSequence === null)
            throw new globalThis.Error("The parameter 'beforeSequence' cannot be null.");
        else if (beforeSequence !== undefined)
            url_ += "beforeSequence=" + encodeURIComponent("" + beforeSequence) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMessagesBefore(_response);
        });
    }

    protected processGetMessagesBefore(response: Response): Promise<DesignerChatMessagePageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DesignerChatMessagePageResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignerChatMessagePageResponse>(null as any);
    }

    /**
     * @param targetId (optional) 
     * @param contextScope (optional) 
     * @param operationId (optional) 
     * @param eventHandlerId (optional) 
     * @return OK
     */
    getParticipants(scopeName: string, agentId: string, sessionId: string, targetId: string | undefined, contextScope: string | undefined, operationId: string | undefined, eventHandlerId: string | undefined, signal?: AbortSignal): Promise<DesignerChatParticipantModel[]> {
        let url_ = this.baseUrl + "/DesignerChat/{scopeName}/{agentId}/sessions/{sessionId}/participants?";
        if (scopeName === undefined || scopeName === null)
            throw new globalThis.Error("The parameter 'scopeName' must be defined.");
        url_ = url_.replace("{scopeName}", encodeURIComponent("" + scopeName));
        if (agentId === undefined || agentId === null)
            throw new globalThis.Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (sessionId === undefined || sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        if (targetId === null)
            throw new globalThis.Error("The parameter 'targetId' cannot be null.");
        else if (targetId !== undefined)
            url_ += "targetId=" + encodeURIComponent("" + targetId) + "&";
        if (contextScope === null)
            throw new globalThis.Error("The parameter 'contextScope' cannot be null.");
        else if (contextScope !== undefined)
            url_ += "contextScope=" + encodeURIComponent("" + contextScope) + "&";
        if (operationId === null)
            throw new globalThis.Error("The parameter 'operationId' cannot be null.");
        else if (operationId !== undefined)
            url_ += "operationId=" + encodeURIComponent("" + operationId) + "&";
        if (eventHandlerId === null)
            throw new globalThis.Error("The parameter 'eventHandlerId' cannot be null.");
        else if (eventHandlerId !== undefined)
            url_ += "eventHandlerId=" + encodeURIComponent("" + eventHandlerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetParticipants(_response);
        });
    }

    protected processGetParticipants(response: Response): Promise<DesignerChatParticipantModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DesignerChatParticipantModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignerChatParticipantModel[]>(null as any);
    }

    /**
     * @param targetId (optional) 
     * @param contextScope (optional) 
     * @param operationId (optional) 
     * @param eventHandlerId (optional) 
     * @param body (optional) 
     * @return OK
     */
    addParticipants(scopeName: string, agentId: string, sessionId: string, targetId: string | undefined, contextScope: string | undefined, operationId: string | undefined, eventHandlerId: string | undefined, body: DesignerChatAddParticipantsRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/DesignerChat/{scopeName}/{agentId}/sessions/{sessionId}/participants?";
        if (scopeName === undefined || scopeName === null)
            throw new globalThis.Error("The parameter 'scopeName' must be defined.");
        url_ = url_.replace("{scopeName}", encodeURIComponent("" + scopeName));
        if (agentId === undefined || agentId === null)
            throw new globalThis.Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (sessionId === undefined || sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        if (targetId === null)
            throw new globalThis.Error("The parameter 'targetId' cannot be null.");
        else if (targetId !== undefined)
            url_ += "targetId=" + encodeURIComponent("" + targetId) + "&";
        if (contextScope === null)
            throw new globalThis.Error("The parameter 'contextScope' cannot be null.");
        else if (contextScope !== undefined)
            url_ += "contextScope=" + encodeURIComponent("" + contextScope) + "&";
        if (operationId === null)
            throw new globalThis.Error("The parameter 'operationId' cannot be null.");
        else if (operationId !== undefined)
            url_ += "operationId=" + encodeURIComponent("" + operationId) + "&";
        if (eventHandlerId === null)
            throw new globalThis.Error("The parameter 'eventHandlerId' cannot be null.");
        else if (eventHandlerId !== undefined)
            url_ += "eventHandlerId=" + encodeURIComponent("" + eventHandlerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddParticipants(_response);
        });
    }

    protected processAddParticipants(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param targetId (optional) 
     * @param contextScope (optional) 
     * @param operationId (optional) 
     * @param eventHandlerId (optional) 
     * @return OK
     */
    removeParticipant(scopeName: string, agentId: string, sessionId: string, userId: string, targetId: string | undefined, contextScope: string | undefined, operationId: string | undefined, eventHandlerId: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/DesignerChat/{scopeName}/{agentId}/sessions/{sessionId}/participants/{userId}?";
        if (scopeName === undefined || scopeName === null)
            throw new globalThis.Error("The parameter 'scopeName' must be defined.");
        url_ = url_.replace("{scopeName}", encodeURIComponent("" + scopeName));
        if (agentId === undefined || agentId === null)
            throw new globalThis.Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (sessionId === undefined || sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (targetId === null)
            throw new globalThis.Error("The parameter 'targetId' cannot be null.");
        else if (targetId !== undefined)
            url_ += "targetId=" + encodeURIComponent("" + targetId) + "&";
        if (contextScope === null)
            throw new globalThis.Error("The parameter 'contextScope' cannot be null.");
        else if (contextScope !== undefined)
            url_ += "contextScope=" + encodeURIComponent("" + contextScope) + "&";
        if (operationId === null)
            throw new globalThis.Error("The parameter 'operationId' cannot be null.");
        else if (operationId !== undefined)
            url_ += "operationId=" + encodeURIComponent("" + operationId) + "&";
        if (eventHandlerId === null)
            throw new globalThis.Error("The parameter 'eventHandlerId' cannot be null.");
        else if (eventHandlerId !== undefined)
            url_ += "eventHandlerId=" + encodeURIComponent("" + eventHandlerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveParticipant(_response);
        });
    }

    protected processRemoveParticipant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    instruct(scopeName: string, agentId: string, body: DesignerChatInstructRequest | undefined, signal?: AbortSignal): Promise<DesignerChatInstructResponse> {
        let url_ = this.baseUrl + "/DesignerChat/{scopeName}/{agentId}/instruct";
        if (scopeName === undefined || scopeName === null)
            throw new globalThis.Error("The parameter 'scopeName' must be defined.");
        url_ = url_.replace("{scopeName}", encodeURIComponent("" + scopeName));
        if (agentId === undefined || agentId === null)
            throw new globalThis.Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInstruct(_response);
        });
    }

    protected processInstruct(response: Response): Promise<DesignerChatInstructResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DesignerChatInstructResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignerChatInstructResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @param file (optional) 
     * @param conversationId (optional) 
     * @param attributes (optional) 
     * @return OK
     */
    uploadAttachment(body: Body2 | undefined, file: FileParameter | null | undefined, conversationId: string | undefined, attributes: string | null | undefined, signal?: AbortSignal): Promise<DesignerChatAttachmentModel> {
        let url_ = this.baseUrl + "/DesignerChat/attachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (conversationId === null || conversationId === undefined)
            throw new globalThis.Error("The parameter 'conversationId' cannot be null.");
        else
            content_.append("conversationId", conversationId.toString());
        if (attributes !== null && attributes !== undefined)
            content_.append("attributes", attributes.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "multipart/form-data",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadAttachment(_response);
        });
    }

    protected processUploadAttachment(response: Response): Promise<DesignerChatAttachmentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DesignerChatAttachmentModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignerChatAttachmentModel>(null as any);
    }

    /**
     * @return OK
     */
    deleteDraftAttachment(fileId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/DesignerChat/attachments/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteDraftAttachment(_response);
        });
    }

    protected processDeleteDraftAttachment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getAttachmentDownload(sessionId: string, fileId: string, signal?: AbortSignal): Promise<DesignerChatAttachmentDownloadModel> {
        let url_ = this.baseUrl + "/DesignerChat/sessions/{sessionId}/attachments/{fileId}";
        if (sessionId === undefined || sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAttachmentDownload(_response);
        });
    }

    protected processGetAttachmentDownload(response: Response): Promise<DesignerChatAttachmentDownloadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DesignerChatAttachmentDownloadModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignerChatAttachmentDownloadModel>(null as any);
    }

    /**
     * @return OK
     */
    getAttachmentHtml(sessionId: string, fileId: string, signal?: AbortSignal): Promise<DesignerChatHtmlContentModel> {
        let url_ = this.baseUrl + "/DesignerChat/sessions/{sessionId}/attachments/{fileId}/html";
        if (sessionId === undefined || sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAttachmentHtml(_response);
        });
    }

    protected processGetAttachmentHtml(response: Response): Promise<DesignerChatHtmlContentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DesignerChatHtmlContentModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignerChatHtmlContentModel>(null as any);
    }
}

export class EmbedDefinitionClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    get(signal?: AbortSignal): Promise<EmbedDefinitionModel[]> {
        let url_ = this.baseUrl + "/EmbedDefinition";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<EmbedDefinitionModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmbedDefinitionModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmbedDefinitionModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateEmbedDefinitionRequest | undefined, signal?: AbortSignal): Promise<EmbedDefinitionModel> {
        let url_ = this.baseUrl + "/EmbedDefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<EmbedDefinitionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmbedDefinitionModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmbedDefinitionModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(id: string, body: UpdateEmbedDefinitionRequest | undefined, signal?: AbortSignal): Promise<EmbedDefinitionModel> {
        let url_ = this.baseUrl + "/EmbedDefinition/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<EmbedDefinitionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmbedDefinitionModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmbedDefinitionModel>(null as any);
    }
}

export class EmbedDeploymentClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    get(environmentId: string, signal?: AbortSignal): Promise<EmbedDeploymentModel[]> {
        let url_ = this.baseUrl + "/EmbedDeployment/{environmentId}";
        if (environmentId === undefined || environmentId === null)
            throw new globalThis.Error("The parameter 'environmentId' must be defined.");
        url_ = url_.replace("{environmentId}", encodeURIComponent("" + environmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<EmbedDeploymentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmbedDeploymentModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmbedDeploymentModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deploy(environmentId: string, definitionId: string, body: DeployEmbedRequest | undefined, signal?: AbortSignal): Promise<ReleasePlanCreatedResult> {
        let url_ = this.baseUrl + "/EmbedDeployment/{environmentId}/{definitionId}";
        if (environmentId === undefined || environmentId === null)
            throw new globalThis.Error("The parameter 'environmentId' must be defined.");
        url_ = url_.replace("{environmentId}", encodeURIComponent("" + environmentId));
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeploy(_response);
        });
    }

    protected processDeploy(response: Response): Promise<ReleasePlanCreatedResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReleasePlanCreatedResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleasePlanCreatedResult>(null as any);
    }

    /**
     * @return OK
     */
    remove(environmentId: string, id: string, signal?: AbortSignal): Promise<ReleasePlanCreatedResult> {
        let url_ = this.baseUrl + "/EmbedDeployment/{environmentId}/{id}";
        if (environmentId === undefined || environmentId === null)
            throw new globalThis.Error("The parameter 'environmentId' must be defined.");
        url_ = url_.replace("{environmentId}", encodeURIComponent("" + environmentId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: Response): Promise<ReleasePlanCreatedResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReleasePlanCreatedResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleasePlanCreatedResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    configure(environmentId: string, id: string, body: ConfigureEmbedRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/EmbedDeployment/{environmentId}/{id}/Configuration";
        if (environmentId === undefined || environmentId === null)
            throw new globalThis.Error("The parameter 'environmentId' must be defined.");
        url_ = url_.replace("{environmentId}", encodeURIComponent("" + environmentId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConfigure(_response);
        });
    }

    protected processConfigure(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EnvironmentClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    search(body: SearchEnvironmentRequest | undefined, signal?: AbortSignal): Promise<EnvironmentModelPagingResultModel> {
        let url_ = this.baseUrl + "/Environment/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<EnvironmentModelPagingResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EnvironmentModelPagingResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnvironmentModelPagingResultModel>(null as any);
    }

    /**
     * @return OK
     */
    getById(id: string, signal?: AbortSignal): Promise<EnvironmentModel> {
        let url_ = this.baseUrl + "/Environment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<EnvironmentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EnvironmentModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnvironmentModel>(null as any);
    }

    /**
     * Updates the environment.
     * @param body (optional) 
     * @return OK
     */
    update(id: string, body: UpdateEnvironmentRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Environment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    delete(id: string, signal?: AbortSignal): Promise<ReleasePlanCreatedResult> {
        let url_ = this.baseUrl + "/Environment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<ReleasePlanCreatedResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReleasePlanCreatedResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleasePlanCreatedResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateEnvironmentCommand | undefined, signal?: AbortSignal): Promise<CreateEnvironmentCommandResult> {
        let url_ = this.baseUrl + "/Environment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<CreateEnvironmentCommandResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateEnvironmentCommandResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateEnvironmentCommandResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setAttributes(id: string, body: SetEnvironmentAttributesRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Environment/{id}/Attribute";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetAttributes(_response);
        });
    }

    protected processSetAttributes(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    removeAttribute(id: string, key: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Environment/{id}/Attribute/{key}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveAttribute(_response);
        });
    }

    protected processRemoveAttribute(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Sets the ChangeSet for the environment.
     * @param changeSetId (optional) 
     * @return OK
     */
    setChangeSet(id: string, changeSetId: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Environment/{id}/ChangeSet?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' cannot be null.");
        else if (changeSetId !== undefined)
            url_ += "changeSetId=" + encodeURIComponent("" + changeSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetChangeSet(_response);
        });
    }

    protected processSetChangeSet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets all components available to be added to an environment
     * @param body (optional) 
     * @return OK
     */
    searchComponent(body: SearchComponentRequest | undefined, signal?: AbortSignal): Promise<ComponentModelPagingResultModel> {
        let url_ = this.baseUrl + "/Environment/Component/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchComponent(_response);
        });
    }

    protected processSearchComponent(response: Response): Promise<ComponentModelPagingResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComponentModelPagingResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComponentModelPagingResultModel>(null as any);
    }

    /**
     * Sets or removes dependencies for a component in batch.
     * @param body (optional) 
     * @return OK
     */
    setDependencies(id: string, body: SetComponentDependenciesRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Environment/Component/{id}/Dependencies";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetDependencies(_response);
        });
    }

    protected processSetDependencies(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getComponentAllowedOrigins(componentId: string, signal?: AbortSignal): Promise<WebsiteOriginsModel> {
        let url_ = this.baseUrl + "/Environment/Component/{componentId}/AllowedOrigins";
        if (componentId === undefined || componentId === null)
            throw new globalThis.Error("The parameter 'componentId' must be defined.");
        url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetComponentAllowedOrigins(_response);
        });
    }

    protected processGetComponentAllowedOrigins(response: Response): Promise<WebsiteOriginsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebsiteOriginsModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebsiteOriginsModel>(null as any);
    }

    /**
     * @return OK
     */
    getEnvironmentComponentAllowedOrigins(environmentId: string, componentId: string, signal?: AbortSignal): Promise<WebsiteOriginsModel> {
        let url_ = this.baseUrl + "/Environment/{environmentId}/Component/{componentId}/AllowedOrigins";
        if (environmentId === undefined || environmentId === null)
            throw new globalThis.Error("The parameter 'environmentId' must be defined.");
        url_ = url_.replace("{environmentId}", encodeURIComponent("" + environmentId));
        if (componentId === undefined || componentId === null)
            throw new globalThis.Error("The parameter 'componentId' must be defined.");
        url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEnvironmentComponentAllowedOrigins(_response);
        });
    }

    protected processGetEnvironmentComponentAllowedOrigins(response: Response): Promise<WebsiteOriginsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebsiteOriginsModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebsiteOriginsModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setComponentAllowedOrigins(id: string, body: SetWebsiteOriginsRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Environment/Component/{id}/AllowedOrigins";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetComponentAllowedOrigins(_response);
        });
    }

    protected processSetComponentAllowedOrigins(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setEnvironmentComponentAllowedOrigins(id: string, componentId: string, body: SetWebsiteOriginsRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Environment/{id}/Component/{componentId}/AllowedOrigins";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (componentId === undefined || componentId === null)
            throw new globalThis.Error("The parameter 'componentId' must be defined.");
        url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetEnvironmentComponentAllowedOrigins(_response);
        });
    }

    protected processSetEnvironmentComponentAllowedOrigins(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setComponentRuntimeProfile(id: string, body: SetComponentRuntimeProfileRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Environment/Component/{id}/RuntimeProfile";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetComponentRuntimeProfile(_response);
        });
    }

    protected processSetComponentRuntimeProfile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Adds a component to an environment.
     * @param id The environment ID
     * @param body (optional) The add component request
     * @return OK
     */
    addEnvironmentComponent(id: string, body: AddEnvironmentComponentRequest | undefined, signal?: AbortSignal): Promise<ReleasePlanCreatedResult> {
        let url_ = this.baseUrl + "/Environment/{id}/Component";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddEnvironmentComponent(_response);
        });
    }

    protected processAddEnvironmentComponent(response: Response): Promise<ReleasePlanCreatedResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReleasePlanCreatedResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleasePlanCreatedResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setEnvironmentComponentRuntimeProfile(id: string, componentId: string, body: SetEnvironmentComponentRuntimeProfileRequest | undefined, signal?: AbortSignal): Promise<ReleasePlanCreatedResult> {
        let url_ = this.baseUrl + "/Environment/{id}/Component/{componentId}/RuntimeProfile";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (componentId === undefined || componentId === null)
            throw new globalThis.Error("The parameter 'componentId' must be defined.");
        url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetEnvironmentComponentRuntimeProfile(_response);
        });
    }

    protected processSetEnvironmentComponentRuntimeProfile(response: Response): Promise<ReleasePlanCreatedResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReleasePlanCreatedResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleasePlanCreatedResult>(null as any);
    }

    /**
     * Removes a component from an environment.
     * @param id The environment ID
     * @param componentId The component ID to remove
     * @return OK
     */
    removeEnvironmentComponent(id: string, componentId: string, signal?: AbortSignal): Promise<ReleasePlanCreatedResult> {
        let url_ = this.baseUrl + "/Environment/{id}/Component/{componentId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (componentId === undefined || componentId === null)
            throw new globalThis.Error("The parameter 'componentId' must be defined.");
        url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveEnvironmentComponent(_response);
        });
    }

    protected processRemoveEnvironmentComponent(response: Response): Promise<ReleasePlanCreatedResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReleasePlanCreatedResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleasePlanCreatedResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addEnvironmentClient(id: string, body: AddEnvironmentClientRequest | undefined, signal?: AbortSignal): Promise<ReleasePlanCreatedResult> {
        let url_ = this.baseUrl + "/Environment/{id}/Client";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddEnvironmentClient(_response);
        });
    }

    protected processAddEnvironmentClient(response: Response): Promise<ReleasePlanCreatedResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReleasePlanCreatedResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleasePlanCreatedResult>(null as any);
    }

    /**
     * @return OK
     */
    removeEnvironmentClient(id: string, clientId: string, signal?: AbortSignal): Promise<ReleasePlanCreatedResult> {
        let url_ = this.baseUrl + "/Environment/{id}/Client/{clientId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (clientId === undefined || clientId === null)
            throw new globalThis.Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveEnvironmentClient(_response);
        });
    }

    protected processRemoveEnvironmentClient(response: Response): Promise<ReleasePlanCreatedResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReleasePlanCreatedResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleasePlanCreatedResult>(null as any);
    }

    /**
     * @return OK
     */
    rotateEnvironmentClientSecret(id: string, clientId: string, signal?: AbortSignal): Promise<ReleasePlanCreatedResult> {
        let url_ = this.baseUrl + "/Environment/{id}/Client/{clientId}/Secret/Rotate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (clientId === undefined || clientId === null)
            throw new globalThis.Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRotateEnvironmentClientSecret(_response);
        });
    }

    protected processRotateEnvironmentClientSecret(response: Response): Promise<ReleasePlanCreatedResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReleasePlanCreatedResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleasePlanCreatedResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addEnvironmentApiKey(id: string, body: AddEnvironmentApiKeyRequest | undefined, signal?: AbortSignal): Promise<ReleasePlanCreatedResult> {
        let url_ = this.baseUrl + "/Environment/{id}/ApiKey";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddEnvironmentApiKey(_response);
        });
    }

    protected processAddEnvironmentApiKey(response: Response): Promise<ReleasePlanCreatedResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReleasePlanCreatedResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleasePlanCreatedResult>(null as any);
    }

    /**
     * @return OK
     */
    removeEnvironmentApiKey(id: string, apiKeyId: string, signal?: AbortSignal): Promise<ReleasePlanCreatedResult> {
        let url_ = this.baseUrl + "/Environment/{id}/ApiKey/{apiKeyId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (apiKeyId === undefined || apiKeyId === null)
            throw new globalThis.Error("The parameter 'apiKeyId' must be defined.");
        url_ = url_.replace("{apiKeyId}", encodeURIComponent("" + apiKeyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveEnvironmentApiKey(_response);
        });
    }

    protected processRemoveEnvironmentApiKey(response: Response): Promise<ReleasePlanCreatedResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReleasePlanCreatedResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleasePlanCreatedResult>(null as any);
    }

    /**
     * @return OK
     */
    rotateEnvironmentApiKeySecret(id: string, apiKeyId: string, signal?: AbortSignal): Promise<ReleasePlanCreatedResult> {
        let url_ = this.baseUrl + "/Environment/{id}/ApiKey/{apiKeyId}/Secret/Rotate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (apiKeyId === undefined || apiKeyId === null)
            throw new globalThis.Error("The parameter 'apiKeyId' must be defined.");
        url_ = url_.replace("{apiKeyId}", encodeURIComponent("" + apiKeyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRotateEnvironmentApiKeySecret(_response);
        });
    }

    protected processRotateEnvironmentApiKeySecret(response: Response): Promise<ReleasePlanCreatedResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReleasePlanCreatedResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleasePlanCreatedResult>(null as any);
    }

    /**
     * @return OK
     */
    removeComponentAttribute(id: string, componentId: string, key: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Environment/{id}/Component/{componentId}/Attribute/{key}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (componentId === undefined || componentId === null)
            throw new globalThis.Error("The parameter 'componentId' must be defined.");
        url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveComponentAttribute(_response);
        });
    }

    protected processRemoveComponentAttribute(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Adds a service connection to an environment.
     * @param id The environment ID
     * @param body (optional) The add component request
     * @return OK
     */
    addServiceConnection(id: string, body: AddServiceConnectionRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Environment/{id}/ServiceConnection";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddServiceConnection(_response);
        });
    }

    protected processAddServiceConnection(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Removes a service connection from an environment.
     * @param id The environment ID
     * @param serviceConnectionId The component ID to remove
     * @return OK
     */
    removeServiceConnection(id: string, serviceConnectionId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Environment/{id}/ServiceConnection/{serviceConnectionId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (serviceConnectionId === undefined || serviceConnectionId === null)
            throw new globalThis.Error("The parameter 'serviceConnectionId' must be defined.");
        url_ = url_.replace("{serviceConnectionId}", encodeURIComponent("" + serviceConnectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveServiceConnection(_response);
        });
    }

    protected processRemoveServiceConnection(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Promote this environment to another environment.
     * @param id The environment ID
     * @param targetEnvironmentId (optional) The add component request
     * @return OK
     */
    promote(id: string, targetEnvironmentId: string | undefined, signal?: AbortSignal): Promise<ReleasePlanCreatedResult> {
        let url_ = this.baseUrl + "/Environment/{id}/Promote?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (targetEnvironmentId === null)
            throw new globalThis.Error("The parameter 'targetEnvironmentId' cannot be null.");
        else if (targetEnvironmentId !== undefined)
            url_ += "targetEnvironmentId=" + encodeURIComponent("" + targetEnvironmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPromote(_response);
        });
    }

    protected processPromote(response: Response): Promise<ReleasePlanCreatedResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReleasePlanCreatedResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleasePlanCreatedResult>(null as any);
    }

    /**
     * Removes a component.
     * @param id The component ID
     * @return OK
     */
    removeComponent(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Environment/Component/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveComponent(_response);
        });
    }

    protected processRemoveComponent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getReleasePlanById(id: string, signal?: AbortSignal): Promise<ReleasePlanModel> {
        let url_ = this.baseUrl + "/Environment/ReleasePlan/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReleasePlanById(_response);
        });
    }

    protected processGetReleasePlanById(response: Response): Promise<ReleasePlanModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReleasePlanModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleasePlanModel>(null as any);
    }

    /**
     * Delete the release plan.
     * @return OK
     */
    deleteReleasePlan(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Environment/ReleasePlan/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteReleasePlan(_response);
        });
    }

    protected processDeleteReleasePlan(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search for release plans
     * @param body (optional) 
     * @return OK
     */
    searchReleasePlan(body: SearchReleasePlanRequest | undefined, signal?: AbortSignal): Promise<ReleasePlanModelPagingResultModel> {
        let url_ = this.baseUrl + "/Environment/ReleasePlan/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchReleasePlan(_response);
        });
    }

    protected processSearchReleasePlan(response: Response): Promise<ReleasePlanModelPagingResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReleasePlanModelPagingResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleasePlanModelPagingResultModel>(null as any);
    }

    /**
     * Re-run the release plan.
     * @return OK
     */
    rerunReleasePlan(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Environment/ReleasePlan/{id}/Rerun";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRerunReleasePlan(_response);
        });
    }

    protected processRerunReleasePlan(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search for container images
     * @param body (optional) The search criteria
     * @return OK
     */
    search2(body: SearchContainerImageRequest | undefined, signal?: AbortSignal): Promise<ContainerImageModelPagingResultModel> {
        let url_ = this.baseUrl + "/Environment/ContainerImage/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch2(_response);
        });
    }

    protected processSearch2(response: Response): Promise<ContainerImageModelPagingResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContainerImageModelPagingResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContainerImageModelPagingResultModel>(null as any);
    }

    /**
     * Gets a container image by ID.
     * @return OK
     */
    containerImageGet(id: string, signal?: AbortSignal): Promise<ContainerImageModel> {
        let url_ = this.baseUrl + "/Environment/ContainerImage/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processContainerImageGet(_response);
        });
    }

    protected processContainerImageGet(response: Response): Promise<ContainerImageModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContainerImageModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContainerImageModel>(null as any);
    }

    /**
     * Adds a version to a container image.
     * @param id The container image ID
     * @param body (optional) The add version request
     * @return OK
     */
    addVersion(id: string, body: AddContainerImageVersionRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Environment/ContainerImage/{id}/Versions";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddVersion(_response);
        });
    }

    protected processAddVersion(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EnvironmentEmbedClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    get(environmentId: string, signal?: AbortSignal): Promise<EnvironmentEmbedModel[]> {
        let url_ = this.baseUrl + "/EnvironmentEmbed/{environmentId}";
        if (environmentId === undefined || environmentId === null)
            throw new globalThis.Error("The parameter 'environmentId' must be defined.");
        url_ = url_.replace("{environmentId}", encodeURIComponent("" + environmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<EnvironmentEmbedModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EnvironmentEmbedModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnvironmentEmbedModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(environmentId: string, body: EnvironmentEmbedRequest | undefined, signal?: AbortSignal): Promise<EnvironmentEmbedModel> {
        let url_ = this.baseUrl + "/EnvironmentEmbed/{environmentId}";
        if (environmentId === undefined || environmentId === null)
            throw new globalThis.Error("The parameter 'environmentId' must be defined.");
        url_ = url_.replace("{environmentId}", encodeURIComponent("" + environmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<EnvironmentEmbedModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EnvironmentEmbedModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnvironmentEmbedModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(environmentId: string, id: string, body: EnvironmentEmbedRequest | undefined, signal?: AbortSignal): Promise<EnvironmentEmbedModel> {
        let url_ = this.baseUrl + "/EnvironmentEmbed/{environmentId}/{id}";
        if (environmentId === undefined || environmentId === null)
            throw new globalThis.Error("The parameter 'environmentId' must be defined.");
        url_ = url_.replace("{environmentId}", encodeURIComponent("" + environmentId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<EnvironmentEmbedModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EnvironmentEmbedModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnvironmentEmbedModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rotate(environmentId: string, id: string, body: RotateEnvironmentEmbedRequest | undefined, signal?: AbortSignal): Promise<EnvironmentEmbedModel> {
        let url_ = this.baseUrl + "/EnvironmentEmbed/{environmentId}/{id}/Rotate";
        if (environmentId === undefined || environmentId === null)
            throw new globalThis.Error("The parameter 'environmentId' must be defined.");
        url_ = url_.replace("{environmentId}", encodeURIComponent("" + environmentId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRotate(_response);
        });
    }

    protected processRotate(response: Response): Promise<EnvironmentEmbedModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EnvironmentEmbedModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnvironmentEmbedModel>(null as any);
    }
}

export class FileClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param includeSystemFiles (optional) 
     * @return OK
     */
    getById(id: string, includeSystemFiles: boolean | undefined, signal?: AbortSignal): Promise<FileViewModel> {
        let url_ = this.baseUrl + "/File/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeSystemFiles === null)
            throw new globalThis.Error("The parameter 'includeSystemFiles' cannot be null.");
        else if (includeSystemFiles !== undefined)
            url_ += "includeSystemFiles=" + encodeURIComponent("" + includeSystemFiles) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<FileViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileViewModel>(null as any);
    }

    /**
     * @return OK
     */
    delete(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/File/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @param attributeKey (optional) 
     * @param attributeValue (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param includeSystemFiles (optional) 
     * @return OK
     */
    search(fileId: string | undefined, attributeKey: string | undefined, attributeValue: string | undefined, pageIndex: number | undefined, pageSize: number | undefined, sortBy: string | undefined, sortAscending: boolean | undefined, includeSystemFiles: boolean | undefined, signal?: AbortSignal): Promise<FileViewModelPagingResultModel> {
        let url_ = this.baseUrl + "/File?";
        if (fileId === null)
            throw new globalThis.Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        if (attributeKey === null)
            throw new globalThis.Error("The parameter 'attributeKey' cannot be null.");
        else if (attributeKey !== undefined)
            url_ += "attributeKey=" + encodeURIComponent("" + attributeKey) + "&";
        if (attributeValue === null)
            throw new globalThis.Error("The parameter 'attributeValue' cannot be null.");
        else if (attributeValue !== undefined)
            url_ += "attributeValue=" + encodeURIComponent("" + attributeValue) + "&";
        if (pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (includeSystemFiles === null)
            throw new globalThis.Error("The parameter 'includeSystemFiles' cannot be null.");
        else if (includeSystemFiles !== undefined)
            url_ += "includeSystemFiles=" + encodeURIComponent("" + includeSystemFiles) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<FileViewModelPagingResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileViewModelPagingResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileViewModelPagingResultModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @param file (optional) 
     * @param attributes (optional) 
     * @return OK
     */
    upload(body: Body3 | undefined, file: FileParameter | null | undefined, attributes: string | null | undefined, signal?: AbortSignal): Promise<FileViewModel> {
        let url_ = this.baseUrl + "/File";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (attributes !== null && attributes !== undefined)
            content_.append("attributes", attributes.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "multipart/form-data",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<FileViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setExpiry(id: string, body: FileExpirationRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/File/{id}/Expiry";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetExpiry(_response);
        });
    }

    protected processSetExpiry(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class FlowClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getConnectionBindings(id: string, signal?: AbortSignal): Promise<FlowConnectionBindingsModel> {
        let url_ = this.baseUrl + "/Flow/{id}/ConnectionBindings";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConnectionBindings(_response);
        });
    }

    protected processGetConnectionBindings(response: Response): Promise<FlowConnectionBindingsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlowConnectionBindingsModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FlowConnectionBindingsModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setConnectionPolicy(id: string, sourceConnectionId: string, body: SetFlowConnectionPolicyRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Flow/{id}/ConnectionPolicies/{sourceConnectionId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (sourceConnectionId === undefined || sourceConnectionId === null)
            throw new globalThis.Error("The parameter 'sourceConnectionId' must be defined.");
        url_ = url_.replace("{sourceConnectionId}", encodeURIComponent("" + sourceConnectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetConnectionPolicy(_response);
        });
    }

    protected processSetConnectionPolicy(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setConnectionBinding(id: string, sourceConnectionId: string, body: SetFlowConnectionBindingRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Flow/{id}/ConnectionBindings/{sourceConnectionId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (sourceConnectionId === undefined || sourceConnectionId === null)
            throw new globalThis.Error("The parameter 'sourceConnectionId' must be defined.");
        url_ = url_.replace("{sourceConnectionId}", encodeURIComponent("" + sourceConnectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetConnectionBinding(_response);
        });
    }

    protected processSetConnectionBinding(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    removeConnectionBinding(id: string, sourceConnectionId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Flow/{id}/ConnectionBindings/{sourceConnectionId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (sourceConnectionId === undefined || sourceConnectionId === null)
            throw new globalThis.Error("The parameter 'sourceConnectionId' must be defined.");
        url_ = url_.replace("{sourceConnectionId}", encodeURIComponent("" + sourceConnectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveConnectionBinding(_response);
        });
    }

    protected processRemoveConnectionBinding(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getMetadata(signal?: AbortSignal): Promise<FlowMetadataModel> {
        let url_ = this.baseUrl + "/Flow/Metadata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMetadata(_response);
        });
    }

    protected processGetMetadata(response: Response): Promise<FlowMetadataModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlowMetadataModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FlowMetadataModel>(null as any);
    }

    /**
     * @return OK
     */
    getById(id: string, signal?: AbortSignal): Promise<FlowViewModel> {
        let url_ = this.baseUrl + "/Flow/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<FlowViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlowViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FlowViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(id: string, body: UpdateFlowRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Flow/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    delete(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Flow/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param name (optional) 
     * @param includeTags (optional) 
     * @param excludeTags (optional) 
     * @return OK
     */
    search(pageIndex: number | undefined, pageSize: number | undefined, sortBy: string | undefined, sortAscending: boolean | undefined, name: string | undefined, includeTags: string[] | undefined, excludeTags: string[] | undefined, signal?: AbortSignal): Promise<FlowViewModelPagingResultModel> {
        let url_ = this.baseUrl + "/Flow?";
        if (pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (includeTags === null)
            throw new globalThis.Error("The parameter 'includeTags' cannot be null.");
        else if (includeTags !== undefined)
            includeTags && includeTags.forEach(item => { url_ += "includeTags=" + encodeURIComponent("" + item) + "&"; });
        if (excludeTags === null)
            throw new globalThis.Error("The parameter 'excludeTags' cannot be null.");
        else if (excludeTags !== undefined)
            excludeTags && excludeTags.forEach(item => { url_ += "excludeTags=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<FlowViewModelPagingResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlowViewModelPagingResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FlowViewModelPagingResultModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateFlowRequest | undefined, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/Flow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    addTag(id: string, tag: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Flow/{id}/Tags/{tag}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tag === undefined || tag === null)
            throw new globalThis.Error("The parameter 'tag' must be defined.");
        url_ = url_.replace("{tag}", encodeURIComponent("" + tag));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddTag(_response);
        });
    }

    protected processAddTag(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    removeTag(id: string, tag: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Flow/{id}/Tags/{tag}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tag === undefined || tag === null)
            throw new globalThis.Error("The parameter 'tag' must be defined.");
        url_ = url_.replace("{tag}", encodeURIComponent("" + tag));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveTag(_response);
        });
    }

    protected processRemoveTag(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getContexts(signal?: AbortSignal): Promise<ContextMetadataModel[]> {
        let url_ = this.baseUrl + "/Flow/Context";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetContexts(_response);
        });
    }

    protected processGetContexts(response: Response): Promise<ContextMetadataModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContextMetadataModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContextMetadataModel[]>(null as any);
    }

    /**
     * @return OK
     */
    getEntities(contextId: string, signal?: AbortSignal): Promise<EntityMetadataModel[]> {
        let url_ = this.baseUrl + "/Flow/EntitySchema/{contextId}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEntities(_response);
        });
    }

    protected processGetEntities(response: Response): Promise<EntityMetadataModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityMetadataModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityMetadataModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getEntitiesByIds(contextId: string, body: BatchEntityIdsRequest | undefined, signal?: AbortSignal): Promise<EntityMetadataModel[]> {
        let url_ = this.baseUrl + "/Flow/EntitySchema/{contextId}/batch";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEntitiesByIds(_response);
        });
    }

    protected processGetEntitiesByIds(response: Response): Promise<EntityMetadataModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityMetadataModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityMetadataModel[]>(null as any);
    }

    /**
     * @param includeNestedTypes (optional) 
     * @return OK
     */
    getEntityById(contextId: string, id: string, includeNestedTypes: boolean | undefined, signal?: AbortSignal): Promise<EntityMetadataModel> {
        let url_ = this.baseUrl + "/Flow/EntitySchema/{contextId}/{id}?";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeNestedTypes === null)
            throw new globalThis.Error("The parameter 'includeNestedTypes' cannot be null.");
        else if (includeNestedTypes !== undefined)
            url_ += "includeNestedTypes=" + encodeURIComponent("" + includeNestedTypes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEntityById(_response);
        });
    }

    protected processGetEntityById(response: Response): Promise<EntityMetadataModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityMetadataModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityMetadataModel>(null as any);
    }

    /**
     * @return OK
     */
    getOperations(contextId: string, signal?: AbortSignal): Promise<OperationMetadataModel[]> {
        let url_ = this.baseUrl + "/Flow/Operation/{contextId}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOperations(_response);
        });
    }

    protected processGetOperations(response: Response): Promise<OperationMetadataModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OperationMetadataModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OperationMetadataModel[]>(null as any);
    }

    /**
     * @param includeNestedTypes (optional) 
     * @return OK
     */
    getOperationById(contextId: string, id: string, includeNestedTypes: boolean | undefined, signal?: AbortSignal): Promise<OperationMetadataModel> {
        let url_ = this.baseUrl + "/Flow/Operation/{contextId}/{id}?";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeNestedTypes === null)
            throw new globalThis.Error("The parameter 'includeNestedTypes' cannot be null.");
        else if (includeNestedTypes !== undefined)
            url_ += "includeNestedTypes=" + encodeURIComponent("" + includeNestedTypes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOperationById(_response);
        });
    }

    protected processGetOperationById(response: Response): Promise<OperationMetadataModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OperationMetadataModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OperationMetadataModel>(null as any);
    }

    /**
     * @param contextId (optional) 
     * @return OK
     */
    getIntegrationEvents(contextId: string | undefined, signal?: AbortSignal): Promise<IntegrationEventMetadataModel[]> {
        let url_ = this.baseUrl + "/Flow/IntegrationEvent?";
        if (contextId === null)
            throw new globalThis.Error("The parameter 'contextId' cannot be null.");
        else if (contextId !== undefined)
            url_ += "contextId=" + encodeURIComponent("" + contextId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIntegrationEvents(_response);
        });
    }

    protected processGetIntegrationEvents(response: Response): Promise<IntegrationEventMetadataModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IntegrationEventMetadataModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IntegrationEventMetadataModel[]>(null as any);
    }

    /**
     * @param includeNestedTypes (optional) 
     * @return OK
     */
    getIntegrationEventById(id: string, includeNestedTypes: boolean | undefined, signal?: AbortSignal): Promise<IntegrationEventMetadataModel> {
        let url_ = this.baseUrl + "/Flow/IntegrationEvent/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeNestedTypes === null)
            throw new globalThis.Error("The parameter 'includeNestedTypes' cannot be null.");
        else if (includeNestedTypes !== undefined)
            url_ += "includeNestedTypes=" + encodeURIComponent("" + includeNestedTypes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIntegrationEventById(_response);
        });
    }

    protected processGetIntegrationEventById(response: Response): Promise<IntegrationEventMetadataModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IntegrationEventMetadataModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IntegrationEventMetadataModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createInstance(body: RunFlowRequest | undefined, signal?: AbortSignal): Promise<ExecuteFlowResponse> {
        let url_ = this.baseUrl + "/Flow/Instance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateInstance(_response);
        });
    }

    protected processCreateInstance(response: Response): Promise<ExecuteFlowResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExecuteFlowResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExecuteFlowResponse>(null as any);
    }

    /**
     * @param environmentId (optional) 
     * @param definitionId (optional) 
     * @param createdDateFrom (optional) 
     * @param createdDateTo (optional) 
     * @param attributeKey (optional) 
     * @param attributeValue (optional) 
     * @param value (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @return OK
     */
    searchInstance(environmentId: string | undefined, definitionId: string | undefined, createdDateFrom: string | undefined, createdDateTo: string | undefined, attributeKey: string | undefined, attributeValue: string | undefined, value: string | undefined, pageIndex: number | undefined, pageSize: number | undefined, sortBy: string | undefined, sortAscending: boolean | undefined, signal?: AbortSignal): Promise<FlowInstanceViewModelPagingResultModel> {
        let url_ = this.baseUrl + "/Flow/Instance?";
        if (environmentId === null)
            throw new globalThis.Error("The parameter 'environmentId' cannot be null.");
        else if (environmentId !== undefined)
            url_ += "environmentId=" + encodeURIComponent("" + environmentId) + "&";
        if (definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' cannot be null.");
        else if (definitionId !== undefined)
            url_ += "definitionId=" + encodeURIComponent("" + definitionId) + "&";
        if (createdDateFrom === null)
            throw new globalThis.Error("The parameter 'createdDateFrom' cannot be null.");
        else if (createdDateFrom !== undefined)
            url_ += "createdDateFrom=" + encodeURIComponent("" + createdDateFrom) + "&";
        if (createdDateTo === null)
            throw new globalThis.Error("The parameter 'createdDateTo' cannot be null.");
        else if (createdDateTo !== undefined)
            url_ += "createdDateTo=" + encodeURIComponent("" + createdDateTo) + "&";
        if (attributeKey === null)
            throw new globalThis.Error("The parameter 'attributeKey' cannot be null.");
        else if (attributeKey !== undefined)
            url_ += "attributeKey=" + encodeURIComponent("" + attributeKey) + "&";
        if (attributeValue === null)
            throw new globalThis.Error("The parameter 'attributeValue' cannot be null.");
        else if (attributeValue !== undefined)
            url_ += "attributeValue=" + encodeURIComponent("" + attributeValue) + "&";
        if (value === null)
            throw new globalThis.Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        if (pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchInstance(_response);
        });
    }

    protected processSearchInstance(response: Response): Promise<FlowInstanceViewModelPagingResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlowInstanceViewModelPagingResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FlowInstanceViewModelPagingResultModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resumeInstance(id: string, body: ResumeFlowRequest | undefined, signal?: AbortSignal): Promise<ExecuteFlowResponse> {
        let url_ = this.baseUrl + "/Flow/Instance/{id}/Resume";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResumeInstance(_response);
        });
    }

    protected processResumeInstance(response: Response): Promise<ExecuteFlowResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExecuteFlowResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExecuteFlowResponse>(null as any);
    }

    /**
     * @return No Content
     */
    cancelInstance(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Flow/Instance/{id}/Cancel";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelInstance(_response);
        });
    }

    protected processCancelInstance(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateInstance(id: string, body: UpdateFlowInstanceRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Flow/Instance/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateInstance(_response);
        });
    }

    protected processUpdateInstance(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get a flow instance by ID.
     * @param includeExecutionDetails (optional) 
     * @return OK
     */
    getInstanceById(id: string, includeExecutionDetails: boolean | undefined, signal?: AbortSignal): Promise<FlowInstanceModel> {
        let url_ = this.baseUrl + "/Flow/Instance/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeExecutionDetails === null)
            throw new globalThis.Error("The parameter 'includeExecutionDetails' cannot be null.");
        else if (includeExecutionDetails !== undefined)
            url_ += "includeExecutionDetails=" + encodeURIComponent("" + includeExecutionDetails) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInstanceById(_response);
        });
    }

    protected processGetInstanceById(response: Response): Promise<FlowInstanceModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlowInstanceModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FlowInstanceModel>(null as any);
    }

    /**
     * Delete a flow instance by ID.
     * @return OK
     */
    deleteInstance(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Flow/Instance/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteInstance(_response);
        });
    }

    protected processDeleteInstance(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get flow instance runs for a specific flow instance.
     * @return OK
     */
    getInstanceRuns(id: string, signal?: AbortSignal): Promise<FlowInstanceRunModel[]> {
        let url_ = this.baseUrl + "/Flow/Instance/{id}/Run";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInstanceRuns(_response);
        });
    }

    protected processGetInstanceRuns(response: Response): Promise<FlowInstanceRunModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlowInstanceRunModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FlowInstanceRunModel[]>(null as any);
    }

    /**
     * Delete a flow instance run.
     * @return OK
     */
    deleteInstanceRun(id: string, runId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Flow/Instance/{id}/Run/{runId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (runId === undefined || runId === null)
            throw new globalThis.Error("The parameter 'runId' must be defined.");
        url_ = url_.replace("{runId}", encodeURIComponent("" + runId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteInstanceRun(_response);
        });
    }

    protected processDeleteInstanceRun(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class IntegrationEventsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param contextId (optional) 
     * @param tag (optional) 
     * @return OK
     */
    search(contextId: string | undefined, tag: string | undefined, signal?: AbortSignal): Promise<IntegrationEventAndPayloadModel[]> {
        let url_ = this.baseUrl + "/IntegrationEvents?";
        if (contextId === null)
            throw new globalThis.Error("The parameter 'contextId' cannot be null.");
        else if (contextId !== undefined)
            url_ += "contextId=" + encodeURIComponent("" + contextId) + "&";
        if (tag === null)
            throw new globalThis.Error("The parameter 'tag' cannot be null.");
        else if (tag !== undefined)
            url_ += "tag=" + encodeURIComponent("" + tag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<IntegrationEventAndPayloadModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IntegrationEventAndPayloadModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IntegrationEventAndPayloadModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateNewIntegrationEventModel | undefined, signal?: AbortSignal): Promise<IntegrationEventModel> {
        let url_ = this.baseUrl + "/IntegrationEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<IntegrationEventModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IntegrationEventModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IntegrationEventModel>(null as any);
    }

    /**
     * @return OK
     */
    getById(id: string, signal?: AbortSignal): Promise<IntegrationEventModel> {
        let url_ = this.baseUrl + "/IntegrationEvents/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<IntegrationEventModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IntegrationEventModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IntegrationEventModel>(null as any);
    }

    /**
     * @return OK
     */
    deleteById(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/IntegrationEvents/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteById(_response);
        });
    }

    protected processDeleteById(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateById(id: string, body: UpdateIntegrationEventModel | undefined, signal?: AbortSignal): Promise<IntegrationEventModel> {
        let url_ = this.baseUrl + "/IntegrationEvents/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateById(_response);
        });
    }

    protected processUpdateById(response: Response): Promise<IntegrationEventModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IntegrationEventModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IntegrationEventModel>(null as any);
    }
}

export class OperationsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getById(contextId: string, id: string, signal?: AbortSignal): Promise<DeepOperationModel> {
        let url_ = this.baseUrl + "/Operations/{contextId}/{id}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<DeepOperationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeepOperationModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeepOperationModel>(null as any);
    }

    /**
     * @return OK
     */
    deleteOperation(contextId: string, id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Operations/{contextId}/{id}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteOperation(_response);
        });
    }

    protected processDeleteOperation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getByOperationName(contextId: string, operationName: string, signal?: AbortSignal): Promise<DeepOperationModel> {
        let url_ = this.baseUrl + "/Operations/{contextId}/{operationName}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (operationName === undefined || operationName === null)
            throw new globalThis.Error("The parameter 'operationName' must be defined.");
        url_ = url_.replace("{operationName}", encodeURIComponent("" + operationName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByOperationName(_response);
        });
    }

    protected processGetByOperationName(response: Response): Promise<DeepOperationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeepOperationModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeepOperationModel>(null as any);
    }

    /**
     * @return OK
     */
    getOperationsForContext(contextId: string, signal?: AbortSignal): Promise<DeepOperationModel[]> {
        let url_ = this.baseUrl + "/Operations/{contextId}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOperationsForContext(_response);
        });
    }

    protected processGetOperationsForContext(response: Response): Promise<DeepOperationModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeepOperationModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeepOperationModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOperation(contextId: string, body: NewOperationModel | undefined, signal?: AbortSignal): Promise<OperationModel> {
        let url_ = this.baseUrl + "/Operations/{contextId}";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateOperation(_response);
        });
    }

    protected processCreateOperation(response: Response): Promise<OperationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OperationModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OperationModel>(null as any);
    }

    /**
     * @return OK
     */
    getBySchemaName(schemaName: string, signal?: AbortSignal): Promise<DeepOperationModel> {
        let url_ = this.baseUrl + "/Operations/{schemaName}";
        if (schemaName === undefined || schemaName === null)
            throw new globalThis.Error("The parameter 'schemaName' must be defined.");
        url_ = url_.replace("{schemaName}", encodeURIComponent("" + schemaName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBySchemaName(_response);
        });
    }

    protected processGetBySchemaName(response: Response): Promise<DeepOperationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeepOperationModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeepOperationModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    createOperationOld(contextId: string, body: NewOperationModel | undefined, signal?: AbortSignal): Promise<OperationModel> {
        let url_ = this.baseUrl + "/Operations/{contextId}/operations";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateOperationOld(_response);
        });
    }

    protected processCreateOperationOld(response: Response): Promise<OperationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OperationModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OperationModel>(null as any);
    }

    /**
     * @return OK
     */
    getOperationExecutionTypes(signal?: AbortSignal): Promise<OperationExecutionTypeModel[]> {
        let url_ = this.baseUrl + "/Operations/executionTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOperationExecutionTypes(_response);
        });
    }

    protected processGetOperationExecutionTypes(response: Response): Promise<OperationExecutionTypeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OperationExecutionTypeModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OperationExecutionTypeModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setScopes(operationId: string, body: string[] | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Operations/{operationId}/Scopes";
        if (operationId === undefined || operationId === null)
            throw new globalThis.Error("The parameter 'operationId' must be defined.");
        url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetScopes(_response);
        });
    }

    protected processSetScopes(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setExposure(operationId: string, body: OperationExposureModel | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Operations/{operationId}/Exposure";
        if (operationId === undefined || operationId === null)
            throw new globalThis.Error("The parameter 'operationId' must be defined.");
        url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetExposure(_response);
        });
    }

    protected processSetExposure(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateOperation(operationId: string, body: UpdateOperationModel | undefined, signal?: AbortSignal): Promise<OperationModel> {
        let url_ = this.baseUrl + "/Operations/{operationId}";
        if (operationId === undefined || operationId === null)
            throw new globalThis.Error("The parameter 'operationId' must be defined.");
        url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateOperation(_response);
        });
    }

    protected processUpdateOperation(response: Response): Promise<OperationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OperationModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OperationModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    renameOperation(contextId: string, operationId: string, body: RenameOperationRequest | undefined, signal?: AbortSignal): Promise<RenameOperationResult> {
        let url_ = this.baseUrl + "/Operations/{contextId}/{operationId}/Name";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined.");
        url_ = url_.replace("{contextId}", encodeURIComponent("" + contextId));
        if (operationId === undefined || operationId === null)
            throw new globalThis.Error("The parameter 'operationId' must be defined.");
        url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRenameOperation(_response);
        });
    }

    protected processRenameOperation(response: Response): Promise<RenameOperationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenameOperationResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RenameOperationResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateDescription(operationId: string, body: UpdateDescriptionModel | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Operations/{operationId}/Description";
        if (operationId === undefined || operationId === null)
            throw new globalThis.Error("The parameter 'operationId' must be defined.");
        url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateDescription(_response);
        });
    }

    protected processUpdateDescription(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PermissionAdministrationClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getPermissions(filter: string | undefined, signal?: AbortSignal): Promise<PermissionModel[]> {
        let url_ = this.baseUrl + "/PermissionAdministration/Permissions?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPermissions(_response);
        });
    }

    protected processGetPermissions(response: Response): Promise<PermissionModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PermissionModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PermissionModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createPermission(body: CreatePermissionCommand | undefined, signal?: AbortSignal): Promise<PermissionModel> {
        let url_ = this.baseUrl + "/PermissionAdministration/Permissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePermission(_response);
        });
    }

    protected processCreatePermission(response: Response): Promise<PermissionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PermissionModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PermissionModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    searchPermissions(body: PermissionAdministrationSearchRequest | undefined, signal?: AbortSignal): Promise<PermissionModelPermissionAdministrationSearchResultModel> {
        let url_ = this.baseUrl + "/PermissionAdministration/Permissions/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchPermissions(_response);
        });
    }

    protected processSearchPermissions(response: Response): Promise<PermissionModelPermissionAdministrationSearchResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PermissionModelPermissionAdministrationSearchResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PermissionModelPermissionAdministrationSearchResultModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updatePermission(id: string, body: UpdatePermissionCommand | undefined, signal?: AbortSignal): Promise<PermissionModel> {
        let url_ = this.baseUrl + "/PermissionAdministration/Permissions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePermission(_response);
        });
    }

    protected processUpdatePermission(response: Response): Promise<PermissionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PermissionModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PermissionModel>(null as any);
    }

    /**
     * @return OK
     */
    deletePermission(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/PermissionAdministration/Permissions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeletePermission(_response);
        });
    }

    protected processDeletePermission(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getRoles(filter: string | undefined, signal?: AbortSignal): Promise<RoleModel[]> {
        let url_ = this.baseUrl + "/PermissionAdministration/Roles?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: Response): Promise<RoleModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createRole(body: CreateRoleCommand | undefined, signal?: AbortSignal): Promise<RoleModel> {
        let url_ = this.baseUrl + "/PermissionAdministration/Roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRole(_response);
        });
    }

    protected processCreateRole(response: Response): Promise<RoleModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    searchRoles(body: PermissionAdministrationSearchRequest | undefined, signal?: AbortSignal): Promise<RoleModelPermissionAdministrationSearchResultModel> {
        let url_ = this.baseUrl + "/PermissionAdministration/Roles/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchRoles(_response);
        });
    }

    protected processSearchRoles(response: Response): Promise<RoleModelPermissionAdministrationSearchResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleModelPermissionAdministrationSearchResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleModelPermissionAdministrationSearchResultModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateRole(id: string, body: UpdateRoleCommand | undefined, signal?: AbortSignal): Promise<RoleModel> {
        let url_ = this.baseUrl + "/PermissionAdministration/Roles/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateRole(_response);
        });
    }

    protected processUpdateRole(response: Response): Promise<RoleModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleModel>(null as any);
    }

    /**
     * @return OK
     */
    deleteRole(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/PermissionAdministration/Roles/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRole(_response);
        });
    }

    protected processDeleteRole(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    assignPermissionToRole(roleId: string, permissionId: string, signal?: AbortSignal): Promise<RoleModel> {
        let url_ = this.baseUrl + "/PermissionAdministration/Roles/{roleId}/Permissions/{permissionId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        if (permissionId === undefined || permissionId === null)
            throw new globalThis.Error("The parameter 'permissionId' must be defined.");
        url_ = url_.replace("{permissionId}", encodeURIComponent("" + permissionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssignPermissionToRole(_response);
        });
    }

    protected processAssignPermissionToRole(response: Response): Promise<RoleModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleModel>(null as any);
    }

    /**
     * @return OK
     */
    unassignPermissionFromRole(roleId: string, permissionId: string, signal?: AbortSignal): Promise<RoleModel> {
        let url_ = this.baseUrl + "/PermissionAdministration/Roles/{roleId}/Permissions/{permissionId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        if (permissionId === undefined || permissionId === null)
            throw new globalThis.Error("The parameter 'permissionId' must be defined.");
        url_ = url_.replace("{permissionId}", encodeURIComponent("" + permissionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnassignPermissionFromRole(_response);
        });
    }

    protected processUnassignPermissionFromRole(response: Response): Promise<RoleModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleModel>(null as any);
    }

    /**
     * @return OK
     */
    getObjectEffectivePermissions(objectId: string, signal?: AbortSignal): Promise<EffectivePermissionsModel> {
        let url_ = this.baseUrl + "/PermissionAdministration/Objects/{objectId}/EffectivePermissions";
        if (objectId === undefined || objectId === null)
            throw new globalThis.Error("The parameter 'objectId' must be defined.");
        url_ = url_.replace("{objectId}", encodeURIComponent("" + objectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetObjectEffectivePermissions(_response);
        });
    }

    protected processGetObjectEffectivePermissions(response: Response): Promise<EffectivePermissionsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EffectivePermissionsModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EffectivePermissionsModel>(null as any);
    }

    /**
     * @return OK
     */
    getObjectAssignedRoles(objectId: string, signal?: AbortSignal): Promise<AssignedRolesModel> {
        let url_ = this.baseUrl + "/PermissionAdministration/Objects/{objectId}/Roles";
        if (objectId === undefined || objectId === null)
            throw new globalThis.Error("The parameter 'objectId' must be defined.");
        url_ = url_.replace("{objectId}", encodeURIComponent("" + objectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetObjectAssignedRoles(_response);
        });
    }

    protected processGetObjectAssignedRoles(response: Response): Promise<AssignedRolesModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignedRolesModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignedRolesModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateObject(objectId: string, body: UpdateObjectNameRequest | undefined, signal?: AbortSignal): Promise<ObjectRolesModel> {
        let url_ = this.baseUrl + "/PermissionAdministration/Objects/{objectId}";
        if (objectId === undefined || objectId === null)
            throw new globalThis.Error("The parameter 'objectId' must be defined.");
        url_ = url_.replace("{objectId}", encodeURIComponent("" + objectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateObject(_response);
        });
    }

    protected processUpdateObject(response: Response): Promise<ObjectRolesModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ObjectRolesModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ObjectRolesModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    assignRoleToObject(objectId: string, roleId: string, body: AssignObjectRoleRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/PermissionAdministration/Objects/{objectId}/Roles/{roleId}";
        if (objectId === undefined || objectId === null)
            throw new globalThis.Error("The parameter 'objectId' must be defined.");
        url_ = url_.replace("{objectId}", encodeURIComponent("" + objectId));
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssignRoleToObject(_response);
        });
    }

    protected processAssignRoleToObject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    unassignRoleFromObject(objectId: string, roleId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/PermissionAdministration/Objects/{objectId}/Roles/{roleId}";
        if (objectId === undefined || objectId === null)
            throw new globalThis.Error("The parameter 'objectId' must be defined.");
        url_ = url_.replace("{objectId}", encodeURIComponent("" + objectId));
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnassignRoleFromObject(_response);
        });
    }

    protected processUnassignRoleFromObject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getObjectRoleMatrix(body: ObjectRoleMatrixRequest | undefined, signal?: AbortSignal): Promise<ObjectRoleMatrixModel> {
        let url_ = this.baseUrl + "/PermissionAdministration/Objects/Matrix";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetObjectRoleMatrix(_response);
        });
    }

    protected processGetObjectRoleMatrix(response: Response): Promise<ObjectRoleMatrixModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ObjectRoleMatrixModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ObjectRoleMatrixModel>(null as any);
    }
}

export class PlanningClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param searchText (optional) 
     * @param isActive (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    searchProjects(searchText: string | undefined, isActive: boolean | undefined, pageIndex: number | undefined, pageSize: number | undefined, signal?: AbortSignal): Promise<ProjectModelPagingResultModel> {
        let url_ = this.baseUrl + "/Planning/Projects?";
        if (searchText === null)
            throw new globalThis.Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (isActive === null)
            throw new globalThis.Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        if (pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchProjects(_response);
        });
    }

    protected processSearchProjects(response: Response): Promise<ProjectModelPagingResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectModelPagingResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectModelPagingResultModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createProject(body: NewProjectModel | undefined, signal?: AbortSignal): Promise<ProjectModel> {
        let url_ = this.baseUrl + "/Planning/Projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateProject(_response);
        });
    }

    protected processCreateProject(response: Response): Promise<ProjectModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectModel>(null as any);
    }

    /**
     * @return OK
     */
    getProject(projectId: string, signal?: AbortSignal): Promise<ProjectModel> {
        let url_ = this.baseUrl + "/Planning/Projects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProject(_response);
        });
    }

    protected processGetProject(response: Response): Promise<ProjectModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectModel>(null as any);
    }

    /**
     * @return OK
     */
    activateProject(projectId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Planning/Projects/{projectId}/Activate";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processActivateProject(_response);
        });
    }

    protected processActivateProject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    deactivateProject(projectId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Planning/Projects/{projectId}/Deactivate";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeactivateProject(_response);
        });
    }

    protected processDeactivateProject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param status (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    searchDomainStories(projectId: string, searchText: string | undefined, status: DomainStoryStatusModel | undefined, pageIndex: number | undefined, pageSize: number | undefined, signal?: AbortSignal): Promise<DomainStoryModelPagingResultModel> {
        let url_ = this.baseUrl + "/Planning/Projects/{projectId}/DomainStories?";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (searchText === null)
            throw new globalThis.Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchDomainStories(_response);
        });
    }

    protected processSearchDomainStories(response: Response): Promise<DomainStoryModelPagingResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DomainStoryModelPagingResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DomainStoryModelPagingResultModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createDomainStory(projectId: string, body: CreateDomainStoryRequest | undefined, signal?: AbortSignal): Promise<DomainStoryModel> {
        let url_ = this.baseUrl + "/Planning/Projects/{projectId}/DomainStories";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateDomainStory(_response);
        });
    }

    protected processCreateDomainStory(response: Response): Promise<DomainStoryModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DomainStoryModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DomainStoryModel>(null as any);
    }

    /**
     * @param name (optional) 
     * @param actorType (optional) 
     * @param status (optional) 
     * @return OK
     */
    searchActors(name: string | undefined, actorType: ActorTypeModel | undefined, status: ActorStatusModel | undefined, signal?: AbortSignal): Promise<ActorModel[]> {
        let url_ = this.baseUrl + "/Planning/Actors?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (actorType === null)
            throw new globalThis.Error("The parameter 'actorType' cannot be null.");
        else if (actorType !== undefined)
            url_ += "actorType=" + encodeURIComponent("" + actorType) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchActors(_response);
        });
    }

    protected processSearchActors(response: Response): Promise<ActorModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ActorModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActorModel[]>(null as any);
    }

    /**
     * @return OK
     */
    getDomainStoryStatements(domainStoryId: string, signal?: AbortSignal): Promise<DomainStoryStatementsModel> {
        let url_ = this.baseUrl + "/Planning/DomainStories/{domainStoryId}/Statements";
        if (domainStoryId === undefined || domainStoryId === null)
            throw new globalThis.Error("The parameter 'domainStoryId' must be defined.");
        url_ = url_.replace("{domainStoryId}", encodeURIComponent("" + domainStoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDomainStoryStatements(_response);
        });
    }

    protected processGetDomainStoryStatements(response: Response): Promise<DomainStoryStatementsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DomainStoryStatementsModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DomainStoryStatementsModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createDomainStoryStatement(domainStoryId: string, body: CreateDomainStoryStatementRequest | undefined, signal?: AbortSignal): Promise<DomainStoryStatementsModel> {
        let url_ = this.baseUrl + "/Planning/DomainStories/{domainStoryId}/Statements";
        if (domainStoryId === undefined || domainStoryId === null)
            throw new globalThis.Error("The parameter 'domainStoryId' must be defined.");
        url_ = url_.replace("{domainStoryId}", encodeURIComponent("" + domainStoryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateDomainStoryStatement(_response);
        });
    }

    protected processCreateDomainStoryStatement(response: Response): Promise<DomainStoryStatementsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DomainStoryStatementsModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DomainStoryStatementsModel>(null as any);
    }

    /**
     * @return OK
     */
    getDomainStoryStatement(domainStoryId: string, statementId: string, signal?: AbortSignal): Promise<StoryStatementModel> {
        let url_ = this.baseUrl + "/Planning/DomainStories/{domainStoryId}/Statements/{statementId}";
        if (domainStoryId === undefined || domainStoryId === null)
            throw new globalThis.Error("The parameter 'domainStoryId' must be defined.");
        url_ = url_.replace("{domainStoryId}", encodeURIComponent("" + domainStoryId));
        if (statementId === undefined || statementId === null)
            throw new globalThis.Error("The parameter 'statementId' must be defined.");
        url_ = url_.replace("{statementId}", encodeURIComponent("" + statementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDomainStoryStatement(_response);
        });
    }

    protected processGetDomainStoryStatement(response: Response): Promise<StoryStatementModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StoryStatementModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoryStatementModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateDomainStoryStatement(domainStoryId: string, statementId: string, body: UpdateDomainStoryStatementRequest | undefined, signal?: AbortSignal): Promise<DomainStoryStatementsModel> {
        let url_ = this.baseUrl + "/Planning/DomainStories/{domainStoryId}/Statements/{statementId}";
        if (domainStoryId === undefined || domainStoryId === null)
            throw new globalThis.Error("The parameter 'domainStoryId' must be defined.");
        url_ = url_.replace("{domainStoryId}", encodeURIComponent("" + domainStoryId));
        if (statementId === undefined || statementId === null)
            throw new globalThis.Error("The parameter 'statementId' must be defined.");
        url_ = url_.replace("{statementId}", encodeURIComponent("" + statementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateDomainStoryStatement(_response);
        });
    }

    protected processUpdateDomainStoryStatement(response: Response): Promise<DomainStoryStatementsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DomainStoryStatementsModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DomainStoryStatementsModel>(null as any);
    }

    /**
     * @param expectedStatementVersion (optional) 
     * @return OK
     */
    deleteDomainStoryStatement(domainStoryId: string, statementId: string, expectedStatementVersion: number | undefined, signal?: AbortSignal): Promise<DomainStoryStatementsModel> {
        let url_ = this.baseUrl + "/Planning/DomainStories/{domainStoryId}/Statements/{statementId}?";
        if (domainStoryId === undefined || domainStoryId === null)
            throw new globalThis.Error("The parameter 'domainStoryId' must be defined.");
        url_ = url_.replace("{domainStoryId}", encodeURIComponent("" + domainStoryId));
        if (statementId === undefined || statementId === null)
            throw new globalThis.Error("The parameter 'statementId' must be defined.");
        url_ = url_.replace("{statementId}", encodeURIComponent("" + statementId));
        if (expectedStatementVersion === null)
            throw new globalThis.Error("The parameter 'expectedStatementVersion' cannot be null.");
        else if (expectedStatementVersion !== undefined)
            url_ += "expectedStatementVersion=" + encodeURIComponent("" + expectedStatementVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteDomainStoryStatement(_response);
        });
    }

    protected processDeleteDomainStoryStatement(response: Response): Promise<DomainStoryStatementsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DomainStoryStatementsModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DomainStoryStatementsModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createDomainStoryStatements(domainStoryId: string, body: CreateDomainStoryStatementsRequest | undefined, signal?: AbortSignal): Promise<DomainStoryStatementsModel> {
        let url_ = this.baseUrl + "/Planning/DomainStories/{domainStoryId}/Statements/Batch";
        if (domainStoryId === undefined || domainStoryId === null)
            throw new globalThis.Error("The parameter 'domainStoryId' must be defined.");
        url_ = url_.replace("{domainStoryId}", encodeURIComponent("" + domainStoryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateDomainStoryStatements(_response);
        });
    }

    protected processCreateDomainStoryStatements(response: Response): Promise<DomainStoryStatementsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DomainStoryStatementsModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DomainStoryStatementsModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    reorderDomainStoryStatements(domainStoryId: string, body: ReorderDomainStoryStatementsRequest | undefined, signal?: AbortSignal): Promise<DomainStoryStatementsModel> {
        let url_ = this.baseUrl + "/Planning/DomainStories/{domainStoryId}/Statements/Order";
        if (domainStoryId === undefined || domainStoryId === null)
            throw new globalThis.Error("The parameter 'domainStoryId' must be defined.");
        url_ = url_.replace("{domainStoryId}", encodeURIComponent("" + domainStoryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReorderDomainStoryStatements(_response);
        });
    }

    protected processReorderDomainStoryStatements(response: Response): Promise<DomainStoryStatementsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DomainStoryStatementsModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DomainStoryStatementsModel>(null as any);
    }

    /**
     * @return OK
     */
    getDomainStoryRevisions(domainStoryId: string, signal?: AbortSignal): Promise<GetDomainStoryRevisionModel[]> {
        let url_ = this.baseUrl + "/Planning/DomainStories/{domainStoryId}/Revisions";
        if (domainStoryId === undefined || domainStoryId === null)
            throw new globalThis.Error("The parameter 'domainStoryId' must be defined.");
        url_ = url_.replace("{domainStoryId}", encodeURIComponent("" + domainStoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDomainStoryRevisions(_response);
        });
    }

    protected processGetDomainStoryRevisions(response: Response): Promise<GetDomainStoryRevisionModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetDomainStoryRevisionModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDomainStoryRevisionModel[]>(null as any);
    }

    /**
     * @return OK
     */
    getLatestDomainStoryRevision(domainStoryId: string, signal?: AbortSignal): Promise<GetDomainStoryRevisionModel> {
        let url_ = this.baseUrl + "/Planning/DomainStories/{domainStoryId}/Revisions/Latest";
        if (domainStoryId === undefined || domainStoryId === null)
            throw new globalThis.Error("The parameter 'domainStoryId' must be defined.");
        url_ = url_.replace("{domainStoryId}", encodeURIComponent("" + domainStoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLatestDomainStoryRevision(_response);
        });
    }

    protected processGetLatestDomainStoryRevision(response: Response): Promise<GetDomainStoryRevisionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetDomainStoryRevisionModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDomainStoryRevisionModel>(null as any);
    }

    /**
     * @return OK
     */
    getDomainStoryRevision(domainStoryRevisionId: string, signal?: AbortSignal): Promise<GetDomainStoryRevisionModel> {
        let url_ = this.baseUrl + "/Planning/DomainStoryRevisions/{domainStoryRevisionId}";
        if (domainStoryRevisionId === undefined || domainStoryRevisionId === null)
            throw new globalThis.Error("The parameter 'domainStoryRevisionId' must be defined.");
        url_ = url_.replace("{domainStoryRevisionId}", encodeURIComponent("" + domainStoryRevisionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDomainStoryRevision(_response);
        });
    }

    protected processGetDomainStoryRevision(response: Response): Promise<GetDomainStoryRevisionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetDomainStoryRevisionModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDomainStoryRevisionModel>(null as any);
    }
}

export class ProfileClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getProfile(signal?: AbortSignal): Promise<UserProfileModel> {
        let url_ = this.baseUrl + "/Profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProfile(_response);
        });
    }

    protected processGetProfile(response: Response): Promise<UserProfileModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserProfileModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfileModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateProfile(body: UpdateUserProfileRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProfile(_response);
        });
    }

    protected processUpdateProfile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createInvitation(body: CreateInvitationRequest | undefined, signal?: AbortSignal): Promise<InvitationModel> {
        let url_ = this.baseUrl + "/Profile/Invitations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateInvitation(_response);
        });
    }

    protected processCreateInvitation(response: Response): Promise<InvitationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InvitationModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvitationModel>(null as any);
    }
}

export class RegistrationClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    register(body: RegisterUserRequest | undefined, signal?: AbortSignal): Promise<RegisterUserResponse> {
        let url_ = this.baseUrl + "/Registration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: Response): Promise<RegisterUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RegisterUserResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegisterUserResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    completeSocialRegistration(body: CompleteSocialRegistrationRequest | undefined, signal?: AbortSignal): Promise<RegisterUserResponse> {
        let url_ = this.baseUrl + "/Registration/Social";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCompleteSocialRegistration(_response);
        });
    }

    protected processCompleteSocialRegistration(response: Response): Promise<RegisterUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RegisterUserResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegisterUserResponse>(null as any);
    }
}

export class ServiceConnectionClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getMetadata(signal?: AbortSignal): Promise<ServiceConnectionMetadataModel[]> {
        let url_ = this.baseUrl + "/ServiceConnection/Metadata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMetadata(_response);
        });
    }

    protected processGetMetadata(response: Response): Promise<ServiceConnectionMetadataModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceConnectionMetadataModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceConnectionMetadataModel[]>(null as any);
    }

    /**
     * @return OK
     */
    getManual(type: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/ServiceConnection/{type}/Manual";
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetManual(_response);
        });
    }

    protected processGetManual(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    search(body: SearchServiceConnectionRequest | undefined, signal?: AbortSignal): Promise<ServiceConnectionModelPagingResultModel> {
        let url_ = this.baseUrl + "/ServiceConnection/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<ServiceConnectionModelPagingResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceConnectionModelPagingResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceConnectionModelPagingResultModel>(null as any);
    }

    /**
     * @param includeParameters (optional) 
     * @return OK
     */
    getById(id: string, includeParameters: boolean | undefined, signal?: AbortSignal): Promise<ServiceConnectionForEditModel> {
        let url_ = this.baseUrl + "/ServiceConnection/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeParameters === null)
            throw new globalThis.Error("The parameter 'includeParameters' cannot be null.");
        else if (includeParameters !== undefined)
            url_ += "includeParameters=" + encodeURIComponent("" + includeParameters) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<ServiceConnectionForEditModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceConnectionForEditModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceConnectionForEditModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(id: string, body: UpdateServiceConnectionRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/ServiceConnection/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    delete(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/ServiceConnection/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateServiceConnectionCommand | undefined, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/ServiceConnection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param environmentId (optional) 
     * @return OK
     */
    getProperties(id: string, environmentId: string | undefined, signal?: AbortSignal): Promise<ServiceConnectionPropertyValueModel[]> {
        let url_ = this.baseUrl + "/ServiceConnection/{id}/Properties?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (environmentId === null)
            throw new globalThis.Error("The parameter 'environmentId' cannot be null.");
        else if (environmentId !== undefined)
            url_ += "environmentId=" + encodeURIComponent("" + environmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProperties(_response);
        });
    }

    protected processGetProperties(response: Response): Promise<ServiceConnectionPropertyValueModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceConnectionPropertyValueModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceConnectionPropertyValueModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getProperty(id: string, propertyName: string, body: GetServiceConnectionPropertyRequest | undefined, signal?: AbortSignal): Promise<ServiceConnectionPropertyValueModel> {
        let url_ = this.baseUrl + "/ServiceConnection/{id}/Property/{propertyName}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (propertyName === undefined || propertyName === null)
            throw new globalThis.Error("The parameter 'propertyName' must be defined.");
        url_ = url_.replace("{propertyName}", encodeURIComponent("" + propertyName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProperty(_response);
        });
    }

    protected processGetProperty(response: Response): Promise<ServiceConnectionPropertyValueModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceConnectionPropertyValueModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceConnectionPropertyValueModel>(null as any);
    }

    /**
     * @param environmentId (optional) 
     * @return OK
     */
    getParameterValueOptions(id: string, parameterName: string, environmentId: string | undefined, signal?: AbortSignal): Promise<ParameterValueOption[]> {
        let url_ = this.baseUrl + "/ServiceConnection/{id}/Parameter/{parameterName}/ValueOptions?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (parameterName === undefined || parameterName === null)
            throw new globalThis.Error("The parameter 'parameterName' must be defined.");
        url_ = url_.replace("{parameterName}", encodeURIComponent("" + parameterName));
        if (environmentId === null)
            throw new globalThis.Error("The parameter 'environmentId' cannot be null.");
        else if (environmentId !== undefined)
            url_ += "environmentId=" + encodeURIComponent("" + environmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetParameterValueOptions(_response);
        });
    }

    protected processGetParameterValueOptions(response: Response): Promise<ParameterValueOption[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ParameterValueOption[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ParameterValueOption[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getDraftParameterValueOptions(type: string, parameterName: string, body: GetDraftServiceConnectionParameterValueOptionsRequest | undefined, signal?: AbortSignal): Promise<ParameterValueOption[]> {
        let url_ = this.baseUrl + "/ServiceConnection/Metadata/{type}/Parameter/{parameterName}/ValueOptions";
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        if (parameterName === undefined || parameterName === null)
            throw new globalThis.Error("The parameter 'parameterName' must be defined.");
        url_ = url_.replace("{parameterName}", encodeURIComponent("" + parameterName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDraftParameterValueOptions(_response);
        });
    }

    protected processGetDraftParameterValueOptions(response: Response): Promise<ParameterValueOption[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ParameterValueOption[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ParameterValueOption[]>(null as any);
    }

    /**
     * @return OK
     */
    verify(id: string, signal?: AbortSignal): Promise<VerifyServiceConnectionQueryResult> {
        let url_ = this.baseUrl + "/ServiceConnection/{id}/Verify";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<VerifyServiceConnectionQueryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VerifyServiceConnectionQueryResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerifyServiceConnectionQueryResult>(null as any);
    }
}

export class UserClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param includeInactive (optional) 
     * @return OK
     */
    getUser(includeInactive: boolean | undefined, signal?: AbortSignal): Promise<UserViewModel> {
        let url_ = this.baseUrl + "/User/CurrentUser?";
        if (includeInactive === null)
            throw new globalThis.Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: Response): Promise<UserViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserViewModel>(null as any);
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param name (optional) 
     * @return OK
     */
    getUsers(pageIndex: number | undefined, pageSize: number | undefined, name: string | undefined, signal?: AbortSignal): Promise<TenantUserModelPagingResultModel> {
        let url_ = this.baseUrl + "/User?";
        if (pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: Response): Promise<TenantUserModelPagingResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TenantUserModelPagingResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantUserModelPagingResultModel>(null as any);
    }

    /**
     * Returns the selected users from the current tenant. The tenant directory is cached so callers that
    render references (such as conversation participants) do not repeatedly query the directory provider.
     * @param body (optional) 
     * @return OK
     */
    getUsersByIds(body: TenantUserIdsRequest | undefined, signal?: AbortSignal): Promise<TenantUserModel[]> {
        let url_ = this.baseUrl + "/User/ByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsersByIds(_response);
        });
    }

    protected processGetUsersByIds(response: Response): Promise<TenantUserModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TenantUserModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantUserModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateUser(userId: string, body: UpdateTenantUserRequest | undefined, signal?: AbortSignal): Promise<TenantUserModel> {
        let url_ = this.baseUrl + "/User/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: Response): Promise<TenantUserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TenantUserModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantUserModel>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    setTenant(tenantId: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/User/SetTenant?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetTenant(_response);
        });
    }

    protected processSetTenant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserInterfaceClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param changeSetId (optional) 
     * @return OK
     */
    getAppCheckpoints(definitionId: string, changeSetId: string | undefined, signal?: AbortSignal): Promise<AppCheckpointModel[]> {
        let url_ = this.baseUrl + "/UserInterface/definition/{definitionId}/checkpoints?";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        if (changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' cannot be null.");
        else if (changeSetId !== undefined)
            url_ += "changeSetId=" + encodeURIComponent("" + changeSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppCheckpoints(_response);
        });
    }

    protected processGetAppCheckpoints(response: Response): Promise<AppCheckpointModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppCheckpointModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppCheckpointModel[]>(null as any);
    }

    /**
     * @param changeSetId (optional) 
     * @return OK
     */
    compareAppCheckpoint(definitionId: string, checkpointId: string, changeSetId: string | undefined, signal?: AbortSignal): Promise<AppCheckpointComparisonModel> {
        let url_ = this.baseUrl + "/UserInterface/definition/{definitionId}/checkpoints/{checkpointId}/comparison?";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        if (checkpointId === undefined || checkpointId === null)
            throw new globalThis.Error("The parameter 'checkpointId' must be defined.");
        url_ = url_.replace("{checkpointId}", encodeURIComponent("" + checkpointId));
        if (changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' cannot be null.");
        else if (changeSetId !== undefined)
            url_ += "changeSetId=" + encodeURIComponent("" + changeSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCompareAppCheckpoint(_response);
        });
    }

    protected processCompareAppCheckpoint(response: Response): Promise<AppCheckpointComparisonModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppCheckpointComparisonModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppCheckpointComparisonModel>(null as any);
    }

    /**
     * @param changeSetId (optional) 
     * @param path (optional) 
     * @return OK
     */
    getAppCheckpointContent(definitionId: string, checkpointId: string, changeSetId: string | undefined, path: string | undefined, signal?: AbortSignal): Promise<AppCheckpointContentModel> {
        let url_ = this.baseUrl + "/UserInterface/definition/{definitionId}/checkpoints/{checkpointId}/content?";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        if (checkpointId === undefined || checkpointId === null)
            throw new globalThis.Error("The parameter 'checkpointId' must be defined.");
        url_ = url_.replace("{checkpointId}", encodeURIComponent("" + checkpointId));
        if (changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' cannot be null.");
        else if (changeSetId !== undefined)
            url_ += "changeSetId=" + encodeURIComponent("" + changeSetId) + "&";
        if (path === null)
            throw new globalThis.Error("The parameter 'path' cannot be null.");
        else if (path !== undefined)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppCheckpointContent(_response);
        });
    }

    protected processGetAppCheckpointContent(response: Response): Promise<AppCheckpointContentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppCheckpointContentModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppCheckpointContentModel>(null as any);
    }

    /**
     * @param changeSetId (optional) 
     * @param body (optional) 
     * @return OK
     */
    undoLastAppCheckpoint(definitionId: string, changeSetId: string | undefined, body: AppCheckpointUndoRequest | undefined, signal?: AbortSignal): Promise<AppCheckpointModel> {
        let url_ = this.baseUrl + "/UserInterface/definition/{definitionId}/checkpoints/undo-last?";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        if (changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' cannot be null.");
        else if (changeSetId !== undefined)
            url_ += "changeSetId=" + encodeURIComponent("" + changeSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUndoLastAppCheckpoint(_response);
        });
    }

    protected processUndoLastAppCheckpoint(response: Response): Promise<AppCheckpointModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppCheckpointModel;
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppCheckpointModel>(null as any);
    }

    /**
     * @param changeSetId (optional) 
     * @param definitionId (optional) 
     * @param name (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    search(changeSetId: string | undefined, definitionId: string | undefined, name: string | undefined, pageIndex: number | undefined, pageSize: number | undefined, signal?: AbortSignal): Promise<BundleDefinitionSummaryModelPagingResultModel> {
        let url_ = this.baseUrl + "/UserInterface?";
        if (changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' cannot be null.");
        else if (changeSetId !== undefined)
            url_ += "changeSetId=" + encodeURIComponent("" + changeSetId) + "&";
        if (definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' cannot be null.");
        else if (definitionId !== undefined)
            url_ += "definitionId=" + encodeURIComponent("" + definitionId) + "&";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<BundleDefinitionSummaryModelPagingResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BundleDefinitionSummaryModelPagingResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BundleDefinitionSummaryModelPagingResultModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateBundleDefinitionRequest | undefined, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/UserInterface";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    searchVersions(definitionId: string, pageIndex: number | undefined, pageSize: number | undefined, signal?: AbortSignal): Promise<BundleDefinitionSummaryModelPagingResultModel> {
        let url_ = this.baseUrl + "/UserInterface/{definitionId}/versions?";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        if (pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchVersions(_response);
        });
    }

    protected processSearchVersions(response: Response): Promise<BundleDefinitionSummaryModelPagingResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BundleDefinitionSummaryModelPagingResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BundleDefinitionSummaryModelPagingResultModel>(null as any);
    }

    /**
     * @param changeSetId (optional) 
     * @return OK
     */
    getByDefinitionId(definitionId: string, changeSetId: string | undefined, signal?: AbortSignal): Promise<BundleDefinitionModel> {
        let url_ = this.baseUrl + "/UserInterface/definition/{definitionId}?";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        if (changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' cannot be null.");
        else if (changeSetId !== undefined)
            url_ += "changeSetId=" + encodeURIComponent("" + changeSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByDefinitionId(_response);
        });
    }

    protected processGetByDefinitionId(response: Response): Promise<BundleDefinitionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BundleDefinitionModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BundleDefinitionModel>(null as any);
    }

    /**
     * @param changeSetId (optional) 
     * @return OK
     */
    getReactSourceFiles(definitionId: string, changeSetId: string | undefined, signal?: AbortSignal): Promise<ReactSourceFileModel[]> {
        let url_ = this.baseUrl + "/UserInterface/definition/{definitionId}/source-files?";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        if (changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' cannot be null.");
        else if (changeSetId !== undefined)
            url_ += "changeSetId=" + encodeURIComponent("" + changeSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReactSourceFiles(_response);
        });
    }

    protected processGetReactSourceFiles(response: Response): Promise<ReactSourceFileModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReactSourceFileModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReactSourceFileModel[]>(null as any);
    }

    /**
     * @param changeSetId (optional) 
     * @param body (optional) 
     * @return OK
     */
    createReactSourceFile(definitionId: string, changeSetId: string | undefined, body: CreateReactSourceFileRequest | undefined, signal?: AbortSignal): Promise<ReactSourceFileContentModel> {
        let url_ = this.baseUrl + "/UserInterface/definition/{definitionId}/source-files?";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        if (changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' cannot be null.");
        else if (changeSetId !== undefined)
            url_ += "changeSetId=" + encodeURIComponent("" + changeSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateReactSourceFile(_response);
        });
    }

    protected processCreateReactSourceFile(response: Response): Promise<ReactSourceFileContentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReactSourceFileContentModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReactSourceFileContentModel>(null as any);
    }

    /**
     * @param changeSetId (optional) 
     * @return OK
     */
    getReactSourceFile(definitionId: string, sourceFileId: string, changeSetId: string | undefined, signal?: AbortSignal): Promise<ReactSourceFileContentModel> {
        let url_ = this.baseUrl + "/UserInterface/definition/{definitionId}/source-files/{sourceFileId}?";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        if (sourceFileId === undefined || sourceFileId === null)
            throw new globalThis.Error("The parameter 'sourceFileId' must be defined.");
        url_ = url_.replace("{sourceFileId}", encodeURIComponent("" + sourceFileId));
        if (changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' cannot be null.");
        else if (changeSetId !== undefined)
            url_ += "changeSetId=" + encodeURIComponent("" + changeSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReactSourceFile(_response);
        });
    }

    protected processGetReactSourceFile(response: Response): Promise<ReactSourceFileContentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReactSourceFileContentModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReactSourceFileContentModel>(null as any);
    }

    /**
     * @param changeSetId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateReactSourceFile(definitionId: string, sourceFileId: string, changeSetId: string | undefined, body: UpdateReactSourceFileRequest | undefined, signal?: AbortSignal): Promise<ReactSourceFileContentModel> {
        let url_ = this.baseUrl + "/UserInterface/definition/{definitionId}/source-files/{sourceFileId}?";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        if (sourceFileId === undefined || sourceFileId === null)
            throw new globalThis.Error("The parameter 'sourceFileId' must be defined.");
        url_ = url_.replace("{sourceFileId}", encodeURIComponent("" + sourceFileId));
        if (changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' cannot be null.");
        else if (changeSetId !== undefined)
            url_ += "changeSetId=" + encodeURIComponent("" + changeSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateReactSourceFile(_response);
        });
    }

    protected processUpdateReactSourceFile(response: Response): Promise<ReactSourceFileContentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReactSourceFileContentModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReactSourceFileContentModel>(null as any);
    }

    /**
     * @param changeSetId (optional) 
     * @return OK
     */
    deleteReactSourceFile(definitionId: string, sourceFileId: string, changeSetId: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/UserInterface/definition/{definitionId}/source-files/{sourceFileId}?";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        if (sourceFileId === undefined || sourceFileId === null)
            throw new globalThis.Error("The parameter 'sourceFileId' must be defined.");
        url_ = url_.replace("{sourceFileId}", encodeURIComponent("" + sourceFileId));
        if (changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' cannot be null.");
        else if (changeSetId !== undefined)
            url_ += "changeSetId=" + encodeURIComponent("" + changeSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteReactSourceFile(_response);
        });
    }

    protected processDeleteReactSourceFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param changeSetId (optional) 
     * @param body (optional) 
     * @return OK
     */
    renameReactSourceFile(definitionId: string, sourceFileId: string, changeSetId: string | undefined, body: RenameReactSourceFileRequest | undefined, signal?: AbortSignal): Promise<ReactSourceFileContentModel> {
        let url_ = this.baseUrl + "/UserInterface/definition/{definitionId}/source-files/{sourceFileId}/rename?";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        if (sourceFileId === undefined || sourceFileId === null)
            throw new globalThis.Error("The parameter 'sourceFileId' must be defined.");
        url_ = url_.replace("{sourceFileId}", encodeURIComponent("" + sourceFileId));
        if (changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' cannot be null.");
        else if (changeSetId !== undefined)
            url_ += "changeSetId=" + encodeURIComponent("" + changeSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRenameReactSourceFile(_response);
        });
    }

    protected processRenameReactSourceFile(response: Response): Promise<ReactSourceFileContentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReactSourceFileContentModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReactSourceFileContentModel>(null as any);
    }

    /**
     * @param changeSetId (optional) 
     * @param body (optional) 
     * @return OK
     */
    renameReactSourceFolder(definitionId: string, changeSetId: string | undefined, body: RenameReactSourceFolderRequest | undefined, signal?: AbortSignal): Promise<RenameReactSourceFolderResultModel> {
        let url_ = this.baseUrl + "/UserInterface/definition/{definitionId}/source-folders/rename?";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        if (changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' cannot be null.");
        else if (changeSetId !== undefined)
            url_ += "changeSetId=" + encodeURIComponent("" + changeSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRenameReactSourceFolder(_response);
        });
    }

    protected processRenameReactSourceFolder(response: Response): Promise<RenameReactSourceFolderResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenameReactSourceFolderResultModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RenameReactSourceFolderResultModel>(null as any);
    }

    /**
     * @param changeSetId (optional) 
     * @return OK
     */
    getReactCodeStatus(definitionId: string, changeSetId: string | undefined, signal?: AbortSignal): Promise<ReactCodeStatusModel> {
        let url_ = this.baseUrl + "/UserInterface/definition/{definitionId}/react-code/status?";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        if (changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' cannot be null.");
        else if (changeSetId !== undefined)
            url_ += "changeSetId=" + encodeURIComponent("" + changeSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReactCodeStatus(_response);
        });
    }

    protected processGetReactCodeStatus(response: Response): Promise<ReactCodeStatusModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReactCodeStatusModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReactCodeStatusModel>(null as any);
    }

    /**
     * @param changeSetId (optional) 
     * @return OK
     */
    downloadReactCode(definitionId: string, changeSetId: string | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/UserInterface/definition/{definitionId}/react-code/download?";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        if (changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' cannot be null.");
        else if (changeSetId !== undefined)
            url_ += "changeSetId=" + encodeURIComponent("" + changeSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadReactCode(_response);
        });
    }

    protected processDownloadReactCode(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param changeSetId (optional) 
     * @return OK
     */
    compileReactCode(definitionId: string, changeSetId: string | undefined, signal?: AbortSignal): Promise<ReactCodeStatusModel> {
        let url_ = this.baseUrl + "/UserInterface/definition/{definitionId}/react-code/compile?";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        if (changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' cannot be null.");
        else if (changeSetId !== undefined)
            url_ += "changeSetId=" + encodeURIComponent("" + changeSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCompileReactCode(_response);
        });
    }

    protected processCompileReactCode(response: Response): Promise<ReactCodeStatusModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReactCodeStatusModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReactCodeStatusModel>(null as any);
    }

    /**
     * @param changeSetId (optional) 
     * @return OK
     */
    publishReactCode(definitionId: string, changeSetId: string | undefined, signal?: AbortSignal): Promise<ReactCodeStatusModel> {
        let url_ = this.baseUrl + "/UserInterface/definition/{definitionId}/react-code/publish?";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        if (changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' cannot be null.");
        else if (changeSetId !== undefined)
            url_ += "changeSetId=" + encodeURIComponent("" + changeSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPublishReactCode(_response);
        });
    }

    protected processPublishReactCode(response: Response): Promise<ReactCodeStatusModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReactCodeStatusModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReactCodeStatusModel>(null as any);
    }

    /**
     * @param changeSetId (optional) 
     * @param buildId (optional) 
     * @return OK
     */
    buildAndPublishReactCode(definitionId: string, changeSetId: string | undefined, buildId: string | undefined, signal?: AbortSignal): Promise<ReactCodeStatusModel> {
        let url_ = this.baseUrl + "/UserInterface/definition/{definitionId}/react-code/build-and-publish?";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        if (changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' cannot be null.");
        else if (changeSetId !== undefined)
            url_ += "changeSetId=" + encodeURIComponent("" + changeSetId) + "&";
        if (buildId === null)
            throw new globalThis.Error("The parameter 'buildId' cannot be null.");
        else if (buildId !== undefined)
            url_ += "buildId=" + encodeURIComponent("" + buildId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBuildAndPublishReactCode(_response);
        });
    }

    protected processBuildAndPublishReactCode(response: Response): Promise<ReactCodeStatusModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReactCodeStatusModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReactCodeStatusModel>(null as any);
    }

    /**
     * @return OK
     */
    getById(id: string, signal?: AbortSignal): Promise<BundleDefinitionModel> {
        let url_ = this.baseUrl + "/UserInterface/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<BundleDefinitionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BundleDefinitionModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BundleDefinitionModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(id: string, body: UpdateBundleDefinitionRequest | undefined, signal?: AbortSignal): Promise<BundleDefinitionModel> {
        let url_ = this.baseUrl + "/UserInterface/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BundleDefinitionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BundleDefinitionModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BundleDefinitionModel>(null as any);
    }

    /**
     * @return OK
     */
    delete(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/UserInterface/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    deleteVersion(definitionId: string, id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/UserInterface/{definitionId}/versions/{id}";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteVersion(_response);
        });
    }

    protected processDeleteVersion(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getComponentMetadata(signal?: AbortSignal): Promise<ComponentMetadataModel[]> {
        let url_ = this.baseUrl + "/UserInterface/Metadata/Component";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetComponentMetadata(_response);
        });
    }

    protected processGetComponentMetadata(response: Response): Promise<ComponentMetadataModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComponentMetadataModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComponentMetadataModel[]>(null as any);
    }

    /**
     * @return OK
     */
    getExpressionMetadata(signal?: AbortSignal): Promise<ExpressionMetadataModel[]> {
        let url_ = this.baseUrl + "/UserInterface/Metadata/Expression";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExpressionMetadata(_response);
        });
    }

    protected processGetExpressionMetadata(response: Response): Promise<ExpressionMetadataModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExpressionMetadataModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpressionMetadataModel[]>(null as any);
    }
}

export interface ActivityMetadataModel {
    name: string;
    displayName: string;
    category?: string | undefined;
    categories: string[];
    description?: string | undefined;
    parameters: ParameterMetadata[];
    variableSets?: VariableSetMetadata[] | undefined;
    displayContent?: string | undefined;
    iconName?: string | undefined;
    iconBase64?: string | undefined;
    iconUrl?: string | undefined;
    wizardSteps?: WizardStepMetadata[] | undefined;
    isBlock?: boolean | undefined;
}

export interface ActorModel {
    id: string;
    tenantId: string;
    name: string;
    description: string;
    actorType: ActorTypeModel;
    aliases: string[];
    status: ActorStatusModel;
    createdAt: string;
    updatedAt: string;
}

export enum ActorStatusModel {
    Active = "Active",
    Archived = "Archived",
}

export enum ActorTypeModel {
    Person = "Person",
    Role = "Role",
    Team = "Team",
    Organisation = "Organisation",
    System = "System",
}

export interface AddComponentDependencyModel {
    dependsOnComponentId: string;
    targetId: string;
    targetType: string;
}

export interface AddContainerImageVersionRequest {
    version: string;
}

export interface AddContextScopeModel {
    name: string;
    description: string;
}

export interface AddEnumItemModel {
    name: string;
}

export interface AddEnvironmentApiKeyRequest {
    apiKeyId: string;
    attributes?: { [key: string]: string; } | undefined;
}

export interface AddEnvironmentClientRequest {
    clientId: string;
    attributes?: { [key: string]: string; } | undefined;
}

export interface AddEnvironmentComponentRequest {
    componentId: string;
    containerImageVersion: string;
    attributes?: { [key: string]: string; } | undefined;
    runtimeProfileOverride?: ComponentRuntimeProfileOverride | undefined;
}

export interface AddPropertyV2Model {
    name: string;
    description: string;
    propertyType: PrimitiveType;
    isRequired: boolean;
    isMultiple: boolean;
    defaultValue?: string | undefined;
    isReference: boolean;
    referenceSchemaId?: string | undefined;
    referenceSchemaContextId?: string | undefined;
    isEnum: boolean;
    enumId?: string | undefined;
    enumContextId?: string | undefined;
}

export interface AddServiceConnectionRequest {
    serviceConnectionId: string;
    serviceConnectionType: string;
    serviceConnectionCategory: string;
}

export interface AgentIdsRequest {
    ids: string[];
}

export interface AgentModel {
    id: string;
    name: string;
    isSystem: boolean;
    fileId?: string | undefined;
}

export interface AgentModelPagingResultModel {
    items: AgentModel[];
    hasNextPage: boolean;
}

export enum ApiKeyAccessChannel {
    Api = "Api",
    Mcp = "Mcp",
    ApiAndMcp = "ApiAndMcp",
    A2A = "A2A",
}

export interface IntelligentWidgetResourceManagerClientEntityModel {
    id: string;
    createdDate: string;
    updatedDate: string;
}

export interface ApiKeyDependencyModel extends IntelligentWidgetResourceManagerClientEntityModel {
    dependsOnComponentId: string;
    targetId: string;
    targetType: string;
    accessChannel: ApiKeyAccessChannel;
}

export interface ApiKeyDependencyRequest {
    dependsOnComponentId: string;
    targetId: string;
    targetType: string;
    accessChannel: ApiKeyAccessChannel;
}

export interface ApiKeyModel extends IntelligentWidgetResourceManagerClientEntityModel {
    name: string;
    code: string;
    description?: string | undefined;
    isEnabled?: boolean;
    dependencies?: ApiKeyDependencyModel[] | undefined;
}

export interface ApiKeyModelPagingResultModel {
    items: ApiKeyModel[];
    hasNextPage: boolean;
}

export interface AppCheckpointChangeModel {
    path: string;
    kind: string;
    beforeLength: number;
    afterLength: number;
}

export interface AppCheckpointComparisonModel {
    checkpoint: AppCheckpointModel;
    changes: AppCheckpointChangeModel[];
}

export interface AppCheckpointContentModel {
    path: string;
    before?: string | undefined;
    after?: string | undefined;
}

export interface AppCheckpointModel {
    id: string;
    assignmentId: string;
    appDefinitionId: string;
    changeSetId: string;
    state: string;
    revision: number;
    hasChanges: boolean;
    canUndo: boolean;
    conflict?: string | undefined;
    createdDate?: string | undefined;
    operationId?: string | undefined;
}

export interface AppCheckpointUndoRequest {
    checkpointId: string;
    expectedRevision: number;
}

export interface AssignObjectRoleRequest {
    name?: string | undefined;
    type?: string | undefined;
}

export interface AssignedRolesModel {
    objectId: string;
    name?: string | undefined;
    type?: string | undefined;
    roleIds?: string[] | undefined;
}

export interface AuditPageModel {
    items: AuditRecordModel[];
    continuationToken?: string | undefined;
}

export interface AuditRecordModel {
    id: string;
    type: string;
    timestamp: string;
    createdDate: string;
    updatedDate: string;
    actionName: string;
    source?: string | undefined;
    identityId: string;
    identityName: string;
    payload?: any | undefined;
    attributes: { [key: string]: string; };
}

export interface AuthoringResourceSummaryModel {
    id: string;
    uri: string;
    name: string;
    description: string;
    mimeType: string;
    scopeType: AuthoringResourceScopeType;
    scopeId?: string | undefined;
    targets: AuthoringResourceTarget[];
    contentHash: string;
    tags: string[];
    isEnabled: boolean;
    isMcpExposed: boolean;
    updatedAt: string;
}

export interface AuthoringResourceModel extends AuthoringResourceSummaryModel {
    content: string;
    createdAt?: string;
}

export enum AuthoringResourceScopeType {
    Tenant = "Tenant",
    SubDomain = "SubDomain",
    Context = "Context",
    App = "App",
}

export interface AuthoringResourceTarget {
    type: AuthoringResourceScopeType;
    id?: string | undefined;
}

export interface BatchEntityIdsRequest {
    ids: string[];
}

export interface BatchUpdateDomainMetadataItemModel {
    id: string;
    targetType: DomainMetadataTargetType;
    metadata: string;
    graphMetadata?: DomainArtifactMetadataModel | undefined;
}

export interface BatchUpdateDomainMetadataModel {
    items: BatchUpdateDomainMetadataItemModel[];
}

export interface BatchUpdateMetadataItemModel {
    id: string;
    metadata: string;
}

export interface BatchUpdateMetadataModel {
    items: BatchUpdateMetadataItemModel[];
}

export interface IntelligentWidgetUserInterfaceClientEntityModel {
    id: string;
    createdDate: string;
    updatedDate: string;
    createdById?: string | undefined;
    createdByName?: string | undefined;
    updatedById?: string | undefined;
    updatedByName?: string | undefined;
}

export interface BundleDefinitionSummaryModel extends IntelligentWidgetUserInterfaceClientEntityModel {
    tenantId?: string;
    definitionId?: string;
    bundleDefinitionId?: string;
    changeSetId?: string;
    versionId?: number;
    previousBundleDefinitionId?: string | undefined;
    name: string;
    tags?: string[] | undefined;
    statistics?: BundleDefinitionStatistics | undefined;
}

export interface BundleDefinitionArtifactsSummaryModel extends BundleDefinitionSummaryModel {
    hasTheme?: boolean;
    viewCount?: number;
    sharedComponentCount?: number;
    embeddedResourceCount?: number;
    viewIds?: string[] | undefined;
    sharedComponentIds?: string[] | undefined;
    embeddedResourceIds?: string[] | undefined;
}

export interface BundleDefinitionModel extends BundleDefinitionSummaryModel {
    definition: string;
}

export interface BundleDefinitionStatistics {
    viewCount: number;
    componentCount: number;
    resourceCount: number;
    operationCount: number;
    contextCount: number;
}

export interface BundleDefinitionSummaryModelPagingResultModel {
    items: BundleDefinitionSummaryModel[];
    hasNextPage: boolean;
}

export enum ChangeSetStatusesModel {
    Active = "Active",
    Cancelled = "Cancelled",
    Complete = "Complete",
}

export interface EntityModel {
    id: string;
    createdDate: string;
    updatedDate: string;
    createdById?: string | undefined;
    createdByName?: string | undefined;
    updatedById?: string | undefined;
    updatedByName?: string | undefined;
}

export interface ChangeSetViewModel extends EntityModel {
    name: string;
    description?: string | undefined;
    status: ChangeSetStatusesModel;
}

export interface ChangeSetViewModelPagingResultModel {
    items: ChangeSetViewModel[];
    hasNextPage: boolean;
}

export interface ClientDependencyModel extends IntelligentWidgetResourceManagerClientEntityModel {
    dependsOnComponentId: string;
    targetId: string;
    targetType: string;
}

export interface ClientDependencyRequest {
    dependsOnComponentId: string;
    targetId: string;
    targetType: string;
}

export interface ClientModel extends IntelligentWidgetResourceManagerClientEntityModel {
    name: string;
    code: string;
    description?: string | undefined;
    redirectUrls?: string[] | undefined;
    attributes: { [key: string]: any; };
    dependencies?: ClientDependencyModel[] | undefined;
}

export interface ClientModelPagingResultModel {
    items: ClientModel[];
    hasNextPage: boolean;
}

export interface CodeBaseAsyncOperationModel {
    operationId: string;
    codeBaseId: string;
    contextId?: string | undefined;
    operation: string;
    status: string;
    createdAt: string;
    startedAt?: string | undefined;
    completedAt?: string | undefined;
    messages: string[];
}

export interface CodeBaseDependantModel {
    dependantCodeBaseId: string;
    codeBaseType: CodeBaseTypeModel;
}

export interface CodeBaseModel {
    id: string;
    language: LanguageModel;
    languageVersion: string;
    componentName: string;
    associatedContextId?: string | undefined;
    state: CodeBaseStatesModel;
    stateChangedDate: string;
    compiledArtifactLocation: string;
    codeBaseType: CodeBaseTypeModel;
    dependants: CodeBaseDependantModel[];
    defaultDependantForCodeBaseTypes: DefaultDependantModel[];
}

export enum CodeBaseStatesModel {
    Changed = "Changed",
    Packaged = "Packaged",
    Deployed = "Deployed",
}

export enum CodeBaseTypeModel {
    Common = "Common",
    Domain = "Domain",
    Application = "Application",
    Tests = "Tests",
    React = "React",
}

export interface CodeGenArtifactModel {
    name: string;
    /** Artifact kind — see IntelligentWidget.Portal.Models.CodeGen.ArtifactTypes for valid values. */
    type: string;
    /** Mention scope prefix — see IntelligentWidget.Portal.Models.CodeGen.ArtifactScopes for valid values. */
    scope: string;
}

export interface CodeGenInstructionReponseModel {
    messages: string[];
}

export interface CodeGenInstructionsModel {
    instruction: string;
}

export interface CodeGenResourceModel {
    id: string;
    uri: string;
    name: string;
    description: string;
    mimeType: string;
    content: string;
    scopeType: CodeGenResourceScopeType;
    scopeId?: string | undefined;
    tags: string[];
    isEnabled: boolean;
    isMcpExposed: boolean;
    createdAt: string;
    updatedAt: string;
}

export enum CodeGenResourceScopeType {
    Tenant = "Tenant",
    SubDomain = "SubDomain",
    Context = "Context",
    App = "App",
}

export interface CodeGenResourceSummaryModel {
    id: string;
    uri: string;
    name: string;
    description: string;
    mimeType: string;
    scopeType: CodeGenResourceScopeType;
    scopeId?: string | undefined;
    tags: string[];
    isEnabled: boolean;
    isMcpExposed: boolean;
    updatedAt: string;
}

export interface CodeStoreFileModel {
    id: string;
    name: string;
    content: string;
    namespace: string;
    tags: TagModel[];
}

export interface CompleteSocialRegistrationRequest {
    tenantCode?: string | undefined;
    tenantName?: string | undefined;
    invitationToken?: string | undefined;
}

export interface ComponentDependencyModel {
    id: string;
    dependsOnComponentId: string;
    targetId: string;
    targetType: string;
    createdDate: string;
}

export interface ComponentMetadataModel {
    name: string;
    displayName: string;
    category?: string | undefined;
    categories: string[];
    description?: string | undefined;
    parameters: ParameterMetadata[];
    variableSets?: VariableSetMetadata[] | undefined;
    displayContent?: string | undefined;
    iconName?: string | undefined;
    iconBase64?: string | undefined;
    iconUrl?: string | undefined;
    wizardSteps?: WizardStepMetadata[] | undefined;
    isContainer?: boolean | undefined;
    isVirtual?: boolean | undefined;
}

export interface ComponentModel extends IntelligentWidgetResourceManagerClientEntityModel {
    name: string;
    containerImageName: string;
    containerImageVersion: string;
    containerImageId: string;
    contextId?: string | undefined;
    runtimeProfile: ComponentRuntimeProfile;
    runtimeProfileOverride?: ComponentRuntimeProfile | undefined;
    environmentVariables: { [key: string]: string; };
    dependencies?: ComponentDependencyModel[] | undefined;
}

export interface ComponentModelPagingResultModel {
    items: ComponentModel[];
    hasNextPage: boolean;
}

export interface ComponentRuntimeProfile {
    tier: RuntimeProfileTier;
    minInstances: number;
    maxInstances: number;
}

export interface ComponentRuntimeProfileOverride {
    tier?: RuntimeProfileTier | undefined;
    minInstances?: number | undefined;
    maxInstances?: number | undefined;
}

export interface ConfigureEmbedRequest {
    allowedOrigins: string[];
    isEnabled: boolean;
}

export interface ContainerImageModel extends IntelligentWidgetResourceManagerClientEntityModel {
    name: string;
    latestVersion: string;
    versions: string[];
    environmentVariables: { [key: string]: string; };
}

export interface ContainerImageModelPagingResultModel {
    items: ContainerImageModel[];
    hasNextPage: boolean;
}

export interface ContextArtifactCountsModel {
    contextId: string;
    entityCount: number;
    operationCount: number;
}

export interface ContextArtifactFolderAssignmentModel {
    artifactKind: string;
    artifactId: string;
    folderId?: string | undefined;
}

export interface ContextArtifactFolderModel {
    id: string;
    categoryId: string;
    name: string;
    parentFolderId?: string | undefined;
    order: number;
}

export interface ContextArtifactLayoutModel {
    folders: ContextArtifactFolderModel[];
    assignments: ContextArtifactFolderAssignmentModel[];
}

export interface ContextCodeBaseModel {
    codeBaseId: string;
    contextId: string;
    codeBaseType: ContextCodeBaseTypeModel;
}

export enum ContextCodeBaseTypeModel {
    Domain = "Domain",
    Application = "Application",
    Tests = "Tests",
}

export interface ContextDesignerCodeSnapshotModel {
    domainFiles: CodeStoreFileModel[];
    applicationFiles: CodeStoreFileModel[];
    testFiles: CodeStoreFileModel[];
    domainCodeBase?: CodeBaseModel | undefined;
    applicationCodeBase?: CodeBaseModel | undefined;
    testCodeBase?: CodeBaseModel | undefined;
}

export interface ContextDesignerSnapshotModel {
    context: ContextModel;
    artifactLayout: ContextArtifactLayoutModel;
    domainModel: DomainModelingDataModel;
    operations: DeepOperationModel[];
    operationExecutionTypes: OperationExecutionTypeModel[];
    code?: ContextDesignerCodeSnapshotModel | undefined;
}

export interface ContextEventHandlerModel {
    id: string;
    name: string;
    description: string;
    contextId: string;
    tenantId: string;
    integrationEventId: string;
    tags: string[];
}

export interface ContextMetadataModel {
    id: string;
    name: string;
}

export interface ContextModel {
    id: string;
    contextName: string;
    codeName: string;
    description?: string | undefined;
    subDomainId: string;
    codebases: ContextCodeBaseModel[];
    scopes: ContextScopeModel[];
    serviceConnections: ContextServiceConnectionModel[];
    tags: string[];
}

export interface ContextScopeModel {
    id: string;
    name: string;
    description: string;
}

export interface ContextServiceConnectionModel {
    id: string;
    contextId: string;
    serviceConnectionId: string;
    serviceConnectionType: string;
}

export interface ConversationViewModel {
    id: string;
    name: string;
    created: string;
    updated: string;
    expiresAt?: string | undefined;
    attributes?: { [key: string]: string; } | undefined;
    participants: ConversationParticipantViewModel[];
    messageCount: number;
}

export interface ConversationDetailViewModel extends ConversationViewModel {
    messages?: ConversationMessageViewModel[];
    hasMoreMessages?: boolean;
    oldestMessageSequence?: number | undefined;
}

export interface ConversationExpirationRequest {
    expiresAt?: string | undefined;
    clearExpiration: boolean;
}

export interface ConversationMessageContentViewModel {
    id: string;
    text?: string | undefined;
    fileName?: string | undefined;
    fileId?: string | undefined;
    linkName?: string | undefined;
    linkUrl?: string | undefined;
    attributes?: { [key: string]: string; } | undefined;
}

export interface ConversationMessagePageViewModel {
    messages: ConversationMessageViewModel[];
    hasMoreMessages: boolean;
    oldestMessageSequence?: number | undefined;
}

export interface ConversationMessageViewModel {
    id: string;
    groupId?: string | undefined;
    participantId: string;
    createdDate: string;
    contents: ConversationMessageContentViewModel[];
}

export interface ConversationParticipantViewModel {
    id: string;
    type: string;
    targetId: string;
    name: string;
    lastMessageStarted?: string | undefined;
}

export interface ConversationViewModelPagingResultModel {
    items: ConversationViewModel[];
    hasNextPage: boolean;
}

export interface CreateAgentRequest {
    name: string;
    fileId?: string | undefined;
}

export interface CreateApiKeyCommand {
    name: string;
    code: string;
    description?: string | undefined;
}

export interface CreateBundleDefinitionRequest {
    changeSetId: string;
    name: string;
    definition: string;
    tags?: string[] | undefined;
}

export interface CreateChangeSetRequest {
    name: string;
    description?: string | undefined;
}

export interface CreateClientCommand {
    name: string;
    code: string;
    description?: string | undefined;
    attributes?: { [key: string]: string; } | undefined;
    redirectUrls?: string[] | undefined;
}

export interface CreateContextEventHandlerRequest {
    integrationEventId: string;
    name?: string | undefined;
    description?: string | undefined;
    tags: string[];
}

export interface CreateDomainStoryRequest {
    name: string;
    description: string;
}

export interface CreateDomainStoryStatementRequest {
    text: string;
    sequence?: number | undefined;
    expectedStatementVersion?: number | undefined;
}

export interface CreateDomainStoryStatementsRequest {
    statements: string[];
    expectedStatementVersion?: number | undefined;
}

export interface CreateEmbedDefinitionRequest {
    name: string;
    code: string;
    description?: string | undefined;
    appDefinitionId: string;
    allowedViewIds: string[];
    defaultViewId: string;
}

export interface CreateEnvironmentCommand {
    name: string;
    code: string;
    order: number;
    tags?: string[] | undefined;
    serviceConnectionId: string;
    deploymentServiceConnectionType: string;
    attributes?: { [key: string]: string; } | undefined;
    transitions?: EnvironmentTransition[] | undefined;
    metadata?: { [key: string]: any; } | undefined;
}

export interface ReleasePlanCreatedResult {
    releasePlanId: string;
}

export interface CreateEnvironmentCommandResult extends ReleasePlanCreatedResult {
    id?: string;
}

export interface CreateFlowRequest {
    name: string;
    definition: string;
    tags: string[];
}

export interface CreateInvitationRequest {
    email: string;
}

export interface CreateNewIntegrationEventModel {
    name: string;
    contextId: string;
    description: string;
    tags: string[];
}

export interface CreatePermissionCommand {
    id?: string | undefined;
    name?: string | undefined;
    group?: string | undefined;
    description?: string | undefined;
}

export interface CreateReactSourceFileRequest {
    path: string;
    content: string;
}

export interface CreateRoleCommand {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    permissionIds?: string[] | undefined;
}

export interface CreateServiceConnectionCommand {
    type: string;
    name: string;
    isPerEnvironment: boolean;
    parameters: { [key: string]: any; };
    environmentParameters: EnvironmentParametersModel[];
    enabledEnvironments?: string[] | undefined;
}

export interface CreateStringTemplateRequest {
    changeSetId: string;
    name: string;
    parentTemplateId?: string | undefined;
    content: string;
    email?: EmailTemplateFields | undefined;
    folderId?: string | undefined;
    format: string;
    properties?: { [key: string]: IExpression; } | undefined;
    category: string;
    inputSchemaValue?: SchemaValue | undefined;
}

export interface CreateTemplateFolderRequest {
    name: string;
    parentId?: string | undefined;
}

export interface CreateTenantRequest {
    code: string;
    name?: string | undefined;
    description?: string | undefined;
    isActive: boolean;
}

export interface DashboardArchitectureStatisticsModel {
    subdomains: number;
    contexts: number;
    entities: number;
    operations: number;
    integrationEvents: number;
}

export interface DashboardAutomationStatisticsModel {
    flows: number;
    agents: number;
    operations: number;
}

export interface DashboardExperienceStatisticsModel {
    apps: number;
    views: number;
    components: number;
    resources: number;
    operations: number;
}

export interface DashboardOperationalMetricPointModel {
    at: string;
    flowRuns: number;
    webhookInvocations: number;
    operationCalls: number;
}

export interface DashboardOperationalMetricsModel {
    from: string;
    to: string;
    flowRuns: number;
    failedFlowRuns: number;
    averageFlowDurationMs?: number | undefined;
    minimumFlowDurationMs?: number | undefined;
    maximumFlowDurationMs?: number | undefined;
    webhookInvocations: number;
    operationCalls: number;
    failedOperationCalls: number;
    averageOperationDurationMs?: number | undefined;
    minimumOperationDurationMs?: number | undefined;
    maximumOperationDurationMs?: number | undefined;
    points: DashboardOperationalMetricPointModel[];
}

export interface DashboardOverviewModel {
    generatedAt: string;
    changeSetId?: string | undefined;
    architecture: DashboardArchitectureStatisticsModel;
    experiences: DashboardExperienceStatisticsModel;
    automation: DashboardAutomationStatisticsModel;
    metrics: DashboardOperationalMetricsModel;
    recentArtifacts: DashboardRecentArtifactModel[];
}

export interface DashboardRecentArtifactModel {
    id: string;
    name: string;
    type: string;
    updatedAt: string;
    url: string;
    updatedByName?: string | undefined;
}

export interface DeepOperationModel {
    id: string;
    contextId: string;
    name: string;
    description: string;
    executionType: OperationExecutionTypesModel;
    exposure: OperationExposureModel;
    scopes: string[];
    requestSchema?: SchemaHierarchyModel | undefined;
    responseSchema?: SchemaHierarchyModel | undefined;
}

export interface DeepSchemaPropertyModel {
    id: string;
    contextId: string;
    name: string;
    isRequired: boolean;
    isMultiple: boolean;
    description: string;
    schema: SchemaHierarchyModel;
}

export interface DefaultDependantModel {
    forCodeBaseType: CodeBaseTypeModel;
}

export interface DeployEmbedRequest {
    allowedOrigins: string[];
}

export interface DesignerChatAddParticipantsRequest {
    userIds: string[];
}

export interface DesignerChatAgentModel {
    id: string;
    name: string;
    description: string;
    isDefault: boolean;
}

export interface DesignerChatAttachmentDownloadModel {
    url: string;
}

export interface DesignerChatAttachmentModel {
    fileId: string;
    fileName: string;
    contentType?: string | undefined;
    size?: number | undefined;
}

export interface DesignerChatContentModel {
    id: string;
    fileId?: string | undefined;
    fileName?: string | undefined;
    text?: string | undefined;
    contentType: string;
    widgetId?: string | undefined;
}

export interface DesignerChatCreateSessionRequest {
    forceNew: boolean;
    includeMessages?: boolean | undefined;
    targetId?: string | undefined;
    contextScope?: string | undefined;
    operationId?: string | undefined;
    eventHandlerId?: string | undefined;
}

export interface DesignerChatHtmlContentModel {
    html: string;
}

export interface DesignerChatInstructRequest {
    requestId?: string | undefined;
    instruction?: string | undefined;
    sessionId?: string | undefined;
    forceNew?: boolean | undefined;
    conversationName?: string | undefined;
    targetId?: string | undefined;
    contextScope?: string | undefined;
    operationId?: string | undefined;
    eventHandlerId?: string | undefined;
    messageAttributes?: { [key: string]: string; } | undefined;
    fileIds?: string[] | undefined;
}

export interface DesignerChatInstructResponse {
    sessionId: string;
    messageId?: string | undefined;
    warning?: string | undefined;
}

export interface DesignerChatMessagePageResponse {
    messages: DesignerChatMessageResponseModel[];
    hasMoreMessages: boolean;
    oldestMessageSequence?: number | undefined;
}

export interface DesignerChatMessageResponseModel {
    id: string;
    sequence?: number | undefined;
    groupId?: string | undefined;
    role?: string | undefined;
    agentName?: string | undefined;
    text?: string | undefined;
    contentType: string;
    createdDate: string;
    attributes?: { [key: string]: string; } | undefined;
    attachments: DesignerChatAttachmentModel[];
    contents: DesignerChatContentModel[];
}

export interface DesignerChatParticipantModel {
    userId: string;
    name: string;
    isOwner: boolean;
    canRemove: boolean;
}

export interface DesignerChatSessionDeltaResponse {
    lastMessageSequence?: number | undefined;
    hasMoreUpdates: boolean;
    changeToken?: string | undefined;
    responseStatus?: string | undefined;
    responseUpdatedAt?: string | undefined;
    responseTurnId?: string | undefined;
    status?: string | undefined;
    isComplete: boolean;
    messages: DesignerChatMessageResponseModel[];
    hasMoreMessages: boolean;
    oldestMessageSequence?: number | undefined;
}

export interface DesignerChatSessionModel {
    sessionId: string;
    isNew: boolean;
    status?: string | undefined;
    name: string;
    createdDate: string;
    expiresAt?: string | undefined;
    agentId?: string | undefined;
    agentName?: string | undefined;
    messages?: DesignerChatMessageResponseModel[] | undefined;
    hasMoreMessages: boolean;
    oldestMessageSequence?: number | undefined;
}

export interface DesignerChatSessionModelPagingResultModel {
    items: DesignerChatSessionModel[];
    hasNextPage: boolean;
}

export interface DesignerChatUpdateSessionRequest {
    name?: string | undefined;
    expiresAt?: string | undefined;
    clearExpiration: boolean;
}

export interface DomainArtifactMetadataModel {
    position?: DomainArtifactPositionModel | undefined;
}

export interface DomainArtifactPositionModel {
    x: number;
    y: number;
}

export interface DomainMetaModel {
    codebaseId: string;
    name: string;
    aggregateRoots: IntelligentWidgetCatalogClientEntityModel[];
}

export enum DomainMetadataTargetType {
    Entity = "Entity",
    Enum = "Enum",
}

export interface DomainModelingDataModel {
    entities: SchemaHierarchyModel[];
    enums: EnumModel[];
}

export interface DomainStoryActorModel {
    actorId?: string | undefined;
    displayName: string;
    actorType: ActorTypeModel;
    aliases: string[];
}

export interface DomainStoryFlowReferenceModel {
    type: FlowReferenceTypeModel;
    referenceId: string;
}

export interface DomainStoryFlowSegmentModel {
    position: number;
    from: DomainStoryFlowReferenceModel;
    activity: string;
    to: DomainStoryFlowReferenceModel;
}

export interface DomainStoryModel {
    id: string;
    tenantId: string;
    projectId: string;
    title: string;
    description: string;
    status: DomainStoryStatusModel;
    currentRevisionId?: string | undefined;
    currentRevisionNumber: number;
    statementVersion: number;
    createdAt: string;
    updatedAt: string;
    createdBy: string;
}

export interface DomainStoryModelPagingResultModel {
    items: DomainStoryModel[];
    hasNextPage: boolean;
}

export interface DomainStoryNoteModel {
    id?: string | undefined;
    type: StoryNoteTypeModel;
    subject: DomainStorySubjectReferenceModel;
    text: string;
}

export interface DomainStoryPotentialStoryModel {
    id?: string | undefined;
    title: string;
    reason: string;
    resultingDomainStoryId?: string | undefined;
}

export interface DomainStoryQuestionModel {
    id?: string | undefined;
    subject: DomainStorySubjectReferenceModel;
    question: string;
    status: StoryQuestionStatusModel;
}

export interface DomainStoryRepeatModel {
    type: RepeatTypeModel;
    subject: DomainStoryRepeatSubjectModel;
}

export interface DomainStoryRepeatSubjectModel {
    type: RepeatSubjectTypeModel;
    referenceId: string;
}

export interface DomainStoryRevisionModel {
    id?: string | undefined;
    projectId: string;
    domainStoryId?: string | undefined;
    revisionNumber?: number | undefined;
    title: string;
    description: string;
    createdBy: string;
    sourceDefinition?: string | undefined;
    sourceStatementVersion?: number | undefined;
    actors: DomainStoryActorModel[];
    workObjects: DomainStoryWorkObjectModel[];
    steps: DomainStoryStepModel[];
    notes: DomainStoryNoteModel[];
    questions: DomainStoryQuestionModel[];
    potentialStories: DomainStoryPotentialStoryModel[];
}

export interface DomainStoryStatementsModel {
    domainStoryId: string;
    statementVersion: number;
    currentRevisionStatementVersion?: number | undefined;
    statements: StoryStatementModel[];
}

export enum DomainStoryStatusModel {
    Draft = "Draft",
    InReview = "InReview",
    Accepted = "Accepted",
    Archived = "Archived",
}

export interface DomainStoryStepModel {
    id?: string | undefined;
    sequence: number;
    sentence: string;
    flowSegments: DomainStoryFlowSegmentModel[];
    optional: boolean;
    repeat?: DomainStoryRepeatModel | undefined;
}

export interface DomainStorySubjectReferenceModel {
    type: StorySubjectTypeModel;
    referenceId?: string | undefined;
}

export interface DomainStoryWorkObjectModel {
    id?: string | undefined;
    name: string;
    description?: string | undefined;
}

export interface EffectivePermissionsModel {
    objectId: string;
    permissionIds?: string[] | undefined;
}

export interface EmailTemplateFields {
    subject?: string | undefined;
    to?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    plainTextBody?: string | undefined;
}

export interface EmbedDefinitionModel {
    id: string;
    name: string;
    code: string;
    description?: string | undefined;
    appDefinitionId: string;
    allowedViewIds: string[];
    defaultViewId: string;
    revision: string;
}

export interface EmbedDeploymentModel {
    id: string;
    environmentId: string;
    definitionId?: string | undefined;
    name: string;
    appDefinitionId: string;
    allowedViewIds: string[];
    defaultViewId: string;
    allowedOrigins: string[];
    isEnabled: boolean;
    publishableKey: string;
    appliedRevision?: string | undefined;
    updateAvailable: boolean;
    releasePlanId?: string | undefined;
    runtimeApiUrl?: string | undefined;
    scriptUrl?: string | undefined;
}

export interface EntityMetadataModel {
    id: string;
    contextId: string;
    name: string;
    description: string;
    properties: EntityPropertyMetadataModel[];
}

export interface EntityPropertyMetadataModel {
    name: string;
    description?: string | undefined;
    isRequired: boolean;
    isMultiple: boolean;
    isComplex: boolean;
    type: PrimitiveType;
    referenceEntityId?: string | undefined;
    referenceEntity?: EntityMetadataModel | undefined;
    referenceEnumId?: string | undefined;
    referenceEnum?: EnumMetadataModel | undefined;
}

export interface EntityPropertyModel {
    name: string;
    type: string;
    entityTypeInfo?: IntelligentWidgetCatalogClientEntityModel | undefined;
    isMultiple: boolean;
}

export interface EnumItemMetadataModel {
    id: string;
    name: string;
    value: number;
}

export interface EnumItemModel {
    id: string;
    name: string;
    value: number;
}

export interface EnumMetadataModel {
    id: string;
    name: string;
    description: string;
    items: EnumItemMetadataModel[];
}

export interface EnumModel {
    id: string;
    name: string;
    description: string;
    metadata: string;
    schemaName: string;
    schemaVersion: string;
    contextId: string;
    items: EnumItemModel[];
}

export interface EnumPropertyModel {
    isRequired: boolean;
    isMultiple: boolean;
    propertyName: string;
    propertyDescription: string;
    defaultValue?: string | undefined;
    enumId: string;
    enumContextId: string;
}

export interface EnvironmentApiKeyModel extends IntelligentWidgetResourceManagerClientEntityModel {
    apiKeyId?: string;
    attributes: { [key: string]: any; };
}

export interface EnvironmentClientModel extends IntelligentWidgetResourceManagerClientEntityModel {
    clientId: string;
    attributes: { [key: string]: any; };
}

export interface EnvironmentComponentModel extends IntelligentWidgetResourceManagerClientEntityModel {
    componentId: string;
    containerImageVersion: string;
    url?: string | undefined;
    runtimeProfileOverride?: ComponentRuntimeProfileOverride | undefined;
    attributes: { [key: string]: any; };
}

export interface EnvironmentEmbedModel {
    id: string;
    environmentId: string;
    name: string;
    appDefinitionId: string;
    allowedViewIds: string[];
    defaultViewId: string;
    allowedOrigins: string[];
    isEnabled: boolean;
    publishableKey: string;
}

export interface EnvironmentEmbedRequest {
    name: string;
    appDefinitionId: string;
    allowedViewIds: string[];
    defaultViewId: string;
    allowedOrigins: string[];
    isEnabled: boolean;
}

export interface EnvironmentModel extends IntelligentWidgetResourceManagerClientEntityModel {
    name: string;
    code: string;
    tags: string[];
    order?: number;
    serviceConnectionId: string;
    deploymentServiceConnectionType?: string | undefined;
    changeSetId?: string | undefined;
    attributes: { [key: string]: any; };
    metadata?: { [key: string]: any; } | undefined;
    transitions: EnvironmentTransitionModel[];
    components: EnvironmentComponentModel[];
    clients: EnvironmentClientModel[];
    apiKeys: EnvironmentApiKeyModel[];
    serviceConnections: EnvironmentServiceConnectionModel[];
}

export interface EnvironmentModelPagingResultModel {
    items: EnvironmentModel[];
    hasNextPage: boolean;
}

export interface EnvironmentParametersModel {
    environmentId: string;
    parameters: { [key: string]: any; };
}

export interface EnvironmentParametersViewModel {
    environmentId: string;
    environmentName: string;
    environmentOrder: number;
    parameters: { [key: string]: any; };
}

export interface EnvironmentServiceConnectionModel extends IntelligentWidgetResourceManagerClientEntityModel {
    serviceConnectionId: string;
    serviceConnectionType: string;
    serviceConnectionCategory: string;
}

export interface EnvironmentTransition {
    id: string;
    to: string;
    order: number;
    metadata?: { [key: string]: any; } | undefined;
}

export interface EnvironmentTransitionModel extends IntelligentWidgetResourceManagerClientEntityModel {
    to: string;
    order?: number;
    metadata?: { [key: string]: any; } | undefined;
}

export interface EventHandlerAndPayloadModel {
    handler: ContextEventHandlerModel;
    payload?: SchemaSummaryModel | undefined;
}

export interface ExecuteFlowResponse {
    instanceId: string;
    output?: any | undefined;
    status: FlowInstanceStatus;
    errorMessage?: string | undefined;
}

export interface ExpressionMetadataModel {
    name: string;
    displayName: string;
    category?: string | undefined;
    categories: string[];
    description?: string | undefined;
    parameters: ParameterMetadata[];
    variableSets?: VariableSetMetadata[] | undefined;
    displayContent?: string | undefined;
    iconName?: string | undefined;
    iconBase64?: string | undefined;
    iconUrl?: string | undefined;
    wizardSteps?: WizardStepMetadata[] | undefined;
    resultType?: VariableTypeMetadata | undefined;
}

export interface FileExpirationRequest {
    expiresAt?: string | undefined;
    clearExpiration: boolean;
}

export interface FileViewModel {
    id: string;
    name: string;
    isSystem: boolean;
    contentType?: string | undefined;
    size: number;
    created: string;
    updated: string;
    expiresAt?: string | undefined;
    url?: string | undefined;
    attributes?: { [key: string]: string; } | undefined;
}

export interface FileViewModelPagingResultModel {
    items: FileViewModel[];
    hasNextPage: boolean;
}

export interface FlowConnectionBindingsModel {
    flowDefinitionId: string;
    isReady: boolean;
    canEditPolicies: boolean;
    slots: FlowConnectionSlotModel[];
}

export interface FlowConnectionSlotModel {
    sourceConnectionId: string;
    name: string;
    type: string;
    tenantConnectionId?: string | undefined;
    tenantConnectionName?: string | undefined;
    isValid: boolean;
    policy: string;
    effectiveConnectionId?: string | undefined;
}

export interface FlowExecutionFailure {
    phase: string;
    exceptionType: string;
    message: string;
    stackTrace?: string | undefined;
    correlationId: string;
}

export interface FlowInstanceModel {
    id: string;
    createdDate: string;
    updatedDate: string;
    tenantId: string;
    environmentId: string;
    definitionId: string;
    status: FlowInstanceStatus;
    input: any;
    output: any;
    currentActivityId?: string | undefined;
    currentActivityStack?: { [key: string]: any; }[] | undefined;
    attributes: { [key: string]: string; };
    values: string[];
    errorMessage?: string | undefined;
    failure?: FlowExecutionFailure | undefined;
    timeToLive?: string | undefined;
}

export interface FlowInstanceRunModel {
    id: string;
    createdDate: string;
    updatedDate: string;
    tenantId: string;
    flowInstanceId: string;
    runId: string;
    timeToLive?: string | undefined;
    steps: FlowInstanceStepModel[];
}

export enum FlowInstanceStatus {
    Running = "Running",
    Completed = "Completed",
    Waiting = "Waiting",
    Failed = "Failed",
    Canceled = "Canceled",
}

export interface FlowInstanceStepModel {
    id: string;
    type: StepType;
    executionId: string;
    activityId: string;
    parentActivityId?: string | undefined;
    name?: string | undefined;
    timestamp: string;
    data?: { [key: string]: any; } | undefined;
    order: number;
}

export interface FlowInstanceViewModel extends EntityModel {
    definitionId: string;
    environmentId: string;
    environmentName: string;
    status: FlowInstanceStatus;
    errorMessage?: string | undefined;
    currentActivityId: string | undefined;
}

export interface FlowInstanceViewModelPagingResultModel {
    items: FlowInstanceViewModel[];
    hasNextPage: boolean;
}

export interface FlowMetadataModel {
    activities: ActivityMetadataModel[];
    expressions: ExpressionMetadataModel[];
}

export enum FlowReferenceTypeModel {
    Actor = "Actor",
    WorkObject = "WorkObject",
}

export interface FlowViewModel extends EntityModel {
    isReadOnly: boolean;
    isSystemOwned: boolean;
    name: string;
    definition: string;
    tags: string[];
    inputSchema?: SchemaReference | undefined;
    outputSchema?: SchemaReference | undefined;
}

export interface FlowViewModelPagingResultModel {
    items: FlowViewModel[];
    hasNextPage: boolean;
}

export interface GetDomainStoryRevisionModel {
    domainStoryId: string;
    domainStoryRevisionId?: string | undefined;
    revisionNumber: number;
    revision?: DomainStoryRevisionModel | undefined;
}

export interface GetDraftServiceConnectionParameterValueOptionsRequest {
    parameters?: { [key: string]: any; } | undefined;
}

export interface GetServiceConnectionPropertyRequest {
    environmentId?: string | undefined;
    dependentValues?: { [key: string]: any; } | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface HttpValidationProblemDetails extends ProblemDetails {
    errors?: { [key: string]: string[]; };

    [key: string]: any;
}

export interface IExpression {
}

export interface IntegrationEventAndPayloadModel {
    event: IntegrationEventModel;
    payload?: SchemaSummaryModel | undefined;
}

export interface IntegrationEventMetadataModel {
    id: string;
    contextId: string;
    name: string;
    description?: string | undefined;
    payload?: EntityMetadataModel | undefined;
}

export interface IntegrationEventModel {
    id: string;
    name: string;
    contextId: string;
    description: string;
    schema: SchemaReferenceModel;
    tags: string[];
}

export interface IntelligentWidgetCatalogClientEntityModel {
    id: string;
    name: string;
    descripton: string;
    properties: EntityPropertyModel[];
    entityMethods: MethodModel[];
}

export interface InvitationModel {
    email: string;
    registrationUrl: string;
    expiresAt: string;
}

export enum LanguageModel {
    CSharp = "CSharp",
    TypeScript = "TypeScript",
}

export interface MethodModel {
    methodName: string;
    description: string;
    returnType: string;
    isReturnTypeMultiple: boolean;
    isStatic: boolean;
    returnTypeInfo?: IntelligentWidgetCatalogClientEntityModel | undefined;
    parameters: ParameterModel[];
}

export interface NewContextModel {
    contextName: string;
    description: string;
    tags: string[];
}

export interface NewEntityAsNewPropertyRequest {
    propertyName: string;
    propertyDescription: string;
    isRequired: boolean;
    isMultiple: boolean;
    newEntityDetails: NewEntitySchemaRequest;
}

export interface NewEntitySchemaRequest {
    schemaType: SchemaTypes;
    entityName: string;
    description: string;
    properties: SimplePropertyModel[];
    enumProperties: EnumPropertyModel[];
    referenceProperties: ReferencePropertyModel[];
}

export interface NewEnumModel {
    name: string;
    description: string;
    metadata: string;
    items?: string[] | undefined;
}

export interface NewOperationModel {
    name: string;
    description: string;
    executionType: OperationExecutionTypesModel;
    exposure?: OperationExposureModel | undefined;
    referencedSchemas: SchemaReferenceModel[];
    tags: string[];
}

export interface NewProjectModel {
    name: string;
    description: string;
}

export interface NewSubDomainModel {
    subDomainName: string;
    subDomainDescription: string;
}

export interface ObjectRoleMatrixCellModel {
    roleId: string;
    isAssigned: boolean;
}

export interface ObjectRoleMatrixModel {
    objects: ObjectRoleMatrixRowModel[];
}

export interface ObjectRoleMatrixRequest {
    objectIds: string[];
    objectFilter?: string | undefined;
    roleFilter?: string | undefined;
    matrixFilter?: string | undefined;
}

export interface ObjectRoleMatrixRowModel {
    objectId: string;
    objectName?: string | undefined;
    objectType?: string | undefined;
    assignedRoleIds: string[];
    effectivePermissionIds: string[];
    roles: ObjectRoleMatrixCellModel[];
}

export interface ObjectRolesModel {
    objectId: string;
    name?: string | undefined;
    type?: string | undefined;
    roleIds?: string[] | undefined;
}

export interface OperationExecutionTypeModel {
    id: OperationExecutionTypesModel;
    name: string;
    description: string;
    caption: string;
}

export enum OperationExecutionTypesModel {
    Read = "Read",
    Update = "Update",
    Create = "Create",
    Delete = "Delete",
    Execute = "Execute",
}

export enum OperationExposureModel {
    Api = "Api",
    ApiAndMcp = "ApiAndMcp",
    McpOnly = "McpOnly",
}

export interface OperationMetadataModel {
    id: string;
    contextId: string;
    name: string;
    description?: string | undefined;
    request?: EntityMetadataModel | undefined;
    response?: EntityMetadataModel | undefined;
}

export interface OperationModel {
    id: string;
    name: string;
    contextId: string;
    description: string;
    executionType: OperationExecutionTypesModel;
    operationType: OperationTypesModel;
    exposure: OperationExposureModel;
    operationLogicRulesetId: string;
    requestSchema: OperationSchemaReferenceModel;
    responseSchema: OperationSchemaReferenceModel;
    referencedSchemas: OperationSchemaReferenceModel[];
    scopes: string[];
    tags: string[];
}

export interface OperationSchemaReferenceModel {
    referenceSchemaId: string;
    referenceSchemaContextId: string;
}

export enum OperationTypesModel {
    HttpService = "HttpService",
}

export interface PagingModel {
    pageIndex: number;
    pageSize: number;
    sortBy?: string | undefined;
    sortAscending: boolean;
}

export interface ParameterMetadata {
    name: string;
    displayName: string;
    order: number;
    type: ParameterType;
    typeCustom?: string | undefined;
    description?: string | undefined;
    category?: string | undefined;
    categories: string[];
    isRequired?: boolean | undefined;
    defaultValue?: any | undefined;
    isCollection: boolean;
    expectedType: VariableTypeMetadata;
    expectedExpressionIsAssignable?: boolean | undefined;
    isStringMultiLine?: boolean | undefined;
    matchType?: string | undefined;
    matchCategory?: string | undefined;
    isSecret?: boolean | undefined;
    valueOptions?: ParameterValueOption[] | undefined;
    valueOptionsSource?: ParameterValueOptionsSource | undefined;
    iconName?: string | undefined;
    iconBase64?: string | undefined;
    iconUrl?: string | undefined;
    visibleWhen?: ParameterVisibilityCondition[] | undefined;
    wizardStepKey?: string | undefined;
    scope?: ParameterScope | undefined;
    suggestedExpressions?: SuggestedExpressionMetadata[] | undefined;
}

export interface ParameterModel {
    name: string;
    type: string;
    entityTypeInfo?: IntelligentWidgetCatalogClientEntityModel | undefined;
    isMultiple: boolean;
}

export enum ParameterScope {
    Environment = "Environment",
    NonEnvironment = "NonEnvironment",
}

export enum ParameterType {
    Primitive = "Primitive",
    Expression = "Expression",
    Activity = "Activity",
    Container = "Container",
    SchemaRef = "SchemaRef",
    SchemaValue = "SchemaValue",
    OperationRef = "OperationRef",
    ServiceConnectionRef = "ServiceConnectionRef",
    IntegrationEventRef = "IntegrationEventRef",
    FlowRef = "FlowRef",
    ComponentRef = "ComponentRef",
    SharedComponentRef = "SharedComponentRef",
    EmbeddedResourceRef = "EmbeddedResourceRef",
    Custom = "Custom",
}

export interface ParameterValueOption {
    name: string;
    value: any;
    description?: string | undefined;
}

export interface ParameterValueOptionsSource {
    kind: string;
    serviceConnectionNameRef: string;
    propertyName: string;
    allowCustomValues: boolean;
    dependentValueNameRefs?: string[] | undefined;
}

export interface ParameterVisibilityCondition {
    nameRef: string;
    operator: ParameterVisibilityOperator;
    value: any;
}

export enum ParameterVisibilityOperator {
    Equals = "Equals",
    NotEquals = "NotEquals",
    HasValue = "HasValue",
    IsEmpty = "IsEmpty",
}

export interface PermissionAdministrationPagingModel {
    pageIndex: number;
    pageSize: number;
    sortBy?: string | undefined;
    sortAscending: boolean;
}

export interface PermissionAdministrationSearchRequest {
    paging?: PermissionAdministrationPagingModel | undefined;
    filter?: string | undefined;
}

export interface PermissionModel {
    id: string;
    name?: string | undefined;
    group?: string | undefined;
    description?: string | undefined;
    created: string;
    updated: string;
}

export interface PermissionModelPermissionAdministrationSearchResultModel {
    items: PermissionModel[];
    hasNextPage: boolean;
}

export enum PrimitiveType {
    String = "String",
    Integer = "Integer",
    Decimal = "Decimal",
    Boolean = "Boolean",
    Guid = "Guid",
    DateTime = "DateTime",
    Date = "Date",
    Time = "Time",
    TimeSpan = "TimeSpan",
    Collection = "Collection",
    Object = "Object",
    Ref = "Ref",
    Enum = "Enum",
}

export interface ProjectModel {
    id: string;
    tenantId: string;
    name: string;
    description: string;
    isActive: boolean;
}

export interface ProjectModelPagingResultModel {
    items: ProjectModel[];
    hasNextPage: boolean;
}

export interface PropertyModel {
    name: string;
    description: string;
    propertyType: PrimitiveType;
    isRequired: boolean;
    isMultiple: boolean;
}

export enum PropertyTypes {
    Simple = "Simple",
    Complex = "Complex",
    Enum = "Enum",
}

export interface ReactCodeComponentModel {
    id: string;
    name: string;
    entryPoint: string;
}

export enum ReactCodeLifecycleState {
    Empty = "Empty",
    Draft = "Draft",
    Modified = "Modified",
    Compiling = "Compiling",
    Compiled = "Compiled",
    Published = "Published",
    Failed = "Failed",
}

export interface ReactCodeStatusModel {
    state: ReactCodeLifecycleState;
    buildId?: string | undefined;
    buildState?: string | undefined;
    diagnostics: string[];
    components: ReactCodeComponentModel[];
}

export interface ReactSourceFileContentModel {
    id: string;
    path: string;
    contentType: string;
    content: string;
}

export interface ReactSourceFileModel {
    id: string;
    path: string;
    contentType: string;
    integrity: string;
    size: number;
    tags: ReactSourceFileTagModel[];
}

export interface ReactSourceFileRenameModel {
    previousId: string;
    id: string;
    path: string;
}

export interface ReactSourceFileTagModel {
    name: string;
    value: string;
}

export interface RedirectUrlPlaceholderMetadataModel {
    placeholders: RedirectUrlPlaceholderModel[];
}

export interface RedirectUrlPlaceholderModel {
    name: string;
    source: string;
    description?: string | undefined;
}

export interface ReferencePropertyModel {
    isRequired: boolean;
    isMultiple: boolean;
    propertyName: string;
    propertyDescription: string;
    referenceSchemaId: string;
    referenceSchemaContextId: string;
}

export interface RegisterUserRequest {
    email: string;
    password: string;
    givenName: string;
    surname: string;
    displayName?: string | undefined;
    tenantCode?: string | undefined;
    tenantName?: string | undefined;
    invitationToken?: string | undefined;
}

export interface RegisterUserResponse {
    userId: string;
    tenantId: string;
    tenantCode: string;
}

export interface ReleasePlanModel extends IntelligentWidgetResourceManagerClientEntityModel {
    targetEnvironmentId?: string;
    completedStepCount?: number;
    steps?: ReleasePlanStepModel[] | undefined;
    status?: ReleasePlanStatus;
    message?: string | undefined;
    errors?: string[] | undefined;
}

export interface ReleasePlanModelPagingResultModel {
    items: ReleasePlanModel[];
    hasNextPage: boolean;
}

export enum ReleasePlanStatus {
    Pending = "Pending",
    InProgress = "InProgress",
    Completed = "Completed",
    Failed = "Failed",
}

export interface ReleasePlanStepModel {
    id: string;
    displayName: string;
    tasks: ReleasePlanTaskModel[];
}

export interface ReleasePlanTaskModel {
    id: string;
    displayName: string;
}

export interface RenameOperationRequest {
    name: string;
}

export interface RenameOperationResult {
    operation: OperationModel;
    requestSchemaId: string;
    requestSchemaName: string;
    responseSchemaId: string;
    responseSchemaName: string;
}

export interface RenameReactSourceFileRequest {
    path: string;
}

export interface RenameReactSourceFolderRequest {
    folderPath: string;
    name: string;
}

export interface RenameReactSourceFolderResultModel {
    files: ReactSourceFileRenameModel[];
}

export interface ReorderDomainStoryStatementsRequest {
    statementIds: string[];
    expectedStatementVersion?: number | undefined;
}

export enum RepeatSubjectTypeModel {
    Actor = "Actor",
    WorkObject = "WorkObject",
}

export enum RepeatTypeModel {
    ForEach = "ForEach",
}

export interface ResumeFlowRequest {
    runSynchronous: boolean;
    storeTransitions: boolean;
    storeVariables: boolean;
}

export interface RoleModel {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    permissionIds?: string[] | undefined;
    created: string;
    updated: string;
}

export interface RoleModelPermissionAdministrationSearchResultModel {
    items: RoleModel[];
    hasNextPage: boolean;
}

export interface RotateEnvironmentEmbedRequest {
    graceMinutes: number;
}

export interface RunFlowRequest {
    definitionId: string;
    runSynchronous: boolean;
    input?: any | undefined;
    environmentId: string;
    storeTransitions: boolean;
    storeVariables: boolean;
}

export enum RuntimeProfileTier {
    Nano = "Nano",
    Small = "Small",
    Medium = "Medium",
    Large = "Large",
}

export interface SaveAuthoringResourceModel {
    id?: string | undefined;
    name: string;
    description: string;
    mimeType: string;
    content: string;
    targets: AuthoringResourceTarget[];
    tags: string[];
    isEnabled: boolean;
    isMcpExposed: boolean;
}

export interface SchemaHierarchyModel {
    id: string;
    contextId: string;
    name: string;
    schemaName: string;
    schemaVersion: string;
    description: string;
    metadata: string;
    schemaTypeId: SchemaTypesModel;
    properties: SchemaPropertyModel[];
    subSchemas: DeepSchemaPropertyModel[];
}

export interface SchemaPropertyModel {
    name: string;
    type: PrimitiveType;
    isRequired: boolean;
    isMultiple: boolean;
    isComplex: boolean;
    isEnum: boolean;
    description: string;
    isReferenceProperty: boolean;
    referenceSchemaId?: string | undefined;
    referenceSchemaContextId?: string | undefined;
    enumId?: string | undefined;
    enumContextId?: string | undefined;
    referenceSchemaShortName?: string | undefined;
    defaultValue?: string | undefined;
}

export interface SchemaReference {
    id: string;
    contextId: string;
    name?: string | undefined;
    contextName?: string | undefined;
}

export interface SchemaReferenceModel {
    schemaId: string;
    schemaContextId: string;
}

export interface SchemaSummaryModel {
    id: string;
    name: string;
    contextId: string;
    schemaName: string;
    schemaVersion: string;
    description: string;
    metadata: string;
    schemaTypeId: SchemaTypesModel;
}

export enum SchemaTypes {
    Unknown = "Unknown",
    DataSchema = "DataSchema",
    RootDataSchema = "RootDataSchema",
    DataOperationRequestSchema = "DataOperationRequestSchema",
    DataOperationResponseSchema = "DataOperationResponseSchema",
    DataReadSchema = "DataReadSchema",
    EnumExtensionSchmea = "EnumExtensionSchmea",
    ExternalServiceContractSchema = "ExternalServiceContractSchema",
    IntegrationEventSchema = "IntegrationEventSchema",
    DTOSchema = "DTOSchema",
}

export enum SchemaTypesModel {
    Unknown = "Unknown",
    DataSchema = "DataSchema",
    RootDataSchema = "RootDataSchema",
    DataOperationRequestSchema = "DataOperationRequestSchema",
    DataOperationResponseSchema = "DataOperationResponseSchema",
    DataReadSchema = "DataReadSchema",
    EnumExtensionSchmea = "EnumExtensionSchmea",
    ExternalServiceContractSchema = "ExternalServiceContractSchema",
    IntegrationEventSchema = "IntegrationEventSchema",
}

export interface SchemaValue {
    id: string;
    name?: string | undefined;
    value: any;
}

export interface SearchApiKeyRequest {
    paging?: PagingModel | undefined;
}

export interface SearchAuditRequest {
    month?: string | undefined;
    identityId?: string | undefined;
    timestampFrom?: string | undefined;
    timestampTo?: string | undefined;
    source?: string | undefined;
    type?: string | undefined;
    actionName?: string | undefined;
    attributes: { [key: string]: string; };
    pageSize: number;
    continuationToken?: string | undefined;
}

export interface SearchClientRequest {
    paging?: PagingModel | undefined;
}

export interface SearchComponentRequest {
    paging?: PagingModel | undefined;
}

export interface SearchContainerImageRequest {
    name?: string | undefined;
    paging?: PagingModel | undefined;
}

export interface SearchEnvironmentRequest {
    paging?: PagingModel | undefined;
}

export interface SearchReleasePlanRequest {
    paging?: PagingModel | undefined;
    ids?: string[] | undefined;
    targetEnvironmentId?: string | undefined;
}

export interface SearchServiceConnectionRequest {
    paging?: PagingModel | undefined;
    type?: string | undefined;
    category?: string | undefined;
    ids?: string[] | undefined;
}

export interface ServiceConnectionBaseModel {
    id: string;
    type: string;
    name: string;
}

export interface ServiceConnectionForEditModel {
    id: string;
    type: string;
    name: string;
    isReadOnly: boolean;
    category: string;
    categories: string[];
    statusName: string;
    isPerEnvironment: boolean;
    isLocked: boolean;
    enabledEnvironments: string[];
    parameters?: { [key: string]: any; } | undefined;
    environmentParameters?: EnvironmentParametersViewModel[] | undefined;
}

export interface ServiceConnectionMetadataModel {
    name: string;
    displayName: string;
    category?: string | undefined;
    categories: string[];
    description?: string | undefined;
    parameters: ParameterMetadata[];
    variableSets?: VariableSetMetadata[] | undefined;
    displayContent?: string | undefined;
    iconName?: string | undefined;
    iconBase64?: string | undefined;
    iconUrl?: string | undefined;
    wizardSteps?: WizardStepMetadata[] | undefined;
}

export interface ServiceConnectionModel extends ServiceConnectionBaseModel {
    isReadOnly?: boolean;
    category: string;
    categories: string[];
    statusName: string;
    isPerEnvironment?: boolean;
    isLocked?: boolean;
    enabledEnvironments: string[];
}

export interface ServiceConnectionModelPagingResultModel {
    items: ServiceConnectionModel[];
    hasNextPage: boolean;
}

export interface ServiceConnectionPropertySchemaSource {
    serviceConnectionNameRef: string;
    propertyName: string;
    dependentValueNameRefs?: string[] | undefined;
}

export interface ServiceConnectionPropertyValueModel {
    name: string;
    description: string;
    value?: any | undefined;
    valueOptions: ParameterValueOption[] | undefined;
}

export interface ServiceConnectionWithParametersModel extends ServiceConnectionBaseModel {
    parameters?: { [key: string]: any; } | undefined;
    isEnabled?: boolean;
}

export interface SetApiKeyDependenciesRequest {
    add?: ApiKeyDependencyRequest[] | undefined;
    remove?: string[] | undefined;
}

export interface SetClientDependenciesRequest {
    add?: ClientDependencyRequest[] | undefined;
    remove?: string[] | undefined;
}

export interface SetComponentDependenciesRequest {
    add?: AddComponentDependencyModel[] | undefined;
    remove?: string[] | undefined;
}

export interface SetComponentRuntimeProfileRequest {
    runtimeProfileOverride?: ComponentRuntimeProfile | undefined;
}

export interface SetEnvironmentAttributesRequest {
    attributes: { [key: string]: any; };
}

export interface SetEnvironmentComponentRuntimeProfileRequest {
    runtimeProfileOverride: ComponentRuntimeProfileOverride;
}

export interface SetFlowConnectionBindingRequest {
    tenantConnectionId: string;
}

export interface SetFlowConnectionPolicyRequest {
    policy: string;
}

export interface SetWebsiteOriginsRequest {
    allowedOrigins?: string[] | undefined;
}

export interface SimplePropertyModel extends PropertyModel {
    defaultValue?: string | undefined;
}

export enum StepType {
    OnEnter = "OnEnter",
    OnLeave = "OnLeave",
    OnPause = "OnPause",
    Execution = "Execution",
}

export enum StoryNoteTypeModel {
    Rule = "Rule",
    Ambiguity = "Ambiguity",
    Terminology = "Terminology",
    PainPoint = "PainPoint",
    Variation = "Variation",
    Exception = "Exception",
    Assumption = "Assumption",
    Observation = "Observation",
    Optional = "Optional",
    Repetition = "Repetition",
}

export enum StoryQuestionStatusModel {
    Open = "Open",
    Answered = "Answered",
    Deferred = "Deferred",
    Dismissed = "Dismissed",
}

export interface StoryStatementModel {
    id: string;
    sequence: number;
    text: string;
    createdAt: string;
    updatedAt: string;
    createdBy: string;
}

export enum StorySubjectTypeModel {
    Story = "Story",
    Actor = "Actor",
    WorkObject = "WorkObject",
    Step = "Step",
}

export interface StringTemplateViewModel extends EntityModel {
    templateId?: string;
    changeSetId?: string;
    versionId?: number;
    previousTemplateVersionId?: string | undefined;
    name: string;
    parentTemplateId?: string | undefined;
    content: string;
    email?: EmailTemplateFields | undefined;
    folderId?: string | undefined;
    format: string;
    properties?: { [key: string]: IExpression; } | undefined;
    category: string;
    inputSchemaValue?: SchemaValue | undefined;
}

export interface StringTemplateViewModelPagingResultModel {
    items: StringTemplateViewModel[];
    hasNextPage: boolean;
}

export interface SubDomainContextsModel {
    subDomain: SubDomainModel;
    contexts: ContextModel[];
    contextArtifactCounts: ContextArtifactCountsModel[];
}

export interface SubDomainModel {
    name: string;
    description: string;
    id: string;
}

export interface SuggestedExpressionMetadata {
    type: string;
    displayName: string;
    constValues?: any[] | undefined;
}

export interface TagModel {
    id: string;
    name: string;
    value: string;
}

export interface TemplateFolderModel {
    id: string;
    name: string;
    parentId?: string | undefined;
    createdDate: string;
    updatedDate: string;
}

export interface TenantSummaryModel {
    id: string;
    code: string;
    name?: string | undefined;
    description?: string | undefined;
    isActive: boolean;
}

export interface TenantModel extends TenantSummaryModel {
    createdDate: string;
    updatedDate?: string | undefined;
}

export interface TenantSummaryModelPagingResultModel {
    items: TenantSummaryModel[];
    hasNextPage: boolean;
}

export interface TenantUserIdsRequest {
    ids: string[];
}

export interface TenantUserModel {
    id: string;
    email: string;
    displayName?: string | undefined;
    givenName?: string | undefined;
    surname?: string | undefined;
    canChangeTenantId: boolean;
}

export interface TenantUserModelPagingResultModel {
    items: TenantUserModel[];
    hasNextPage: boolean;
}

export interface TenantViewModel {
    id: string;
    code: string;
    isActive: boolean;
}

export interface TestRunResultModel {
    codeBaseId: string;
    isSuccess: boolean;
    exitCode: number;
    messages: string[];
}

export interface UpdateAgentRequest {
    name: string;
    fileId?: string | undefined;
}

export interface UpdateApiKeyRequest {
    name?: string | undefined;
    description?: string | undefined;
    isEnabled?: boolean | undefined;
}

export interface UpdateBundleDefinitionRequest {
    changeSetId: string;
    name?: string | undefined;
    definition?: string | undefined;
    tags?: string[] | undefined;
}

export interface UpdateChangeSetRequest {
    name?: string | undefined;
    description?: string | undefined;
}

export interface UpdateClientRequest {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    redirectUrls?: string[] | undefined;
}

export interface UpdateContextEventHandlerRequest {
    name: string;
    description: string;
    tags: string[];
}

export interface UpdateContextScopeModel {
    name: string;
    description: string;
}

export interface UpdateDescriptionModel {
    description: string;
}

export interface UpdateDomainStoryStatementRequest {
    text: string;
    expectedStatementVersion?: number | undefined;
}

export interface UpdateEmbedDefinitionRequest {
    name: string;
    description?: string | undefined;
    appDefinitionId: string;
    allowedViewIds: string[];
    defaultViewId: string;
}

export interface UpdateEnvironmentRequest {
    name?: string | undefined;
    code?: string | undefined;
    order?: number | undefined;
    tags?: string[] | undefined;
    transitions?: EnvironmentTransition[] | undefined;
    metadata?: { [key: string]: any; } | undefined;
}

export interface UpdateFlowInstanceRequest {
    currentActivityId?: string | undefined;
    currentActivityStack?: { [key: string]: any; }[] | undefined;
    timeToLive?: string | undefined;
    attributeKey?: string | undefined;
    attributeValue?: string | undefined;
    value?: string | undefined;
}

export interface UpdateFlowRequest {
    name?: string | undefined;
    definition?: string | undefined;
    tags?: string[] | undefined;
}

export interface UpdateIntegrationEventModel {
    name: string;
    description: string;
    tags: string[];
}

export interface UpdateMetadataModel {
    metadata: string;
}

export interface UpdateObjectNameRequest {
    name?: string | undefined;
    type?: string | undefined;
}

export interface UpdateOperationModel {
    executionType: OperationExecutionTypesModel;
}

export interface UpdatePermissionCommand {
    id: string;
    name?: string | undefined;
    group?: string | undefined;
    description?: string | undefined;
}

export interface UpdatePropertyModel {
    newName: string;
    description: string;
    isRequired: boolean;
    isMultiple: boolean;
    defaultValue: string;
    enumId?: string | undefined;
    enumContextId?: string | undefined;
}

export interface UpdateReactSourceFileRequest {
    content: string;
}

export interface UpdateRoleCommand {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    permissionIds?: string[] | undefined;
}

export interface UpdateServiceConnectionRequest {
    name?: string | undefined;
    isPerEnvironment?: boolean | undefined;
    parameters?: { [key: string]: any; } | undefined;
    environmentParameters?: EnvironmentParametersModel[] | undefined;
    enabledEnvironments?: string[] | undefined;
}

export interface UpdateStringTemplateRequest extends CreateStringTemplateRequest {
    setFolderId?: boolean;
}

export interface UpdateTemplateFolderRequest {
    name: string;
    parentId?: string | undefined;
}

export interface UpdateTenantRequest {
    code: string;
    name?: string | undefined;
    description?: string | undefined;
    isActive: boolean;
}

export interface UpdateTenantUserRequest {
    displayName: string;
    givenName: string;
    surname: string;
}

export interface UpdateUserProfileRequest {
    displayName?: string | undefined;
    givenName?: string | undefined;
    surname?: string | undefined;
}

export interface UpsertCodeGenResourceModel {
    id?: string | undefined;
    name: string;
    description: string;
    mimeType: string;
    content: string;
    scopeType: CodeGenResourceScopeType;
    scopeId?: string | undefined;
    tags: string[];
    isEnabled: boolean;
    isMcpExposed: boolean;
}

export interface UpsertContextServiceConnectionModel {
    serviceConnectionId: string;
    serviceConnectionType: string;
}

export interface UserProfileModel {
    id: string;
    email: string;
    displayName?: string | undefined;
    givenName?: string | undefined;
    surname?: string | undefined;
    tenantId?: string | undefined;
    tenantCode?: string | undefined;
}

export interface UserRoleViewModel {
    id: string;
    name: string;
}

export interface UserViewModel {
    id: string;
    tenant?: TenantViewModel | undefined;
    tenants?: TenantViewModel[] | undefined;
    permissions: string[];
    roles: UserRoleViewModel[];
}

export interface VariableDictionaryKeysMetadata {
    nameRef: string;
    keysFromRef: string;
}

export interface VariableTypeMetadata {
    type?: PrimitiveType | undefined;
    typeRef?: string | undefined;
    typeJsonSchema?: any | undefined;
    typeJsonSchemaSource?: ServiceConnectionPropertySchemaSource | undefined;
    typeWrapInCollection?: boolean | undefined;
    typeUnwrapFromCollection?: boolean | undefined;
    variableSets?: VariableSetMetadata[] | undefined;
}

export interface VariableSetMetadata extends VariableTypeMetadata {
    name?: string | undefined;
    nameRef?: string | undefined;
    order?: number;
    dictionaryKeys?: VariableDictionaryKeysMetadata[] | undefined;
}

export interface VerifyServiceConnectionQueryResult {
    success: boolean;
    errorMessage?: string | undefined;
}

export interface WebsiteOriginsModel {
    defaultOrigins: string[];
    overrideOrigins?: string[] | undefined;
}

export interface WizardStepMetadata {
    key: string;
    order: number;
    title: string;
    description?: string | undefined;
}

export interface Body {
    file?: string | undefined;

    [key: string]: any;
}

export interface Body2 {
    file?: string | undefined;
    conversationId?: string;
    attributes?: string | undefined;

    [key: string]: any;
}

export interface Body3 {
    file?: string | undefined;
    attributes?: string | undefined;

    [key: string]: any;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

/* tslint:disable */
/* eslint-disable */